var type_timer;
var finished_writing_interval = 2000;
var my_input = document.getElementById("input_text");
var fontEmbedCss;
var oldCanvasH;
var oldCanvasW;
var newCanvasH;
var newCanvasW;
var diffper;



let audToUsdRate = 1;
let currencySymbol = 'AUD';

//New functions for US Market
// Function to check if current domain is US (.com)
function isUSMarket() {
  return window.location.hostname.includes("theneonfactory.com") &&
         !window.location.hostname.includes("theneonfactory.com.au");
}

function cmToInchesRounded(cm) {
  if (!isUSMarket()) {
    return cm; // return cm as-is for non-US markets
  }
  let inch = cm * 0.393701;       
  inch = Math.ceil(inch * 2) / 2;
  return inch % 1 === 0 ? inch.toFixed(0) : inch.toFixed(1);
}

function getCartDomain() {
  if (window.location.hostname.includes('theneonfactory.com') && !window.location.hostname.includes('theneonfactory.com.au')) {
    return 'https://theneonfactory.com'; // US market
  } else {
    return 'https://theneonfactory.com.au'; // AU market
  }
}

function initExchangeRate() {
  if (!isUSMarket()) return;
  if (!window.Currency || !Currency.rates) return;

  const activeCurrency = window.ShopifyAnalytics?.meta?.currency;

  if (!activeCurrency) return;
  currencySymbol = activeCurrency;

  if (activeCurrency === 'USD') {
    audToUsdRate = parseFloat(Currency.rates.AUD.toFixed(3));
  }
}

initExchangeRate();

// Convert price using stored rate
function convertPrice(priceAUD) {
  return isUSMarket ? (priceAUD * audToUsdRate).toFixed(0) : priceAUD.toFixed(0);
}

function convertCustomRadioBacking() {
  if (!isUSMarket()) return;
  document.querySelectorAll('input[name="customRadiobacking"]').forEach((input) => {
    const valAUD = parseFloat(input.value);
    if (isNaN(valAUD)) return;

    const valUSD = convertPrice(valAUD);
    input.value = valUSD;
    const label = input.closest(".backing-box");
    if (label) {
      const priceSpan = label.querySelector(".backing-top span:last-child");
      if (priceSpan) {
        priceSpan.textContent = "+$" + valUSD + ' ' + currencySymbol;
      }
    }
  });
}

function updateSelectOptions() {
  var select = document.querySelector('.custom-select-mount select');
  if (!select) return;

  var options = select.querySelectorAll('option');
  for (var i = 0; i < options.length; i++) {
    var option = options[i];

    if (!option.getAttribute('data-original-text')) {
      option.setAttribute('data-original-text', option.textContent);
    }

    if (isUSMarket()) {
      var value = parseFloat(option.value);
      if (isNaN(value) || value === 0) {
        
        option.textContent = option.getAttribute('data-original-text').replace(/\$\d+/, ''); 
      } else {
        
        var priceUSD = convertPrice(value);
        option.value = priceUSD;
        option.textContent = option.getAttribute('data-original-text').replace(/\$\d+/, '$' + priceUSD + ' ' + currencySymbol);
      }
    } else {
      option.textContent = option.getAttribute('data-original-text');
    }
  }
}

// Convert checkbox prices
function convertCheckboxPrices() {
  if (!isUSMarket()) return;

  
  const checkboxes = document.querySelectorAll('.custom-input-checkbox');
  checkboxes.forEach(checkbox => {
    const label = checkbox.closest('label');
    if (!label) return;

    
    if (!label.getAttribute('data-original-text')) {
      label.setAttribute('data-original-text', label.textContent.trim());
      checkbox.setAttribute('data-original-value', checkbox.value);
    }

    let text = label.getAttribute('data-original-text');
    let valueAUD = parseFloat(text.match(/\+\$(\d+(\.\d+)?)/)?.[1]) || 0;

    if (valueAUD === 0) {
      
      label.childNodes[0].nodeValue = text.replace(/\+\$\d+/, '').trim() + ' ';
      checkbox.value = 0;
    } else {
      // Convert to USD
      var priceUSD = convertPrice(valueAUD);
      label.childNodes[0].nodeValue = text.replace(/\+\$\d+/, '+$' + priceUSD + ' ' + currencySymbol) + ' ';
      checkbox.value = priceUSD;
    }
  });
}

function convertBoardImagePrices() {
  if (!isUSMarket()) return;

  const boards = document.querySelectorAll(".bord_img img[data-price]");

  boards.forEach((img) => {
    const audPrice = parseFloat(img.getAttribute("data-price") || 0);
    if (isNaN(audPrice) || audPrice === 0) return;

    // Convert to USD
    const usdPrice = convertPrice(audPrice);

    // Update data-price
    img.setAttribute("data-price", usdPrice);

    // Update 'name' attribute
    const originalName = img.getAttribute("name") || "";
    const updatedName = originalName.replace(/\+\$\d+/, '+$' + usdPrice + ' ' + currencySymbol);
    img.setAttribute("name", updatedName);
  });
}

convertCheckboxPrices();

updateSelectOptions();

convertBoardImagePrices();
convertCustomRadioBacking();

function addContentToCanvas() {
  // Get the input field and canvas elements
  var inputField = document.getElementById("input_text");
  var canvas = document.getElementById("img-canvas");

  var textlength = $("#input_text").val().split("\n");
  // console.log(textlength);
  var tempHeight;

  // Height
  //
  var ctx = canvas.getContext("2d");
  var font = $(".text_show").css("font-family");
  var fontsize = $(".text_show").css("font-size");
  let maxtempW = $.map(textlength, function (i, index) {
    // Get the canvas context

    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Set the font and other styles
    ctx.font = fontsize + " " + font;
    ctx.fillStyle = "black";

    // Get the input field value
    var content = textlength;

    // Add the content to the canvas
    ctx.fillText(content, 10, 50);

    // Get the pixel data of the canvas
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var data = imageData.data;

    var getRBG = function (x, y) {
        var offset = canvas.width * y + x;
        return {
          red: data[offset * 4],
          green: data[offset * 4 + 1],
          blue: data[offset * 4 + 2],
          opacity: data[offset * 4 + 3],
        };
      },
      isWhite = function (rgb) {
        // many images contain noise, as the white is not a pure #fff white
        return rgb.red > 200 && rgb.green > 200 && rgb.blue > 200;
      },
      scanY = function (fromTop) {
        var offset = fromTop ? 1 : -1;

        // loop through each row
        for (
          var y = fromTop ? 0 : canvas.height - 1;
          fromTop ? y < canvas.height : y > -1;
          y += offset
        ) {
          // loop through each column
          for (var x = 0; x < canvas.width; x++) {
            var rgb = getRBG(x, y);
            if (!isWhite(rgb)) {
              if (fromTop) {
                return y;
              } else {
                return Math.min(y + 1, canvas.height);
              }
            }
          }
        }
        return null; // all image is white
      },
      scanX = function (fromLeft) {
        var offset = fromLeft ? 1 : -1;

        // loop through each column
        for (
          var x = fromLeft ? 0 : canvas.width - 1;
          fromLeft ? x < canvas.width : x > -1;
          x += offset
        ) {
          // loop through each row
          for (var y = 0; y < canvas.height; y++) {
            var rgb = getRBG(x, y);
            if (!isWhite(rgb)) {
              if (fromLeft) {
                return x;
              } else {
                return Math.min(x + 1, canvas.width);
              }
            }
          }
        }
        return null; // all image is white
      };

    var cropTop = scanY(true),
      cropBottom = scanY(false),
      cropLeft = scanX(true),
      cropRight = scanX(false),
      cropWidth = cropRight - cropLeft,
      cropHeight = cropBottom - cropTop;

    canvas.setAttribute("width", cropWidth);
    canvas.setAttribute("height", cropHeight);
    console.log(cropWidth);
    console.log(cropHeight);
    // finally crop the guy
    // canvas
    //   .getContext("2d")
    //   .drawImage(
    //     imageObject,
    //     cropLeft,
    //     cropTop,
    //     cropWidth,
    //     cropHeight,
    //     0,
    //     0,
    //     cropWidth,
    //     cropHeight
    //   );
    console.log("CH" + canvas.height);
    console.log("CW" + canvas.width);
    updateline();
    return canvas.width;
  });
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  var maxtempwidth = Math.max.apply(this, maxtempW);
  console.log(maxtempwidth + "MAXMAXMAX");
  newCanvasW = maxtempwidth;
}

if (window.location.pathname == "/pages/custom-neon-signs") {
  my_input.addEventListener("keyup", function () {
    clearTimeout(type_timer);
    type_timer = setTimeout(finished_typing, finished_writing_interval);
  });

  my_input.addEventListener("keydown", function () {
    clearTimeout(type_timer);
  });
}

function finished_typing() {
  // console.log("User finished typing");
  saveValueImg();
}

function stripfloat(number) {
  return Number(parseFloat(number).toPrecision(3));
}
function escapeHtml(unsafe) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function getFontSize() {
  var selectedFont = $(".font_style li.active").attr("data-font");
  var selectedFontFamily = $(".font_style li.active")
    .attr("data-fonttype")
    .toLowerCase();
  var selectedSize = $("#size_table .size-box.active").attr("data-size");
  var inputText = $("#input_text").val();
  var signHeight = 0;

  var fontwidthnew = {
    simple: {
      xs: 8,
      s: 9,
      m: 12,
      l: 15,
      xl: 20,
      super: 24,
      xxxl:27,
      newsuper:33,
      megasuper:40,
    },
    fancy: {
      xs: 10,
      s: 12,
      m: 16,
      l: 20,
      xl: 27,
      super: 30,
      xxxl:36,
      newsuper: 40,
      megasuper: 45,
    },
    doubleline: {
      m: 20,
      l: 26,
      xl: 34,
      super: 40,
      xxxl:46,
      newsuper: 50,
      megasuper: 55,
    },
  };

  // switch(selectedFontFamily){
  //   case "simple":
  //     var heightMulti = fontwidthnew[selectedFontFamily][selectedSize] / 8;
  //     break;
  //   case "fancy":
  //     var heightMulti = fontwidthnew[selectedFontFamily][selectedSize] / 10;
  //     break;
  //   case "doubleline":
  //     var heightMulti = fontwidthnew[selectedFontFamily][selectedSize] / 20;
  //     break;
  // }
  // var heightMulti = 1;
  var heightMulti = fontwidthnew[selectedFontFamily][selectedSize];

  var fontnames = [
    "AustinCapittal",
    "JackArmstrong",
    "AmsterdamGraffiti",
    "Breamcatcher",
    "Elegant",
    "Samantha",
    "AvalonChaligraphy",
    "PaperFlowers",
    "Retrolight",
    "Technology",
    "BombFont",
    "FancyMatter",
    "ChildHappy",
    "Blinkest",
    "Walkway",
    "DolceVita",
    "LettersForLearners",
    "Beautica",
    "RoselinaEllis",
    "ModernSansLight",
    "GreatDay",
    "Southland",
    "PrettyGirlScript",
    "Spaceship2100",
    "JulyIt",
    "RMPlaytime",
    "Bearline",
    "Minimal",
    "Academy",
    "AniTypewriter",
  ];

  var textlength = $("#input_text").val().split("\n");
  // console.log(textlength);
  var tempHeight;

  // Height
  //

  var signHeight = [];
  let maxHeight = $.map(textlength, function (i, index) {
    inputText = i;
    inputText = inputText.replace(/\s/g, "");
    if (inputText == "") {
      signHeight.push(0);
      // console.log("Pushed 0");
      var maxtempheight = Math.max.apply(this, signHeight);
      maxtempheight = maxtempheight;
      tempHeight = maxtempheight;
      return stripfloat(maxtempheight);
    }

    if (((inputText || "").match(/^(?![\s\S])/g) || []).length > 0) {
      signHeight.push(0);
      // console.log("Pushed 0");
      var maxtempheight = Math.max.apply(this, signHeight);
      maxtempheight = maxtempheight;
      tempHeight = maxtempheight;
      return stripfloat(maxtempheight);
    }
    switch (selectedFont) {
      case "Academy":
        if ((inputText || "").match(/[^a-zA-Z0-9\s,;:!?]/gm)) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(/[^a-zA-Z0-9\s,;:!?]/gm, "");
          $("#input_text").val(escapeHtml(newtext));
          // setNewPrice();
        }

        if (((inputText || "").match(/([^qQ0-9])/g) || []).length > 0) {
          var lettercountfont = inputText.match(/([^qQ0-9])/g).length;
          signHeight.push(stripfloat(8));
        }

        if (((inputText || "").match(/[02-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(8));
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          signHeight.push(stripfloat(8));
        }

        if (((inputText || "").match(/[qQ]/g) || []).length > 0) {
          signHeight.push(stripfloat(8.7));
        }

        if (((inputText || "").match(/[\,]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.043 * 0.55));
        }
        if (((inputText || "").match(/[\:\?\!]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.043 * 1.32));
        }
        if (((inputText || "").match(/[\.]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.043 * 0.7));
        }
        if (((inputText || "").match(/[\;]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.043 * 1.51));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "AmsterdamGraffiti":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s#@$*%&_^~\/=?+\\{}<>\-"()',;:!|\]\[`.]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s#@$*%&_^~\/=?+\\{}<>\-"()',;:!|\]\[`.]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          // setNewPrice();
        }
        if (((inputText || "").match(/[ABEGHOSUVY]/gi) || []).length > 0) {
          signHeight.push(stripfloat(6.65 * 1.036));
        }
        if (((inputText || "").match(/[CDJKLMPQRTZ]/gi) || []).length > 0) {
          signHeight.push(stripfloat(6.65 * 0.97));
        }
        if (((inputText || "").match(/[FINWX]/gi) || []).length > 0) {
          signHeight.push(stripfloat(6.65 * 0.82));
        }
        if (((inputText || "").match(/[13567]/gi) || []).length > 0) {
          signHeight.push(stripfloat(7.1 * 1.02));
        }
        if (((inputText || "").match(/[04]/gi) || []).length > 0) {
          signHeight.push(stripfloat(7.1 * 1.12));
        }
        if (((inputText || "").match(/[289]/gi) || []).length > 0) {
          signHeight.push(stripfloat(7.1 * 0.91));
        }

        if (
          ((inputText || "").match(/[$@\&\(\)\?\\\{\}\[\]]/g) || []).length > 0
        ) {
          signHeight.push(stripfloat(5.565 * 1.36));
        }
        if (((inputText || "").match(/[\*%#\!\|\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.565 * 1.16));
        }
        if (((inputText || "").match(/[\/\:\;\^]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.565 * 1));
        }
        if (((inputText || "").match(/[\~\+]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.565 * 0.8));
        }
        if (((inputText || "").match(/[\.\=]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.565 * 0.68));
        }
        if (((inputText || "").match(/[-\"\'_\,\.\`]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.565 * 0.44));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "AniTypewriter":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s£&€¥%#@_$=?/\<>~+^*\/(){}[\]`\-":!';,|\\]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s£&€¥%#@_$=?/\<>~+^*\/(){}[\]`\-":!';,|\\]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.769 * 1.4));
        }
        if (((inputText || "").match(/[bglpqty]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.769 * 1.12));
        }
        if (((inputText || "").match(/[dfhkimnorsuvwxz]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.769 * 0.95));
        }
        if (((inputText || "").match(/[ace]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.769 * 0.78));
        }
        if (((inputText || "").match(/[QR]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.319 * 1.18));
        }
        if (((inputText || "").match(/[A-EI-MOPSTUW-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.319 * 1.02));
        }
        if (((inputText || "").match(/[FGHNV]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.319 * 0.93));
        }
        if (((inputText || "").match(/[017]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.5));
        }
        if (((inputText || "").match(/[2345689]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4));
        }

        if (((inputText || "").match(/[\(\)\|]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 1.162));
        }
        if (((inputText || "").match(/[\{\}\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 1.515));
        }
        if (((inputText || "").match(/[€£\/\?\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 1.36));
        }
        if (((inputText || "").match(/[\%\!]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 1.301));
        }
        if (((inputText || "").match(/[¥\#\@\&\;]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 1.107));
        }
        if (((inputText || "").match(/[\+\:\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 0.835));
        }
        if (((inputText || "").match(/[\*]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 0.719));
        }
        if (((inputText || "").match(/[\^]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 0.641));
        }
        if (((inputText || "").match(/[\=\']/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 0.524));
        }
        if (((inputText || "").match(/[\"\,]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 0.447));
        }
        if (((inputText || "").match(/[\~`]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 0.33));
        }
        if (((inputText || "").match(/[-\_\.]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 0.136));
        }

        if (((inputText || "").match(/[$]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.149 * 1.515));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "AustinCapittal":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s@#&_$%()\\?\/!^*\-+={}[\];<>|"':]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@#&_$%()\\?\/!^*\-+={}[\];<>|"':]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[aceimnruvwxz]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.065 * 0.68));
        }
        if (((inputText || "").match(/[dfklt]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.065 * 1.86));
        }
        if (((inputText || "").match(/[bh]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.065 * 1.4));
        }
        if (((inputText || "").match(/[pqs]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.065 * 0.93));
        }

        if (((inputText || "").match(/[g]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.065 * 1.18));
        }

        if (((inputText || "").match(/[yj]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.065 * 1.204));
        }
        if (((inputText || "").match(/[A-HJKLN-QT-Y]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.8 * 1.03));
        }
        if (((inputText || "").match(/[IMRSZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.769 * 0.96));
        }

        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.5));
        }

        //punctuation
        if (((inputText || "").match(/[\$\\\?\/]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.671 * 1.615));
        }
        if (
          ((inputText || "").match(/[\!\@\#\%\&\(\)\{\}\[\]\|]/g) || [])
            .length > 0
        ) {
          signHeight.push(stripfloat(1.671 * 1.376));
        }
        if (((inputText || "").match(/[\^\*\+\;\"\:\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.671 * 0.419));
        }
        if (((inputText || "").match(/[-\_\=\']/g) || []).length > 0) {
          signHeight.push(stripfloat(1.671 * 0.179));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "AvalonChaligraphy":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s%@&_\/$=#?\{}<>[\]\\\-*()^!|"+',;:`~]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s%@&_\/$=#?\{}<>[\]\\\-*()^!|"+',;:`~]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[bdfghjklpqtyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.273 * 1.44));
        }
        if (((inputText || "").match(/[aceimnorsuvwx]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.273 * 0.52));
        }

        if (((inputText || "").match(/[A-FH-MPR-X]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.558 * 1));
        }

        if (((inputText || "").match(/[GNOQYU]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.558 * 1.2));
        }
        if (((inputText || "").match(/[Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.558 * 0.88));
        }
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.45));
        }

        if (((inputText || "").match(/[\?\{\}\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.519 * 1.588));
        }
        if (((inputText || "").match(/[\/\%\&\(\)\|\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.519 * 1.469));
        }
        if (((inputText || "").match(/[$\+\#\@\!]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.519 * 1.31));
        }
        if (((inputText || "").match(/[\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.519 * 0.913));
        }
        if (((inputText || "").match(/[\*\=\;\:\^]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.519 * 0.675));
        }
        if (((inputText || "").match(/[-\"\'\_\.\,\`\~]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.519 * 0.278));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Bearline":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s#@¥€\/%&\$£?¢+=_{}\-*()<>"'[\],;:÷!|\\]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s#@¥€\/%&\$£?¢+=_{}\-*()<>"'[\],;:÷!|\\]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[b]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.796 * 1.73));
        }
        if (((inputText || "").match(/[dfghjklpqtyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.796 * 1.27));
        }
        if (((inputText || "").match(/[aceimnoruvwx]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.796 * 0.63));
        }

        if (((inputText || "").match(/[s]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.796 * 0.896));
        }

        if (((inputText || "").match(/[0-35-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.3));
        }
        if (((inputText || "").match(/[4]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8));
        }
        if (((inputText || "").match(/[Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.015 * 1.33));
        }
        if (((inputText || "").match(/[BCDGHJMNOQSTY]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.015 * 1.09));
        }
        if (((inputText || "").match(/[AEFIKLPRUVWX]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.015 * 0.89));
        }

        if (((inputText || "").match(/[\{\}]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 1.711));
        }
        if (((inputText || "").match(/[\|\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 1.573));
        }
        if (((inputText || "").match(/[$\/\&\?\!\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 1.463));
        }
        if (((inputText || "").match(/[€£¥]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 1.297));
        }
        if (((inputText || "").match(/[\%\#\@]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 1.187));
        }
        if (((inputText || "").match(/[¢]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 1.021));
        }
        if (((inputText || "").match(/[\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 0.911));
        }
        if (((inputText || "").match(/[\+]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 0.607));
        }
        if (((inputText || "").match(/[\*\;\:]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 0.469));
        }
        if (((inputText || "").match(/[\÷\=]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 0.359));
        }
        if (((inputText || "").match(/[\"\'\,]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 0.193));
        }
        if (((inputText || "").match(/[-\_\.]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.624 * 0.083));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Beautica":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s\/\&$£€¥%?¿{}[\]#@()!¡¢_+\-*÷=":<>;',|]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s\/\&$£€¥%?¿{}[\]#@()!¡¢_+\-*÷=":<>;',|]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[bdfghjkpqy]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.492 * 1.47));
        }
        if (((inputText || "").match(/[almnrtz]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.492 * 0.87));
        }
        if (((inputText || "").match(/[ceiosuvwx]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.492 * 0.33));
        }
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.6));
        }
        if (((inputText || "").match(/[PQRS]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.315 * 1.23));
        }
        if (((inputText || "").match(/[A-NRTWXZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.315 * 1.05));
        }
        if (((inputText || "").match(/[OUVY ]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.315 * 0.75));
        }

        if (((inputText || "").match(/[\/\\|]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 2.211));
        }
        if (((inputText || "").match(/[$&(){}\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 1.697));
        }
        if (((inputText || "").match(/[¥£]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 1.389));
        }
        if (((inputText || "").match(/[€#?!¿¡]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 1.183));
        }
        if (((inputText || "").match(/[¢@]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 0.874));
        }
        if (((inputText || "").match(/[<>]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 0.699));
        }
        if (((inputText || "").match(/[+*÷";:]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 0.36));
        }
        if (((inputText || "").match(/[-=%'_.,]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.9444 * 0.154));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Blinkest":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s\@$£\/%#&?()|{}[\]€!¥_¢+\-=<>*÷;:^~"',\\`]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@$£\/%#&?()|{}[\]€!¥_¢+\-=<>*÷;:^~"',\\`]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-EILMO-RT-VX-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.5));
        }
        if (((inputText || "").match(/[GJKNSW]/g) || []).length > 0) {
          signHeight.push(stripfloat(8));
        }
        if (((inputText || "").match(/[FH]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.2));
        }
        if (((inputText || "").match(/[0-68]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.9));
        }
        if (((inputText || "").match(/[7]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4));
        }
        if (((inputText || "").match(/[9]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.7));
        }
        if (((inputText || "").match(/[bdfghjlpt]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.476 * 1.58));
        }
        if (((inputText || "").match(/[kqy]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.476 * 1.29));
        }
        if (((inputText || "").match(/[z]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.476 * 1));
        }
        if (((inputText || "").match(/[ewx]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.476 * 0.71));
        }
        if (((inputText || "").match(/[acimnorsuv]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.476 * 0.43));
        }

        if (((inputText || "").match(/[()|{}\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 1.854));
        }
        if (((inputText || "").match(/[\/]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 1.725));
        }
        if (((inputText || "").match(/[$£%&?!\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 1.622));
        }
        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 1.365));
        }
        if (((inputText || "").match(/[€]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 1.21));
        }
        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 1.107));
        }
        if (((inputText || "").match(/[¢+]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 0.695));
        }
        if (((inputText || "").match(/[-<>]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 0.592));
        }
        if (((inputText || "").match(/[÷=;:*^]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 0.335));
        }
        if (((inputText || "").match(/["'_.,`]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8838 * 0.18));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "BombFont":
        if ((inputText || "").match(/[^a-zA-Z0-9\s`;',.!@#$&*():"?]/gm)) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s`;',.!@#$&*():"?]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[I]/gi) || []).length > 0) {
          signHeight.push(stripfloat(6.423 * 1.13));
        }
        if (
          ((inputText || "").match(/[ABFGLMNOQRT-WYZ0-9?$!;@#:]/gi) || [])
            .length > 0
        ) {
          signHeight.push(stripfloat(6.423 * 1.01));
        }
        if (((inputText || "").match(/[CDEHSPXKJ()&]/gi) || []).length > 0) {
          signHeight.push(stripfloat(6.9));
        }

        if (((inputText || "").match(/[`.,*"']/gi) || []).length > 0) {
          signHeight.push(stripfloat(6.423 * 0.5));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "DolceVita":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s@#€€¢%¥&\/$£\\<>?\-=_~+*"()^[\]';:,!`]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@#€€¢%¥&\/$£\\<>?\-=_~+*"()^[\]';:,!`]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-Z0-9]/gi) || []).length > 0) {
          signHeight.push(stripfloat(8.7));
        }

        if (((inputText || "").match(/[\[\]]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 1.702));
        }
        if (
          ((inputText || "").match(/[€£¥¢$\/%@&()?!\\]/gi) || []).length > 0
        ) {
          signHeight.push(stripfloat(5.8758 * 1.566));
        }
        if (((inputText || "").match(/[#]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 1.481));
        }
        if (((inputText || "").match(/[;:]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 0.919));
        }
        if (((inputText || "").match(/[<>]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 0.732));
        }
        if (((inputText || "").match(/[+*]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 0.477));
        }
        if (((inputText || "").match(/[=]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 0.391));
        }
        if (((inputText || "").match(/[`^]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 0.289));
        }
        if (((inputText || "").match(/["']/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 0.221));
        }
        if (((inputText || "").match(/[-_.,~]/gi) || []).length > 0) {
          signHeight.push(stripfloat(5.8758 * 0.136));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Elegant":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s#@[\]$[<>{\/%()}+\-=_?\\&!~|*"^',;:`]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s#@[\]$[<>{\/%()}+\-=_?\\&!~|*"^',;:`]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-Z0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.1));
        }
        if (((inputText || "").match(/[bdfghjklpqtyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.026 * 1.36));
        }
        if (((inputText || "").match(/[s]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.026 * 0.86));
        }
        if (((inputText || "").match(/[aceimnoruvwx]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.026 * 0.62));
        }

        if (((inputText || "").match(/[\(\)\[\]|]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 1.943));
        }
        if (((inputText || "").match(/[\$\/\{}]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 1.785));
        }
        if (((inputText || "").match(/[#\@\!\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 1.654));
        }
        if (((inputText || "").match(/[\?]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 1.496));
        }
        if (((inputText || "").match(/[\%]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 1.391));
        }
        if (((inputText || "").match(/[\&]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 1.129));
        }
        if (((inputText || "").match(/[\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 0.866));
        }
        if (((inputText || "").match(/[\+\:\;]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 0.709));
        }
        if (((inputText || "").match(/[\*\=\"\'\^]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 0.341));
        }
        if (((inputText || "").match(/[\.\,\`\~]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.809 * 0.184));
        }
        if (((inputText || "").match(/[\_\-]/g) || []).length > 0) {
          signHeight.push(stripfloat(0.5));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Technology":
        if ((inputText || "").match(/[^a-zA-Z0-9\s$?\----"[\];,:!]/gm)) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s$?\----"[\];,:!]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-Z0-9]/gi) || []).length > 0) {
          signHeight.push(stripfloat(9));
        }
        if (((inputText || "").match(/[[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 1.854));
        }
        if (((inputText || "").match(/[$]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 1.745));
        }
        if (((inputText || "").match(/[?!]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 1.449));
        }
        if (((inputText || "").match(/[;]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 0.888));
        }
        if (((inputText || "").match(/[:]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 0.717));
        }
        if (((inputText || "").match(/[".]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 0.327));
        }
        if (((inputText || "").match(/[.]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 0.234));
        }
        if (((inputText || "").match(/[-]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4182 * 0.156));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "GreatDay":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s|':;"\-*!^&+={}\\<>/?_()@#$%[\]]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s|':;"\-*!^&+={}\\<>/?_()@#$%[\]]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[GY]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.884 * 1.16));
        }
        if (((inputText || "").match(/[BCDIJKMNPQ]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.884 * 1.08));
        }
        if (((inputText || "").match(/[AEFHOR-XZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.884 * 0.94));
        }
        if (((inputText || "").match(/[L]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.884 * 0.82));
        }
        if (((inputText || "").match(/[f]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.234 * 1.91));
        }
        if (((inputText || "").match(/[bdghjklqty]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.234 * 1.39));
        }
        if (((inputText || "").match(/[ipz]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.234 * 1.08));
        }
        if (((inputText || "").match(/[acemou-x]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.234 * 0.77));
        }
        if (((inputText || "").match(/[nrs]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.234 * 0.46));
        }

        if (((inputText || "").match(/[0-3]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.88 * 0.9));
        }

        if (((inputText || "").match(/[4-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.88 * 1.06));
        }

        if (((inputText || "").match(/["'_=*-]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.161 * 0.32));
        }

        if (((inputText || "").match(/[<>+&]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.161 * 0.6));
        }

        if (((inputText || "").match(/[;?]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.161 * 0.81));
        }

        if (((inputText || "").match(/[\/\\#@!^]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.161 * 1));
          // console.log('Great Day Height');
          // console.log(signHeight[index]);
        }

        if (((inputText || "").match(/[|{}[\]()%]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.161 * 1.67));
        }
        if (((inputText || "").match(/[$]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.161 * 1.99));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "JulyIt":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s¥<>@?$\/&()\\€%#_[\]¢+\-*÷=!¡,:^"';|`]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s¥<>@?$\/&()\\€%#_[\]¢+\-*÷=!¡,:^"';|`]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[ADF-KTY]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.869 * 1.09));
        }
        if (((inputText || "").match(/[BCEL-SU-XZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.869 * 0.94));
        }
        if (((inputText || "").match(/[f]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.138 * 2.07));
        }
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.138 * 1.75));
        }
        if (((inputText || "").match(/[bdghklpqtyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.138 * 1.43));
        }
        if (((inputText || "").match(/[aceimnorsuvwx]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.138 * 0.47));
        }
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.3));
        }
        if (((inputText || "").match(/[¥¥]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 2.776));
        }
        if (((inputText || "").match(/[?]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 1.787));
        }
        if (((inputText || "").match(/[$!¡[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 1.635));
        }
        if (((inputText || "").match(/[¢€&()]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 1.407));
        }
        if (((inputText || "").match(/[\/%\\|]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 1.255));
        }
        if (((inputText || "").match(/[@<>]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 1.027));
        }
        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 0.875));
        }
        if (((inputText || "").match(/[+*;]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 0.647));
        }
        if (((inputText || "").match(/[=÷,:^]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 0.494));
        }
        if (((inputText || "").match(/["'_.`-]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.6294 * 0.266));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "LettersForLearners":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s@%#€£¥&~$¢+÷?{}<>\-*\/_()\[\]";,`':!|]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@%#€£¥&~$¢+÷?{}<>\-*\/_()\[\]";,`':!|]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-PR-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.5));
        }
        if (((inputText || "").match(/[Q]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.9));
        }
        if (((inputText || "").match(/[bdfghjklpqy]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.065 * 1.28));
        }
        if (((inputText || "").match(/[it]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.065 * 1.08));
        }
        if (((inputText || "").match(/[acemn]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.065 * 0.88));
        }
        if (((inputText || "").match(/[orsuvwxz]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.065 * 0.69));
        }
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.9));
        }
        if (((inputText || "").match(/[()]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 1.818));
        }
        if (((inputText || "").match(/[%{}[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 1.45));
        }
        if (((inputText || "").match(/[$¢€£¥\/@?!\\|]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 1.364));
        }
        if (((inputText || "").match(/[&]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 1.234));
        }
        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 1.147));
        }
        if (((inputText || "").match(/[<>]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 0.801));
        }
        if (((inputText || "").match(/[+;]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 0.714));
        }
        if (((inputText || "").match(/[*"']/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 0.584));
        }
        if (((inputText || "").match(/[=÷,]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 0.498));
        }
        if (((inputText || "").match(/[~]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 0.368));
        }
        if (((inputText || "").match(/[`-]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 0.281));
        }
        if (((inputText || "").match(/[_.]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6194 * 0.152));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Minimal":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s@#$$_?+\-\/=÷\\<>*^";{}[\]`'(),:!|]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@#$$_?+\-\/=÷\\<>*^";{}[\]`'(),:!|]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[Q]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.876 * 1.33));
        }
        if (((inputText || "").match(/[A-PR-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.876 * 0.99));
        }
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.976 * 1.4));
        }
        if (((inputText || "").match(/[bdfghklpqty]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.976 * 1.22));
        }
        if (((inputText || "").match(/[aceimnorsu-xz]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.976 * 0.78));
        }
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.2));
        }
        if (((inputText || "").match(/[@()|]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 1.954));
        }
        if (((inputText || "").match(/[${}]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 1.876));
        }
        if (((inputText || "").match(/[[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 1.774));
        }
        if (((inputText || "").match(/[?!\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 1.594));
        }
        if (((inputText || "").match(/[\/#]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 1.234));
        }
        if (((inputText || "").match(/[;~]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 0.951));
        }
        if (((inputText || "").match(/[:]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 0.694));
        }
        if (((inputText || "").match(/[+÷<>]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 0.591));
        }
        if (((inputText || "").match(/[*=]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 0.437));
        }
        if (((inputText || "").match(/[",`]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 0.334));
        }
        if (((inputText || "").match(/['_.^~-]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.8903 * 0.179));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      //Height
      case "ModernSansLight":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s@%&$¥#_=<>*¢÷^~+?\-\\\/"{}()[\]`,;'!|:]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@%&$¥#_=<>*¢÷^~+?\-\\\/"{}()[\]`,;'!|:]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.9));
        }

        //small

        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.814 * 1.426));
        }
        if (((inputText || "").match(/[bdf-hklpqty]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.814 * 1.134));
        }
        if (((inputText || "").match(/[acemnorsu-xz]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.814 * 0.791));
        }

        if (((inputText || "").match(/[i]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.814 * 1.134));
        }

        //number
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.6));
        }

        //punctuations
        if (((inputText || "").match(/[_\.]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 0.11));
        }
        if (((inputText || "").match(/[~`]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 0.28));
        }
        if (((inputText || "").match(/["'\,]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 0.36));
        }
        if (((inputText || "").match(/[÷=:^]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 0.58));
        }
        if (((inputText || "").match(/[<>\+]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 0.69));
        }
        if (((inputText || "").match(/[-\*]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 0.78));
        }
        if (((inputText || "").match(/[¢;]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 0.97));
        }
        if (((inputText || "").match(/[¥\/%#&!\\?]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 1.27));
        }
        if (((inputText || "").match(/[$\|]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 1.52));
        }
        if (((inputText || "").match(/[\[\]\{\}\(\)]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.512 * 1.65));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "PaperFlowers":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s:;|'!"(),[\]{}<>\-*\/\\¢¥&+=#_?€£%@]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s:;|'!"(),[\]{}<>\-*\/\\¢¥&+=#_?€£%@]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-PR-Z]/gi) || []).length > 0) {
          signHeight.push(stripfloat(7.9));
        }
        if (((inputText || "").match(/[Q]/gi) || []).length > 0) {
          signHeight.push(stripfloat(7.9 * 1.101));
        }

        //small none

        //number
        if (((inputText || "").match(/[0-9]/gi) || []).length > 0) {
          signHeight.push(stripfloat(7.9));
        }

        //punctuations
        if (((inputText || "").match(/[\-]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.33 * 0.09));
        }
        if (((inputText || "").match(/[_'"\.`~]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.33 * 0.2));
        }
        if (((inputText || "").match(/[\,]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.33 * 0.25));
        }
        if (((inputText || "").match(/[\*\=^]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.33 * 0.33));
        }
        if (((inputText || "").match(/[\÷\+\:\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.33 * 0.71));
        }
        if (((inputText || "").match(/[\;¢]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.33 * 0.83));
        }
        if (
          ((inputText || "").match(/[€£¥\/\@&\(\)!\\\|\{\}\[\]?]/g) || [])
            .length > 0
        ) {
          signHeight.push(stripfloat(6.33 * 1.28));
        }
        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.33 * 1.12));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "PrettyGirlScript":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s:!|'`<>;,{}"*+$=-[\]^£\/%#()?\\~€_@&]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s:!|'`<>;,{}"*+$=-[\]^£\/%#()?\\~€_@&]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[G]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.785 * 1.538));
        }
        if (((inputText || "").match(/[JPQY]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.785 * 1.469));
        }
        if (((inputText || "").match(/[A-EFHIK-NRSTZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.785 * 0.915));
        }
        if (((inputText || "").match(/[OUVWX]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.785 * 0.828));
        }

        //small

        if (((inputText || "").match(/[f]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 1.816));
        }
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 1.668));
        }
        if (((inputText || "").match(/[gp]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 1.478));
        }
        if (((inputText || "").match(/[qy]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 1.436));
        }
        if (((inputText || "").match(/[bd]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 1.035));
        }
        if (((inputText || "").match(/[irw]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 0.929));
        }
        if (((inputText || "").match(/[hklt]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 1.056));
        }
        if (((inputText || "").match(/[v]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 0.802));
        }
        if (((inputText || "").match(/[aceosux]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 0.739));
        }
        if (((inputText || "").match(/[mn]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 0.613));
        }

        if (((inputText || "").match(/[z]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.735 * 0.739));
        }

        //number
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6));
        }

        //punctuations
        if (((inputText || "").match(/[\_\.\`-]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 0.24));
        }
        if (((inputText || "").match(/[\,\+\=\^\~]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 0.44));
        }
        if (((inputText || "").match(/[\*"'\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 0.52));
        }
        if (((inputText || "").match(/[#:]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 0.82));
        }
        if (((inputText || "").match(/[;]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 1.13));
        }
        if (((inputText || "").match(/[\/\!\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 1.36));
        }
        if (((inputText || "").match(/[$€£@\&\?]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 1.49));
        }
        if (((inputText || "").match(/[\(\)\|\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 1.71));
        }
        if (((inputText || "").match(/[\{\}]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.094 * 1.84));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "RMPlaytime":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s!|`;:,'$*=+"?{}[\]\-()^€£¥\\~\/_<>&%@]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s!|`;:,'$*=+"?{}[\]\-()^€£¥\\~\/_<>&%@]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4));
        }

        //small

        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.739 * 1.377));
        }
        if (((inputText || "").match(/[gpqy]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.739 * 1.185));
        }
        if (((inputText || "").match(/[bdfhiklt]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.739 * 1.08));
        }
        if (((inputText || "").match(/[acemnorsuvwxz]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.739 * 0.871));
        }

        //number

        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.5));
        }

        //punctuations
        if (((inputText || "").match(/[\%]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.166 * 0.12));
        }
        if (((inputText || "").match(/[-_\.\`\~\^]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.166 * 0.29));
        }
        if (((inputText || "").match(/[\"\'\,]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.166 * 0.47));
        }
        if (((inputText || "").match(/[\*\+\=]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.166 * 0.68));
        }
        if (((inputText || "").match(/[\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.166 * 0.93));
        }
        if (((inputText || "").match(/[\#\:]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.166 * 1.01));
        }
        if (
          ((inputText || "").match(/[€£¥\/\@\&\;\?\!\\\|]/g) || []).length > 0
        ) {
          signHeight.push(stripfloat(5.166 * 1.22));
        }
        if (((inputText || "").match(/[\[\]\{\}\(\)]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.166 * 1.74));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "RoselinaEllis":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s!`^*,"'+:;~÷=\-$¢€£¥#_()!|{}<>[\]#\/%\\?@&]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s`^*,"'+:;~÷=\-$¢€£¥#_()!|{}<>[\]#\/%\\?@&]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[GHJNRZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.96 * 1.081));
        }
        if (((inputText || "").match(/[LMVWY]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.96 * 1.03));
        }
        if (((inputText || "").match(/[ISTUX]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.96 * 0.997));
        }
        if (((inputText || "").match(/[A-FKOPQ]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.96 * 0.942));
        }

        //small

        if (((inputText || "").match(/[jt]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.727 * 1.76));
        }
        if (((inputText || "").match(/[l]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.727 * 1.467));
        }
        if (((inputText || "").match(/[fgpqsyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.727 * 1.357));
        }
        if (((inputText || "").match(/[bdhk]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.727 * 1.173));
        }
        if (((inputText || "").match(/[inx]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.727 * 0.77));
        }
        if (((inputText || "").match(/[aceoruvwx]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.727 * 0.477));
        }

        if (((inputText || "").match(/[m]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.727 * 0.587));
        }

        //number

        if (((inputText || "").match(/[38]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.37 * 1.098));
        }
        if (((inputText || "").match(/[0124-79]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.37 * 1.009));
        }

        //punctuations
        if (
          ((inputText || "").match(/[~^`\,\._\"\'\*-\+]/g) || []).length > 0
        ) {
          signHeight.push(stripfloat(2.716 * 0.29));
        }
        if (((inputText || "").match(/[\:\;]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.716 * 0.59));
        }
        if (((inputText || "").match(/[$¢€£¥\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.716 * 1.03));
        }
        if (((inputText || "").match(/[\\\/\%]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.716 * 1.53));
        }
        if (
          ((inputText || "").match(/[\@\&\(\)\!\\\|\{\}\[\]?]/g) || []).length >
          0
        ) {
          signHeight.push(stripfloat(2.716 * 1.76));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      //Height
      case "Walkway":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s$=€&÷_~¢+#?\\<>"*^()|:{}`,;[\]%@¥]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s$=€&÷_~¢+#?\\<>"*^()|:{}`,;[\]%@¥]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        // uppercase
        if (((inputText || "").match(/[Q]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.2 * 1.042));
        }
        if (((inputText || "").match(/[A-PR-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.2 * 1));
        }
        // lowercase
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.3962 * 1.407));
        }
        if (((inputText || "").match(/[f-ikly]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.3962 * 1.126));
        }
        if (((inputText || "").match(/[t]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.3962 * 0.985));
        }
        if (((inputText || "").match(/[acemnorsu-xz]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.3962 * 0.844));
        }

        if (((inputText || "").match(/[bdpq]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.3962 * 1.188));
        }

        //numbers
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.2 * 1));
        }
        //punctuations
        if (((inputText || "").match(/[._-]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 0.14));
        }
        if (((inputText || "").match(/[~`,"'=]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 0.28));
        }
        if (((inputText || "").match(/[*^]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 0.47));
        }
        if (((inputText || "").match(/[÷#]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 0.66));
        }
        if (((inputText || "").match(/[>:<=]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 0.82));
        }
        if (((inputText || "").match(/[;¢]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 1.1));
        }
        if (((inputText || "").match(/[€$¥\/%@&!\\|?]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 1.4));
        }
        if (((inputText || "").match(/[()\[\]{}]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.342 * 1.82));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;
      case "Spaceship2100":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s$€@&_!:;,|'<>`^{}"#*()=%+\-[\]~\/#?\\]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s$€@&_!:;,|'<>`^{}"#*()=%+\-[\]~\/#?\\]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        //uppercase
        if (((inputText || "").match(/[J]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1731 * 1.72));
        }
        if (((inputText || "").match(/[BDFGHIKLPQTY]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1731 * 1.237));
        }
        if (((inputText || "").match(/[A]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1731 * 0.831));
        }
        if (((inputText || "").match(/[CEMNORSU-XZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1731 * 0.715));
        }
        //lowercase
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1923 * 1.637));
        }
        if (((inputText || "").match(/[bdf-iklpqty]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1923 * 1.213));
        }
        if (((inputText || "").match(/[c]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1923 * 0.77));
        }
        if (((inputText || "").match(/[aemnorsu-xz]/g) || []).length > 0) {
          signHeight.push(stripfloat(5.1923 * 0.732));
        }
        //numbers
        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4 * 1));
        }
        //punctuations
        if (((inputText || "").match(/[,._\-`]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.579 * 0.2));
        }
        if (((inputText || "").match(/[<>^~'"#*]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.579 * 0.42));
        }
        if (((inputText || "").match(/[:+]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.579 * 0.78));
        }
        if (((inputText || "").match(/[;#]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.579 * 0.89));
        }
        if (((inputText || "").match(/[@€%]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.579 * 1.23));
        }
        if (((inputText || "").match(/[$!?&]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.579 * 1.51));
        }
        if (((inputText || "").match(/[\/{}\\|()\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.579 * 1.78));
        }
        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Southland":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s`,;:[\]<>{}^|\\!'"%=÷\/+\-*$¢€£¥#@()?~&_]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s`,;:[\]<>{}^|\\!'"%=÷\/+\-*$¢€£¥#@()?~&_]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[GZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.4423 * 1.209));
        }
        if (((inputText || "").match(/[A-FH-LO-WY]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.4423 * 1.05));
        }
        if (((inputText || "").match(/[MNX]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.4423 * 0.891));
        }
        if (((inputText || "").match(/[fj]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.5654 * 1.661));
        }
        if (((inputText || "").match(/[bdghkltyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.5654 * 1.469));
        }
        if (((inputText || "").match(/[pqs]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.5654 * 1.149));
        }
        if (((inputText || "").match(/[cirx]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.5654 * 0.83));
        }
        if (((inputText || "").match(/[aemnouvw]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.5654 * 0.386));
        }
        if (((inputText || "").match(/[5-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.85 * 1.027));
        }
        if (((inputText || "").match(/[0234]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.85 * 0.973));
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.85 * 0.919));
        }
        if (
          ((inputText || "").match(/[,.:;<>`^~_'"=÷*\+-]/g) || []).length > 0
        ) {
          signHeight.push(stripfloat(1.219 * 0.49));
        }
        if (((inputText || "").match(/[¢#]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.219 * 1.19));
        }
        if (
          ((inputText || "").match(/[$£¥\/%#@()?!\\|{}]/g) || []).length > 0
        ) {
          signHeight.push(stripfloat(1.219 * 1.48));
        }
        if (((inputText || "").match(/[€&\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.219 * 1.63));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Samantha":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s!;:,'"[\]{}<>()=+\-\/*$%#_?\\@&]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s!;:,'"[\]{}<>()=+\-\/*$%#_?\\@&]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[GJY]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.8154 * 1.291));
        }
        if (((inputText || "").match(/[HKMQZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.8154 * 1.071));
        }
        if (((inputText || "").match(/[A-FILNOPRSTUWX]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.8154 * 0.924));
        }
        if (((inputText || "").match(/[V]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.8154 * 0.822));
        }
        if (((inputText || "").match(/[bhfk]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.1077 * 1.461));
        }
        if (((inputText || "").match(/[dj]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.1077 * 1.412));
        }
        if (((inputText || "").match(/[glpqtyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.1077 * 1.29));
        }
        if (((inputText || "").match(/[rs]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.1077 * 0.755));
        }
        if (((inputText || "").match(/[aiowx]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.1077 * 0.657));
        }
        if (((inputText || "").match(/[cemnuv]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.1077 * 0.559));
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6 * 1.043));
        }
        if (((inputText || "").match(/[02-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(4.6 * 1));
        }
        if (((inputText || "").match(/[.,"'_`^~-]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.418 * 0.15));
        }
        if (((inputText || "").match(/[*=+]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.418 * 0.4));
        }
        if (((inputText || "").match(/[;:<]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.418 * 0.79));
        }
        if (((inputText || "").match(/[>#]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.418 * 1));
        }
        if (((inputText || "").match(/[@&$]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.418 * 1.29));
        }
        if (((inputText || "").match(/[%\/\[\]{}!\\?()]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.418 * 1.61));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;
      case "FancyMatter":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s@#&$?%()\-+={}[\]<>!*_|"^\\;':\/]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@#&$?%()\-+={}[\]<>!*_|"^\\;':\/]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-FH-XZ]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4 * 1));
        }
        if (((inputText || "").match(/[GY]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.4 * 1.16));
        }

        if (((inputText || "").match(/[acemnoru-x]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.985 * 0.65));
        }
        if (((inputText || "").match(/[is]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.985 * 0.87));
        }
        if (((inputText || "").match(/[bdhklpqt]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.985 * 1.25));
        }
        if (((inputText || "").match(/[fgyz]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.985 * 1.43));
        }
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.985 * 1.66));
        }

        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(3.985 * 1.66));
        }

        //punctuation
        if (
          ((inputText || "").match(/[\!\$\%\&\(\)\{\}\[\]\\\|\?\/]/g) || [])
            .length > 0
        ) {
          signHeight.push(stripfloat(2.05 * 1.561));
        }
        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.05 * 1.268));
        }
        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.05 * 0.878));
        }
        if (((inputText || "").match(/[\+\;\:\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.05 * 0.537));
        }
        if (((inputText || "").match(/[\*]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.05 * 0.39));
        }
        i;
        if (((inputText || "").match(/[\^\_\=\"\'-]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.05 * 0.146));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "ChildHappy":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s%@#&_<>$+=?^*\-{}\\\/()[\]":!|;']/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s%@#&_<>$+=?^*\-{}\\\/()[\]":!|;']/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-Z]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.6 * 1));
        }

        if (((inputText || "").match(/[a-z]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.2 * 1));
        }

        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          signHeight.push(stripfloat(7.2 * 1));
        }

        //punctuation
        if (((inputText || "").match(/[\$\(\)\{\}\[\]]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.346 * 1.406));
        }
        if (((inputText || "").match(/[\!\@#%\&\\\|\?\/]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.346 * 1.151));
        }
        if (((inputText || "").match(/[\;\:\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.346 * 0.98));
        }
        if (((inputText || "").match(/[\=]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.346 * 0.725));
        }
        if (((inputText || "").match(/[\^\*\=\"\']/g) || []).length > 0) {
          signHeight.push(stripfloat(2.346 * 0.554));
        }
        if (((inputText || "").match(/[-\_]/g) || []).length > 0) {
          signHeight.push(stripfloat(2.346 * 0.128));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      //Height
      case "JackArmstrong":
        if (
          (inputText || "").match(/[^a-zA-Z0-9\s@%&?#^~<>{}==%-[\]()+",';:|]/gm)
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s@%&?#^~<>{}==%-[\]()+",';:|]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[a-zA-Z]/gi) || []).length > 0) {
          signHeight.push(stripfloat(19));
        }

        //number
        if (((inputText || "").match(/[0-9]/gi) || []).length > 0) {
          signHeight.push(stripfloat(18));
        }

        //punctuations
        if (((inputText || "").match(/[\(\)]/g) || []).length > 0) {
          signHeight.push(stripfloat(16.175 * 1.484));
        }
        if (((inputText || "").match(/[\@]/g) || []).length > 0) {
          signHeight.push(stripfloat(16.175 * 1.422));
        }
        if (((inputText || "").match(/[\<\>\[\]\|]/g) || []).length > 0) {
          signHeight.push(stripfloat(16.175 * 1.391));
        }
        if (((inputText || "").match(/[\{\}]/g) || []).length > 0) {
          signHeight.push(stripfloat(16.175 * 1.329));
        }
        if (((inputText || "").match(/[?!#\&\%\/]/g) || []).length > 0) {
          signHeight.push(stripfloat(16.175 * 1.205));
        }
        if (((inputText || "").match(/[\"\'\+\*\^\=]/g) || []).length > 0) {
          signHeight.push(stripfloat(16.175 * 0.711));
        }
        if (((inputText || "").match(/[\.\,-\~]/g) || []).length > 0) {
          signHeight.push(stripfloat(16.175 * 0.389));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Breamcatcher":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s‰¤÷\-©®=%#~™µ+*@<>¶^¥£\/&_\\{}§¢€()$?¿[\]\-"`,;:!¡'|]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s‰¤÷\-©®=%#~™µ+*@<>¶^¥£\/&_\\{}§¢€()$?¿[\]\-"`,;:!¡'|]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-PR-Z]/gi) || []).length > 0) {
          signHeight.push(stripfloat(8));
        }
        if (((inputText || "").match(/[Q]/gi) || []).length > 0) {
          signHeight.push(stripfloat(1.1 * 8));
        }

        //number
        if (((inputText || "").match(/[0-9]/gi) || []).length > 0) {
          signHeight.push(stripfloat(8));
        }

        //punctuations
        if (((inputText || "").match(/[\|]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 1.653));
        }
        if (
          ((inputText || "").match(/[\(\)\{\}\[\]\§\¶\µ]/g) || []).length > 0
        ) {
          signHeight.push(stripfloat(6.655 * 1.548));
        }
        if (((inputText || "").match(/[\%\‰\@\&\\]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 1.277));
        }
        if (
          ((inputText || "").match(/[$¢€£¥\/\#\!\?\¿\¡\©\®]/g) || []).length > 0
        ) {
          signHeight.push(stripfloat(6.655 * 1.202));
        }
        if (((inputText || "").match(/[\<\>]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.856));
        }
        if (((inputText || "").match(/[\¤\;\:\™]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.796));
        }
        if (((inputText || "").match(/[\+]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.706));
        }
        if (((inputText || "").match(/[\÷]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.646));
        }
        if (((inputText || "").match(/[\*\^]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.555));
        }
        if (((inputText || "").match(/[\=\'\"]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.406));
        }
        if (((inputText || "").match(/[\`]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.255));
        }
        if (((inputText || "").match(/[\.\~\,]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.195));
        }
        if (((inputText || "").match(/[-\_]/g) || []).length > 0) {
          signHeight.push(stripfloat(6.655 * 0.105));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;

      case "Retrolight":
        if (
          (inputText || "").match(
            /[^a-zA-Z0-9\s!|[\]^();"':*{}<>\-+?\/\\=_&#$%@]/gm
          )
        ) {
          alert("This character is not available in selected font.");
          var currentinput = $("#input_text").val();
          var newtext = currentinput.replace(
            /[^a-zA-Z0-9\s!|[\]^();"':*{}<>\-+?\/\\=_&#$%@]/gm,
            ""
          );
          $("#input_text").val(escapeHtml(newtext));
          setNewPrice();
        }
        if (((inputText || "").match(/[A-Z]/gi) || []).length > 0) {
          signHeight.push(stripfloat(8.6));
        }

        //number
        if (((inputText || "").match(/[0-9]/gi) || []).length > 0) {
          signHeight.push(stripfloat(8.6));
        }

        if (((inputText || "").match(/[-_^="',.`~]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.921 * 0.39));
        }
        if (((inputText || "").match(/[<>+*]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.921 * 0.68));
        }
        if (((inputText || "").match(/[:&]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.921 * 0.94));
        }
        if (((inputText || "").match(/[!@#%\\;?\/]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.921 * 1.17));
        }
        if (((inputText || "").match(/[$(){}\[\]|]/g) || []).length > 0) {
          signHeight.push(stripfloat(1.921 * 1.43));
        }

        var maxtempheight = Math.max.apply(this, signHeight);
        maxtempheight = maxtempheight;
        tempHeight = maxtempheight;
        return stripfloat(maxtempheight);
        break;
    }
  });

  // console.log(tempHeight + "Tmp Height");
  var maxWidth = $.map(textlength, function (i) {
    var signWidth = 0;
    inputText = i;
    inputText = inputText.replace(/\s/g, "");
    // console.log(inputText);
    switch (selectedFont) {
      case "Academy":
        if (((inputText || "").match(/[a-hA-H]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[a-hA-H]/g).length;
          signWidth += stripfloat(lettercountfont * 6.666 * 1.036);
        }

        if (((inputText || "").match(/[iI]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[iI]/g).length;
          signWidth += stripfloat(lettercountfont * 6.666 * 0.45);
        }

        if (((inputText || "").match(/[jJ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[jJ]/g).length;
          signWidth += stripfloat(lettercountfont * 6.666 * 0.76);
        }

        if (((inputText || "").match(/[kKlL]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[kKlL]/g).length;
          signWidth += stripfloat(lettercountfont * 6.666 * 1.036);
        }

        if (((inputText || "").match(/[mM]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[mM]/g).length;
          signWidth += stripfloat(lettercountfont * 7.3);
        }

        if (((inputText || "").match(/[qQ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[qQ]/g).length;
          signWidth += stripfloat(lettercountfont * 6);
        }

        if (((inputText || "").match(/[n-pN-P]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[n-pN-P]/g).length;
          signWidth += stripfloat(lettercountfont * 6.666 * 1.036);
        }

        if (((inputText || "").match(/[r-zR-Z]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[r-zR-Z]/g).length;
          signWidth += stripfloat(lettercountfont * 6.666 * 1.036);
        }

        if (((inputText || "").match(/([^qQ0-9])/g) || []).length > 0) {
          var lettercountfont = inputText.match(/([^qQ0-9])/g).length;
          signHeight = stripfloat(8);
        }

        if (((inputText || "").match(/[02-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02-9]/g).length;
          signWidth += stripfloat(lettercountfont * 5.7);
          signHeight = stripfloat(8);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.9);
          signHeight = stripfloat(8);
        }

        if (((inputText || "").match(/['',.;:!]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/['',.;:!]/g).length;
          signWidth += stripfloat(lettercountfont * 2.785 * 0.86);
        }

        if (((inputText || "").match(/[?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[?]/g).length;
          signWidth += stripfloat(lettercountfont * 2.785 * 1.97);
        }

        return stripfloat(signWidth);
        break;
      case "AmsterdamGraffiti":
        if (((inputText || "").match(/[ABMWY]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[ABMWY]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.181 * 1.18);
        }

        if (((inputText || "").match(/[CDEGHOPQRTUZ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[CDEGHOPQRTUZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.181 * 1.05);
        }

        if (((inputText || "").match(/[FKLNSVX]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[FKLNSVX]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.181 * 0.88);
        }

        if (((inputText || "").match(/[IJ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[IJ]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.181 * 0.78);
        }
        if (((inputText || "").match(/[1]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.1);
        }

        if (((inputText || "").match(/[023457]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[023457]/gi).length;
          signWidth += stripfloat(lettercountfont * 1.05 * 6.19);
        }

        if (((inputText || "").match(/[689]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[689]/gi).length;
          signWidth += stripfloat(lettercountfont * 0.84 * 6.19);
        }

        if (((inputText || "").match(/[#@]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[#@]/gi).length;
          signWidth += stripfloat(lettercountfont * 4.328 * 1.75);
        }

        if (((inputText || "").match(/[$*%&_^~]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[$*%&_^~]/gi).length;
          signWidth += stripfloat(lettercountfont * 4.328 * 1.5);
        }
        if (((inputText || "").match(/[\/=]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[\/=]/gi).length;
          signWidth += stripfloat(lettercountfont * 4.328 * 1.22);
        }
        if (((inputText || "").match(/[?+\\{}<>]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[?+\\{}<>]/gi).length;
          signWidth += stripfloat(lettercountfont * 4.328 * 1.03);
        }
        if (((inputText || "").match(/["()-]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/["()-]/gi).length;
          signWidth += stripfloat(lettercountfont * 4.328 * 0.8);
        }
        if (((inputText || "").match(/['',;:!|\][`.]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/['',;:!|\][`.]/gi).length;
          signWidth += stripfloat(lettercountfont * 4.328 * 0.57);
        }

        return stripfloat(signWidth);
        break;

      case "AniTypewriter":
        // Capitals
        //
        if (((inputText || "").match(/[MW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MW]/g).length;
          signWidth += stripfloat(lettercountfont * 5.58 * 1.34);
        }

        if (((inputText || "").match(/[AHJKXY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AHJKXY]/g).length;
          signWidth += stripfloat(lettercountfont * 5.58 * 1.05);
        }

        if (((inputText || "").match(/[BDGN-RTUV]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BDGN-RTUV]/g).length;
          signWidth += stripfloat(lettercountfont * 5.58 * 1);
        }
        if (((inputText || "").match(/[CEFLSZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CEFLSZ]/g).length;
          signWidth += stripfloat(lettercountfont * 5.58 * 0.8);
        }
        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 5.58 * 0.46);
        }

        // LowerCase
        //

        if (((inputText || "").match(/[m]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[m]/g).length;
          signWidth += stripfloat(lettercountfont * 4.919 * 1.57);
        }

        if (((inputText || "").match(/[nwx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[nwx]/g).length;
          signWidth += stripfloat(lettercountfont * 4.919 * 1.32);
        }

        if (((inputText || "").match(/[ghkpqruvy]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ghkpqruvy]/g).length;
          signWidth += stripfloat(lettercountfont * 4.919 * 1.11);
        }

        if (((inputText || "").match(/[abdestz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abdestz]/g).length;
          signWidth += stripfloat(lettercountfont * 4.919 * 0.91);
        }

        if (((inputText || "").match(/[cfj]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[cfj]/g).length;
          signWidth += stripfloat(lettercountfont * 4.919 * 0.75);
        }

        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 4.919 * 0.52);
        }

        if (((inputText || "").match(/[o]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[o]/g).length;
          signWidth += stripfloat(lettercountfont * 4.919 * 0.996);
        }

        if (((inputText || "").match(/[068]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[068]/g).length;
          signWidth += stripfloat(lettercountfont * 4.9);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 4.1);
        }

        if (((inputText || "").match(/[2]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[2]/g).length;
          signWidth += stripfloat(lettercountfont * 5.2);
        }

        if (((inputText || "").match(/[34579]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[34579]/g).length;
          signWidth += stripfloat(lettercountfont * 4.6);
        }

        if (((inputText || "").match(/[£&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[£&]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 1.746);
        }

        if (((inputText || "").match(/[€¥%]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€¥%]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 1.616);
        }

        if (((inputText || "").match(/[#@_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#@_]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 1.459);
        }

        if (((inputText || "").match(/[$=?\\<>~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$=?\\<>~]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 1.251);
        }

        if (((inputText || "").match(/[+^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[+^]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 1.121);
        }

        if (((inputText || "").match(/[*\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[*\/]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 0.99);
        }

        if (((inputText || "").match(/[(){]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[(){]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 0.86);
        }

        if (((inputText || "").match(/[}[\]`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[}[\]`]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 0.704);
        }

        if (((inputText || "").match(/[":!-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[":!-]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 0.599);
        }

        if (((inputText || "").match(/[';]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[';]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 0.417);
        }

        if (((inputText || "").match(/[,.|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[,.|]/g).length;
          signWidth += stripfloat(lettercountfont * 3.8371 * 0.261);
        }

        return stripfloat(signWidth);
        break;

      case "AustinCapittal":
        // Capitals
        //
        if (((inputText || "").match(/[AT]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AT]/g).length;
          signWidth += stripfloat(lettercountfont * 9.53 * 1.31);
        }

        if (((inputText || "").match(/[RU-X]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[RU-X]/g).length;
          signWidth += stripfloat(lettercountfont * 9.53 * 1.21);
        }

        if (((inputText || "").match(/[DGHMNQ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[DGHMNQ]/g).length;
          signWidth += stripfloat(lettercountfont * 9.53 * 1.1);
        }

        if (((inputText || "").match(/[BEPSZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BEPSZ]/g).length;
          signWidth += stripfloat(lettercountfont * 9.53 * 0.95);
        }

        if (((inputText || "").match(/[CFJKO]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CFJKO]/g).length;
          signWidth += stripfloat(lettercountfont * 9.53 * 0.89);
        }

        if (((inputText || "").match(/[LY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[LY]/g).length;
          signWidth += stripfloat(lettercountfont * 9.53 * 0.61);
        }

        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 9.53 * 0.48);
        }

        if (((inputText || "").match(/[t]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[t]/g).length;
          signWidth += stripfloat(lettercountfont * 4.323 * 1.76);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }

        if (((inputText || "").match(/[m]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[m]/g).length;
          signWidth += stripfloat(lettercountfont * 4.323 * 1.57);
        }
        if (((inputText || "").match(/[dflx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[dflx]/g).length;
          signWidth += stripfloat(lettercountfont * 4.323 * 1.27);
        }
        if (((inputText || "").match(/[aghknpquw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[aghknpquw]/g).length;
          signWidth += stripfloat(lettercountfont * 4.323 * 1.04);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[bceijorsvz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[bceijorsvz]/g).length;
          signWidth += stripfloat(lettercountfont * 4.323 * 0.81);
        }
        if (((inputText || "").match(/[y]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[y]/g).length;
          signWidth += stripfloat(lettercountfont * 4.323 * 0.55);
        }

        if (((inputText || "").match(/[02]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02]/g).length;
          signWidth += stripfloat(lettercountfont * 1.89 * 1.269);
        }
        if (((inputText || "").match(/[3-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[3-9]/g).length;
          signWidth += stripfloat(lettercountfont * 1.89 * 0.952);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 1.89 * 0.741);
        }

        //punctuation
        if (((inputText || "").match(/[\@#\&\_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\@#\&\_]/g).length;
          signWidth += stripfloat(lettercountfont * 1.036 * 2.124);
        }
        if (((inputText || "").match(/[\$\%\(\)\\\?\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\$\%\(\)\\\?\/]/g).length;
          signWidth += stripfloat(lettercountfont * 1.036 * 1.159);
        }
        if (
          ((inputText || "").match(/[\!\^\*-\+\=\{\}\[\]\;\<\>]/g) || [])
            .length > 0
        ) {
          var lettercountfont = inputText.match(
            /[\!\^\*-\+\=\{\}\[\]\;\<\>]/g
          ).length;
          signWidth += stripfloat(lettercountfont * 1.036 * 0.772);
        }
        if (((inputText || "").match(/[\|\"\'\:]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\|\"\'\:]/g).length;
          signWidth += stripfloat(lettercountfont * 1.036 * 0.289);
        }

        return stripfloat(signWidth);
        break;

      case "AvalonChaligraphy":
        // Capitals
        //
        if (((inputText || "").match(/[MNW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MNW]/g).length;
          signWidth += stripfloat(lettercountfont * 8.065 * 1.48);
        }

        if (((inputText || "").match(/[ABDFKLPRSTVXH]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ABDFKLPRSTVXH]/g).length;
          signWidth += stripfloat(lettercountfont * 8.065 * 1.05);
        }

        if (((inputText || "").match(/[GOQYU]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[GOQYU]/g).length;
          signWidth += stripfloat(lettercountfont * 8.065 * 0.9);
        }

        if (((inputText || "").match(/[CEIJZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CEIJZ]/g).length;
          signWidth += stripfloat(lettercountfont * 8.065 * 0.68);
        }

        if (((inputText || "").match(/[bdfghjklmpyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[bdfghjklmpyz]/g).length;
          signWidth += stripfloat(lettercountfont * 2.869 * 1.39);
        }

        if (((inputText || "").match(/[acenoq-tuvx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[acenoq-tuvx]/g).length;
          signWidth += stripfloat(lettercountfont * 2.869 * 0.7);
        }

        if (((inputText || "").match(/[i]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[i]/g).length;
          signWidth += stripfloat(lettercountfont * 2.869 * 0.38);
        }

        if (((inputText || "").match(/[w]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[w]/g).length;
          signWidth += stripfloat(lettercountfont * 2.869 * 0.94);
        }

        if (((inputText || "").match(/[02-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02-9]/g).length;
          signWidth += stripfloat(lettercountfont * 3.89 * 1.02);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.89 * 0.59);
        }

        if (((inputText || "").match(/[+%@&_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[+%@&_]/g).length;
          signWidth += stripfloat(lettercountfont * 1.9219 * 1.665);
        }

        if (((inputText || "").match(/[\/\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\/\\]/g).length;
          signWidth += stripfloat(lettercountfont * 1.9219 * 1.458);
        }

        if (((inputText || "").match(/[$=#?\{}<>[\]~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$=#?\{}<>[\]~]/g).length;
          signWidth += stripfloat(lettercountfont * 1.9219 * 1.197);
        }

        if (((inputText || "").match(/[*()^-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[*()^-]/g).length;
          signWidth += stripfloat(lettercountfont * 1.9219 * 0.885);
        }

        if (((inputText || "").match(/[!|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[!|]/g).length;
          signWidth += stripfloat(lettercountfont * 1.9219 * 0.676);
        }

        if (((inputText || "").match(/["'.,;:`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/["'.,;:`]/g).length;
          signWidth += stripfloat(lettercountfont * 1.9219 * 0.364);
        }

        return stripfloat(signWidth);
        break;

      case "Bearline":
        // Capitals
        //
        if (((inputText || "").match(/[ABHMNU]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ABHMNU]/g).length;
          signWidth += stripfloat(lettercountfont * 4.265 * 1.22);
        }

        if (((inputText || "").match(/[CDFGJLQRSTW-Z]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CDFGJLQRSTW-Z]/g).length;
          signWidth += stripfloat(lettercountfont * 4.265 * 1.05);
        }

        if (((inputText || "").match(/[EKOPV]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[EKOPV]/g).length;
          signWidth += stripfloat(lettercountfont * 4.265 * 0.77);
        }

        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8);
        }

        if (((inputText || "").match(/[a-eghjmnpqs-xz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[a-eghjmnpqs-xz]/g).length;
          signWidth += stripfloat(lettercountfont * 3.33 * 1.11);
        }

        if (((inputText || "").match(/[fiklory]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[fiklory]/g).length;
          signWidth += stripfloat(lettercountfont * 3.33 * 0.75);
        }

        if (((inputText || "").match(/[45]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[45]/g).length;
          signWidth += stripfloat(lettercountfont * 2.61 * 1.3);
        }

        if (((inputText || "").match(/[0236-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0236-9]/g).length;
          signWidth += stripfloat(lettercountfont * 2.61 * 0.95);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 2.61 * 0.53);
        }

        if (((inputText || "").match(/[#@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#@]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 1.979);
        }

        if (((inputText || "").match(/[¥]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¥]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 1.831);
        }

        if (((inputText || "").match(/[€\/%&\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€\/%&\\]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 1.633);
        }

        if (((inputText || "").match(/[$£?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$£?]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 1.336);
        }

        if (((inputText || "").match(/[¢+=_{}]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢+=_{}]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 1.138);
        }

        if (((inputText || "").match(/[*()<>-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[*()<>-]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 0.841);
        }

        if (((inputText || "").match(/["'[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/["'[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 0.643);
        }

        if (((inputText || "").match(/[,;:]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[,;:]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 0.346);
        }

        if (((inputText || "").match(/[÷.!|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[÷.!|]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0206 * 0.148);
        }

        return stripfloat(signWidth);
        break;

      case "Beautica":
        // Capitals
        //
        if (((inputText || "").match(/[HJKPQUVX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[HJKPQUVX]/g).length;
          signWidth += stripfloat(lettercountfont * 3.815 * 1.17);
        }

        if (((inputText || "").match(/[A-GINRSTY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[A-GINRSTY]/g).length;
          signWidth += stripfloat(lettercountfont * 3.815 * 0.91);
        }

        if (((inputText || "").match(/[OZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[OZ]/g).length;
          signWidth += stripfloat(lettercountfont * 3.815 * 0.6);
        }

        if (((inputText || "").match(/[MWL]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MWL]/g).length;
          signWidth += stripfloat(lettercountfont * 3.815 * 1.29);
        }

        if (((inputText || "").match(/[dhgjpty]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[dhgjpty]/g).length;
          signWidth += stripfloat(lettercountfont * 1.657 * 1.51);
        }

        if (((inputText || "").match(/[abfklmnoqwz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abfklmnoqwz]/g).length;
          signWidth += stripfloat(lettercountfont * 1.657 * 0.87);
        }

        if (((inputText || "").match(/[ceisuvxr]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ceisuvxr]/g).length;
          signWidth += stripfloat(lettercountfont * 1.657 * 0.5);
        }

        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0-9]/g).length;
          signWidth += stripfloat(lettercountfont * 1.34);
        }

        if (((inputText || "").match(/[\/\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\/\\]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 2.979);
        }

        if (((inputText || "").match(/[&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[&]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 2.359);
        }

        if (((inputText || "").match(/[$]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 1.676);
        }

        if (((inputText || "").match(/[£€¥%?¿{}[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[£€¥%?¿{}[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 1.428);
        }

        if (((inputText || "").match(/[#@()!¡]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#@()!¡]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 1.055);
        }

        if (((inputText || "").match(/[¢_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢_]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 0.807);
        }

        if (((inputText || "").match(/[+*÷=":<>;-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[+*÷=":<>;-]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 0.434);
        }

        if (((inputText || "").match(/['.,|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/['.,|]/g).length;
          signWidth += stripfloat(lettercountfont * 1.6111 * 0.186);
        }

        return stripfloat(signWidth);
        break;

      case "Blinkest":
        // Capitals
        //
        if (((inputText || "").match(/[MNW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MNW]/g).length;
          signWidth += stripfloat(lettercountfont * 6.138 * 1.3);
        }

        if (((inputText || "").match(/[ADHKLP-UXZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ADHKLP-UXZ]/g).length;
          signWidth += stripfloat(lettercountfont * 6.138 * 1.05);
        }

        if (((inputText || "").match(/[EFGJOVY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[EFGJOVY]/g).length;
          signWidth += stripfloat(lettercountfont * 6.138 * 0.89);
        }

        if (((inputText || "").match(/[BCI]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BCI]/g).length;
          signWidth += stripfloat(lettercountfont * 6.138 * 0.73);
        }

        if (((inputText || "").match(/[t]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[t]/g).length;
          signWidth += stripfloat(lettercountfont * 2.884 * 2.25);
        }

        if (((inputText || "").match(/[gjp]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[gjp]/g).length;
          signWidth += stripfloat(lettercountfont * 2.884 * 1.56);
        }

        if (((inputText || "").match(/[dhqwyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[dhqwyz]/g).length;
          signWidth += stripfloat(lettercountfont * 2.884 * 1.21);
        }

        if (((inputText || "").match(/[abfk-nruv]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abfk-nruv]/g).length;
          signWidth += stripfloat(lettercountfont * 2.884 * 0.86);
        }
        if (((inputText || "").match(/[ceiosx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ceiosx]/g).length;
          signWidth += stripfloat(lettercountfont * 2.884 * 0.52);
        }

        if (((inputText || "").match(/[2-589]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[2-589]/g).length;
          signWidth += stripfloat(lettercountfont * 3.87 * 1.16);
        }

        if (((inputText || "").match(/[067]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[067]/g).length;
          signWidth += stripfloat(lettercountfont * 3.87 * 0.9);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.87 * 0.6);
        }

        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 1.987);
        }

        if (((inputText || "").match(/[$£\/%#&?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$£\/%#&?]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 1.818);
        }

        if (((inputText || "").match(/[()|{}[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[()|{}[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 1.395);
        }

        if (((inputText || "").match(/[€!]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€!]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 1.142);
        }

        if (((inputText || "").match(/[¥_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¥_]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 0.973);
        }

        if (((inputText || "").match(/[¢+=<>-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢+=<>-]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 0.719);
        }

        if (((inputText || "").match(/[*÷;:^~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[*÷;:^~]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 0.549);
        }

        if (((inputText || "").match(/["',\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/["',\\]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 0.296);
        }

        if (((inputText || "").match(/[.`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[.`]/g).length;
          signWidth += stripfloat(lettercountfont * 2.3649 * 0.127);
        }

        return stripfloat(signWidth);
        break;

      case "BombFont":
        if (((inputText || "").match(/[W]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/gi).length;
          signWidth += stripfloat(lettercountfont * 5.934 * 1.43);
        }

        if (((inputText || "").match(/[UVXY]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[UVXY]/gi).length;
          signWidth += stripfloat(lettercountfont * 5.934 * 1.26);
        }

        if (((inputText || "").match(/[KMNP-SZ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[KMNP-SZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 5.934 * 1.09);
        }

        if (((inputText || "").match(/[DEFHLOT&?$#@]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[DEFHLOT&?$#@]/gi).length;
          signWidth += stripfloat(lettercountfont * 5.934 * 0.92);
        }

        if (((inputText || "").match(/[ABCGIJ0-9*()]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[ABCGIJ0-9*()]/gi).length;
          signWidth += stripfloat(lettercountfont * 5.934 * 0.75);
        }

        if (((inputText || "").match(/[.,'"`;:!]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[.,'"`;:!]/gi).length;
          signWidth += stripfloat(lettercountfont * 5.934 * 0.45);
        }

        return stripfloat(signWidth);
        break;

      case "DolceVita":
        if (((inputText || "").match(/[W]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.523 * 1.74);
        }

        if (((inputText || "").match(/[MOQ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[MOQ]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.523 * 1.3);
        }

        if (((inputText || "").match(/[ACDGHNTUVXYZ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[ACDGHNTUVXYZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.523 * 0.99);
        }

        if (((inputText || "").match(/[BKPRS]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[BKPRS]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.523 * 0.84);
        }

        if (((inputText || "").match(/[EFL]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[EFL]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.523 * 0.68);
        }

        if (((inputText || "").match(/[J]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[J]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.523 * 0.45);
        }

        if (((inputText || "").match(/[I]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/gi).length;
          signWidth += stripfloat(lettercountfont * 6.523 * 0.12);
        }

        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 2.822);
        }

        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 2.217);
        }

        if (((inputText || "").match(/[€]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 1.929);
        }

        if (((inputText || "").match(/[¢%]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢%]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 1.641);
        }

        if (((inputText || "").match(/[¥&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¥&]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 1.526);
        }

        if (((inputText || "").match(/[\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\/]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 1.353);
        }

        if (((inputText || "").match(/[$£\\<>]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$£\\<>]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 1.238);
        }

        if (((inputText || "").match(/[?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[?]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 1.065);
        }

        if (((inputText || "").match(/[=_~-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[=_~-]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 0.95);
        }

        if (((inputText || "").match(/[+*]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[+*]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 0.777);
        }

        if (((inputText || "").match(/["()^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/["()^]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 0.662);
        }

        if (((inputText || "").match(/[[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 0.489);
        }

        if (((inputText || "").match(/[';:]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[';:]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 0.374);
        }

        if (((inputText || "").match(/[.,!`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[.,!`]/g).length;
          signWidth += stripfloat(lettercountfont * 3.4727 * 0.202);
        }

        if (((inputText || "").match(/[0689]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0689]/g).length;
          signWidth += stripfloat(lettercountfont * 4.37 * 1.25);
        }

        if (((inputText || "").match(/[23457]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[23457]/g).length;
          signWidth += stripfloat(lettercountfont * 4.37 * 1.02);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 4.37 * 0.27);
        }

        return stripfloat(signWidth);
        break;

      case "Elegant":
        if (((inputText || "").match(/[HMTX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[HMTX]/g).length;
          signWidth += stripfloat(lettercountfont * 5.18 * 1.25);
        }

        if (((inputText || "").match(/[ABDEFGJKLNSUW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ABDEFGJKLNSUW]/g).length;
          signWidth += stripfloat(lettercountfont * 5.18 * 1.06);
        }

        if (((inputText || "").match(/[IO-RVYZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[IO-RVYZ]/g).length;
          signWidth += stripfloat(lettercountfont * 5.18 * 0.86);
        }

        if (((inputText || "").match(/[C]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[C]/g).length;
          signWidth += stripfloat(lettercountfont * 5.18 * 0.67);
        }

        if (((inputText || "").match(/[gjty]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[gjty]/g).length;
          signWidth += stripfloat(lettercountfont * 3.311 * 1.35);
        }

        if (((inputText || "").match(/[adfhk-qu-xz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[adfhk-qu-xz]/g).length;
          signWidth += stripfloat(lettercountfont * 3.311 * 1.05);
        }

        if (((inputText || "").match(/[bcers]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[bcers]/g).length;
          signWidth += stripfloat(lettercountfont * 3.311 * 0.7);
        }

        if (((inputText || "").match(/[i]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[i]/g).length;
          signWidth += stripfloat(lettercountfont * 3.311 * 0.45);
        }

        if (((inputText || "").match(/[0-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0-9]/g).length;
          signWidth += stripfloat(lettercountfont * 3.82 * 1.047);
        }

        if (((inputText || "").match(/[#@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#@]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 1.839);
        }

        if (((inputText || "").match(/[$[<>\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$[<>\]]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 1.447);
        }

        if (((inputText || "").match(/[\/%(){}}]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\/%(){}}]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 1.291);
        }

        if (((inputText || "").match(/[+=_?\\-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[+=_?\\-]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 1.056);
        }

        if (((inputText || "").match(/[&!~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[&!~]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 0.899);
        }

        if (((inputText || "").match(/[|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[|]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 0.665);
        }

        if (((inputText || "").match(/[*"^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[*"^]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 0.509);
        }

        if (((inputText || "").match(/['.,;:`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/['.,;:`]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5563 * 0.274);
        }

        return stripfloat(signWidth);
        break;

      case "Technology":
        if (((inputText || "").match(/[MW]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[MW]/gi).length;
          signWidth += stripfloat(lettercountfont * 5 * 1.16);
        }

        if (((inputText || "").match(/[A-HJKLN-VXYZ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[A-HJKLN-VXYZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 5 * 1);
        }

        if (((inputText || "").match(/[I]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/gi).length;
          signWidth += stripfloat(lettercountfont * 5 * 0.3);
        }

        if (((inputText || "").match(/[02-9]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[02-9]/gi).length;
          signWidth += stripfloat(lettercountfont * 5);
        }

        if (((inputText || "").match(/[1]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/gi).length;
          signWidth += stripfloat(lettercountfont * 1.5);
        }

        if (((inputText || "").match(/[$]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5727 * 1.943);
        }

        if (((inputText || "").match(/[?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[?]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5727 * 1.749);
        }

        if (((inputText || "").match(/[-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[-]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5727 * 1.166);
        }

        if (((inputText || "").match(/["[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/["[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5727 * 1.049);
        }

        if (((inputText || "").match(/[;]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[;]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5727 * 0.699);
        }

        if (((inputText || "").match(/[.,:!]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[.,:!]/g).length;
          signWidth += stripfloat(lettercountfont * 2.5727 * 0.505);
        }

        return stripfloat(signWidth);
        break;

      case "GreatDay":
        if (((inputText || "").match(/[AMTW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AMTW]/g).length;
          signWidth += stripfloat(lettercountfont * 8.35 * 1.25);
        }

        if (((inputText || "").match(/[HKNVX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[HKNVX]/g).length;
          signWidth += stripfloat(lettercountfont * 8.35 * 1.13);
        }

        if (((inputText || "").match(/[BDEFJUY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BDEFJUY]/g).length;
          signWidth += stripfloat(lettercountfont * 8.35 * 1.01);
        }

        if (((inputText || "").match(/[CGPR]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CGPR]/g).length;
          signWidth += stripfloat(lettercountfont * 8.35 * 0.89);
        }

        if (((inputText || "").match(/[IOSZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[IOSZ]/g).length;
          signWidth += stripfloat(lettercountfont * 8.35 * 0.77);
        }

        if (((inputText || "").match(/[LQ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[LQ]/g).length;
          signWidth += stripfloat(lettercountfont * 8.35 * 0.65);
        }

        if (((inputText || "").match(/[dfghjmqv-y]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[dfghjmqv-y]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7 * 1.29);
        }

        if (((inputText || "").match(/[irs]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[irs]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7 * 0.7);
        }

        if (((inputText || "").match(/[abceklnoptuz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abceklnoptuz]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7 * 0.92);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 1.68 * 0.6);
        }
        if (((inputText || "").match(/[046-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[046-9]/g).length;
          signWidth += stripfloat(lettercountfont * 1.68 * 1);
        }
        if (((inputText || "").match(/[235]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[235]/g).length;
          signWidth += stripfloat(lettercountfont * 1.68 * 1.19);
        }

        if (((inputText || "").match(/[|']/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[|']/g).length;
          signWidth += stripfloat(lettercountfont * 1.979 * 0.28);
        }
        if (((inputText || "").match(/[:;"-*]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[:;"-*]/g).length;
          signWidth += stripfloat(lettercountfont * 1.979 * 0.63);
        }
        if (((inputText || "").match(/[!^&+={}\\<>\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[!^&+={}\\<>\/]/g).length;
          signWidth += stripfloat(lettercountfont * 1.979 * 0.93);
        }
        if (((inputText || "").match(/[?_()@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[?_()@]/g).length;
          signWidth += stripfloat(lettercountfont * 1.979 * 1.14);
        }
        if (((inputText || "").match(/[#$%[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#$%[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 1.979 * 1.62);
        }

        return stripfloat(signWidth);
        break;

      case "JulyIt":
        if (((inputText || "").match(/[T]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[T]/g).length;
          signWidth += stripfloat(lettercountfont * 5.888 * 1.39);
        }

        if (((inputText || "").match(/[V]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[V]/g).length;
          signWidth += stripfloat(lettercountfont * 5.888 * 1.27);
        }

        if (((inputText || "").match(/[BCDFGJMSX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BCDFGJMSX]/g).length;
          signWidth += stripfloat(lettercountfont * 5.888 * 1.1);
        }

        if (((inputText || "").match(/[AEHIKLNOUWYZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AEHIKLNOUWYZ]/g).length;
          signWidth += stripfloat(lettercountfont * 5.888 * 0.93);
        }

        if (((inputText || "").match(/[PQR]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[PQR]/g).length;
          signWidth += stripfloat(lettercountfont * 5.888 * 0.76);
        }

        if (((inputText || "").match(/[dfgjpyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[dfgjpyz]/g).length;
          signWidth += stripfloat(lettercountfont * 2.476 * 1.41);
        }

        if (((inputText || "").match(/[abhk-nqtuwx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abhk-nqtuwx]/g).length;
          signWidth += stripfloat(lettercountfont * 2.476 * 1);
        }

        if (((inputText || "").match(/[ceiorsv]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ceiorsv]/g).length;
          signWidth += stripfloat(lettercountfont * 2.476 * 0.6);
        }

        if (((inputText || "").match(/[02]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7);
        }

        if (((inputText || "").match(/[19]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[19]/g).length;
          signWidth += stripfloat(lettercountfont * 2);
        }

        if (((inputText || "").match(/[3-8]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[3-8]/g).length;
          signWidth += stripfloat(lettercountfont * 2.4);
        }

        if (((inputText || "").match(/[¥]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¥]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 2.663);
        }

        if (((inputText || "").match(/[<>]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[<>]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 1.712);
        }

        if (((inputText || "").match(/[@?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@?]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 1.569);
        }

        if (((inputText || "").match(/[$\/&()\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$\/&()\\]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 1.284);
        }

        if (((inputText || "").match(/[€%#_[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€%#_[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 1.094);
        }

        if (((inputText || "").match(/[¢+*÷=!¡-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢+*÷=!¡-]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 0.808);
        }

        if (((inputText || "").match(/[,:^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[,:^]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 0.618);
        }

        if (((inputText || "").match(/["'.;|`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/["'.;|`]/g).length;
          signWidth += stripfloat(lettercountfont * 2.1029 * 0.333);
        }

        return stripfloat(signWidth);
        break;

      case "LettersForLearners":
        if (((inputText || "").match(/[W]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/g).length;
          signWidth += stripfloat(lettercountfont * 4.33 * 1.5);
        }

        if (((inputText || "").match(/[MQ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MQ]/g).length;
          signWidth += stripfloat(lettercountfont * 4.33 * 1.27);
        }

        if (((inputText || "").match(/[A-EGHKNOPR-VXYZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[A-EGHKNOPR-VXYZ]/g).length;
          signWidth += stripfloat(lettercountfont * 4.33 * 1.03);
        }

        if (((inputText || "").match(/[FIJL]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[FIJL]/g).length;
          signWidth += stripfloat(lettercountfont * 4.33 * 0.8);
        }

        if (((inputText || "").match(/[mqw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[mqw]/g).length;
          signWidth += stripfloat(lettercountfont * 3.438 * 1.59);
        }

        if (((inputText || "").match(/[bde]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[bde]/g).length;
          signWidth += stripfloat(lettercountfont * 3.438 * 1.3);
        }

        if (((inputText || "").match(/[acfghknopsuvxy]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[acfghknopsuvxy]/g).length;
          signWidth += stripfloat(lettercountfont * 3.438 * 1.01);
        }

        if (((inputText || "").match(/[jrtz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[jrtz]/g).length;
          signWidth += stripfloat(lettercountfont * 3.438 * 0.72);
        }

        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 3.438 * 0.43);
        }

        if (((inputText || "").match(/[03-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[03-9]/g).length;
          signWidth += stripfloat(lettercountfont * 3.74 * 1.25);
        }

        if (((inputText || "").match(/[2]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[2]/g).length;
          signWidth += stripfloat(lettercountfont * 3.74 * 0.96);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.74 * 0.29);
        }

        //Special Characters
        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 2.303);
        }

        if (((inputText || "").match(/[%]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[%]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 2.055);
        }

        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 1.843);
        }

        if (((inputText || "").match(/[€]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 1.453);
        }

        if (((inputText || "").match(/[£¥&~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[£¥&~]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 1.311);
        }

        if (((inputText || "").match(/[$¢+÷?{}<>]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$¢+÷?{}<>]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 1.169);
        }

        if (((inputText || "").match(/[-*\/_()]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[-*\/_()]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 0.957);
        }

        if (((inputText || "").match(/[\[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 0.815);
        }

        if (((inputText || "").match(/[";]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[";]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 0.602);
        }

        if (((inputText || "").match(/[,']/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[,']/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 0.461);
        }

        if (((inputText || "").match(/['.:!|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/['.:!|]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 0.248);
        }

        if (((inputText || "").match(/[=]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[=]/g).length;
          signWidth += stripfloat(lettercountfont * 2.8222 * 0.957);
        }

        return stripfloat(signWidth);
        break;

      case "Minimal":
        if (((inputText || "").match(/[QW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[QW]/g).length;
          signWidth += stripfloat(lettercountfont * 3.915 * 1.66);
        }

        if (((inputText || "").match(/[CGOZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CGOZ]/g).length;
          signWidth += stripfloat(lettercountfont * 3.915 * 1.4);
        }

        if (((inputText || "").match(/[AMNSUVXY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AMNSUVXY]/g).length;
          signWidth += stripfloat(lettercountfont * 3.915 * 1.14);
        }

        if (((inputText || "").match(/[BDHK]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BDHK]/g).length;
          signWidth += stripfloat(lettercountfont * 3.915 * 0.89);
        }

        if (((inputText || "").match(/[EFLPRT]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[EFLPRT]/g).length;
          signWidth += stripfloat(lettercountfont * 3.915 * 0.63);
        }

        if (((inputText || "").match(/[J]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[J]/g).length;
          signWidth += stripfloat(lettercountfont * 3.915 * 0.38);
        }

        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 3.915 * 0.13);
        }

        if (((inputText || "").match(/[m]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[m]/g).length;
          signWidth += stripfloat(lettercountfont * 3.503 * 2.11);
        }

        if (((inputText || "").match(/[w]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[w]/g).length;
          signWidth += stripfloat(lettercountfont * 3.503 * 1.57);
        }

        if (((inputText || "").match(/[nuv]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[nuv]/g).length;
          signWidth += stripfloat(lettercountfont * 3.503 * 1.28);
        }

        if (((inputText || "").match(/[a-eghopqsxyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[a-eghopqsxyz]/g).length;
          signWidth += stripfloat(lettercountfont * 3.503 * 0.99);
        }

        if (((inputText || "").match(/[fjkr]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[fjkr]/g).length;
          signWidth += stripfloat(lettercountfont * 3.503 * 0.71);
        }

        if (((inputText || "").match(/[t]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[t]/g).length;
          signWidth += stripfloat(lettercountfont * 3.503 * 0.42);
        }

        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 3.503 * 0.17);
        }

        if (((inputText || "").match(/[069]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[069]/g).length;
          signWidth += stripfloat(lettercountfont * 3.57 * 1.12);
        }

        if (((inputText || "").match(/[234578]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[234578]/g).length;
          signWidth += stripfloat(lettercountfont * 3.57 * 1);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.57 * 0.67);
        }

        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 3.794);
        }

        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 2.396);
        }

        if (((inputText || "").match(/[$$]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$$]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 1.847);
        }

        if (((inputText || "").match(/[_?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[_?]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 1.697);
        }

        if (((inputText || "").match(/[\+-/=÷\\<>]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\+-/=÷\\<>]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 1.148);
        }

        if (((inputText || "").match(/[*^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[*^]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 0.849);
        }

        if (((inputText || "").match(/[";{}[\]`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[";{}[\]`]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 0.649);
        }

        if (((inputText || "").match(/['(),.:!|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/['(),.:!|]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 0.349);
        }

        if (((inputText || "").match(/[~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[~]/g).length;
          signWidth += stripfloat(lettercountfont * 2.0032 * 1.697);
        }

        return stripfloat(signWidth);
        break;

      //Width
      case "ModernSansLight":
        if (((inputText || "").match(/[W]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/g).length;
          signWidth += stripfloat(lettercountfont * 5.115 * 1.563);
        }
        if (((inputText || "").match(/[AMQV]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AMQV]/g).length;
          signWidth += stripfloat(lettercountfont * 5.115 * 1.271);
        }
        if (((inputText || "").match(/[B-EGHKOPRTX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[B-EGHKOPRTX]/g).length;
          signWidth += stripfloat(lettercountfont * 5.115 * 1.075);
        }
        if (((inputText || "").match(/[FJL]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[FJL]/g).length;
          signWidth += stripfloat(lettercountfont * 5.115 * 0.82);
        }
        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 5.115 * 0.156);
        }
        if (((inputText || "").match(/[NYZUS]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[NYZUS]/g).length;
          signWidth += stripfloat(lettercountfont * 5.115 * 0.92);
        }
        //small

        if (((inputText || "").match(/[mw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[mw]/g).length;
          signWidth += stripfloat(lettercountfont * 4.135 * 1.572);
        }
        if (((inputText || "").match(/[v]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[v]/g).length;
          signWidth += stripfloat(lettercountfont * 4.135 * 1.28);
        }
        if (((inputText || "").match(/[a-eghkn-quxyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[a-eghkn-quxyz]/g).length;
          signWidth += stripfloat(lettercountfont * 4.135 * 1.088);
        }
        if (((inputText || "").match(/[frst]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[frst]/g).length;
          signWidth += stripfloat(lettercountfont * 4.135 * 0.846);
        }
        if (((inputText || "").match(/[j]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[j]/g).length;
          signWidth += stripfloat(lettercountfont * 4.135 * 0.484);
        }
        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 4.135 * 0.218);
        }

        //number

        if (((inputText || "").match(/[2-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[2-9]/g).length;
          signWidth += stripfloat(lettercountfont * 4.34 * 1.06);
        }
        if (((inputText || "").match(/[0]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0]/g).length;
          signWidth += stripfloat(lettercountfont * 4.34 * 1.01);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 4.34 * 1.51);
        }

        //punctuations
        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 2.517);
        }
        if (((inputText || "").match(/[%&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[%&]/g).length;
          signWidth += stripfloat(lettercountfont * 3.33 * 1.738);
        }
        if (((inputText || "").match(/[$¥#_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$¥#_]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 1.588);
        }
        if (((inputText || "").match(/[=<>]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[=<>]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 1.408);
        }
        if (((inputText || "").match(/[\*¢÷^~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\*¢÷^~]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 1.289);
        }
        if (((inputText || "").match(/[\+\?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\+\?]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 1.109);
        }
        if (((inputText || "").match(/[-\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[-\\]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 0.989);
        }
        if (((inputText || "").match(/[/"{}]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[/"{}]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 0.809);
        }
        if (((inputText || "").match(/[\(\)\[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\(\)\[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 0.689);
        }
        if (((inputText || "").match(/[`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[`]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 0.509);
        }
        if (((inputText || "").match(/[,;:]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[,;:]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 0.389);
        }
        if (((inputText || "").match(/['\.!\|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/['\.!\|]/g).length;
          signWidth += stripfloat(lettercountfont * 3.337 * 0.239);
        }

        return stripfloat(signWidth);
        break;

      case "PaperFlowers":
        if (((inputText || "").match(/[W]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.808 * 1.674);
        }
        if (((inputText || "").match(/[A-DJMNUVY]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[A-DJMNUVY]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.808 * 1.069);
        }
        if (((inputText || "").match(/[HKO-RTXZ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[HKO-RTXZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.808 * 0.997);
        }
        if (((inputText || "").match(/[EFGLS]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[EFGLS]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.808 * 0.819);
        }
        if (((inputText || "").match(/[I]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.808 * 0.534);
        }

        //small none

        //number

        if (((inputText || "").match(/[048]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[048]/g).length;
          signWidth += stripfloat(lettercountfont * 2.64 * 1.136);
        }
        if (((inputText || "").match(/[679]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[679]/g).length;
          signWidth += stripfloat(lettercountfont * 2.64 * 1.061);
        }
        if (((inputText || "").match(/[235]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[235]/g).length;
          signWidth += stripfloat(lettercountfont * 2.64 * 0.947);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 2.64 * 0.606);
        }

        //punctuation

        if (((inputText || "").match(/[\.:;\|'!` ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\.:;\|'!` ]/g).length;
          signWidth += stripfloat(lettercountfont * 2.359 * 0.47);
        }
        if (
          ((inputText || "").match(/[\"\(\)\,\[\]\{\}\<\>]/g) || []).length > 0
        ) {
          var lettercountfont = inputText.match(
            /[\"\(\)\,\[\]\{\}\<\>]/g
          ).length;
          signWidth += stripfloat(lettercountfont * 2.359 * 0.72);
        }
        if (((inputText || "").match(/[-\*\/\\^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[-\*\/\\]/g).length;
          signWidth += stripfloat(lettercountfont * 2.359 * 0.95);
        }
        if (((inputText || "").match(/[¢¥]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢¥]/g).length;
          signWidth += stripfloat(lettercountfont * 2.359 * 1.17);
        }
        if (((inputText || "").match(/[\&\+\=#_\?~÷]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\&\+\=#_\?~÷]/g).length;
          signWidth += stripfloat(lettercountfont * 2.359 * 1.4);
        }
        if (((inputText || "").match(/[$€£%]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$€£%]/g).length;
          signWidth += stripfloat(lettercountfont * 2.359 * 1.5);
        }
        if (((inputText || "").match(/[\@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\@]/g).length;
          signWidth += stripfloat(lettercountfont * 2.359 * 2.46);
        }

        return stripfloat(signWidth);
        break;

      case "PrettyGirlScript":
        if (((inputText || "").match(/[M]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[M]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 1.822);
        }
        if (((inputText || "").match(/[HN]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[HN]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 1.368);
        }
        if (((inputText || "").match(/[KW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[KW]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 1.304);
        }
        if (((inputText || "").match(/[BDIQULXZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BDIQULXZ]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 1.021);
        }
        if (((inputText || "").match(/[AFY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AFY]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 0.896);
        }
        if (((inputText || "").match(/[JOT]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[JOT]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 0.801);
        }
        if (((inputText || "").match(/[GV]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[GV]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 1.754);
        }
        if (((inputText || "").match(/[C]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[C]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 1.676);
        }
        if (((inputText || "").match(/[ES]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ES]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 0.487);
        }
        if (((inputText || "").match(/[PR]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[PR]/g).length;
          signWidth += stripfloat(lettercountfont * 6.365 * 1.178);
        }

        //small

        if (((inputText || "").match(/[mqw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[mqw]/g).length;
          signWidth += stripfloat(lettercountfont * 4.312 * 1.392);
        }
        if (((inputText || "").match(/[fh]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[fh]/g).length;
          signWidth += stripfloat(lettercountfont * 4.312 * 1.252);
        }
        if (((inputText || "").match(/[bd]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[bd]/g).length;
          signWidth += stripfloat(lettercountfont * 4.312 * 1.113);
        }
        if (((inputText || "").match(/[ajknprtuvxyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ajknprtuvxyz]/g).length;
          signWidth += stripfloat(lettercountfont * 4.312 * 0.997);
        }
        if (((inputText || "").match(/[go]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[go]/g).length;
          signWidth += stripfloat(lettercountfont * 4.312 * 0.905);
        }
        if (((inputText || "").match(/[cels]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[cels]/g).length;
          signWidth += stripfloat(lettercountfont * 4.312 * 0.742);
        }
        if (((inputText || "").match(/[i]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[i]/g).length;
          signWidth += stripfloat(lettercountfont * 4.312 * 0.51);
        }

        //number

        if (((inputText || "").match(/[0]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 1.239);
        }
        if (((inputText || "").match(/[245789]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[245789]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 1.157);
        }
        if (((inputText || "").match(/[36]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[36]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 0.95);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 0.455);
        }

        //punctuation

        if (((inputText || "").match(/[\.\:!\|\']/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\.\:!\|\']/g).length;
          signWidth += stripfloat(lettercountfont * 1.762 * 0.28);
        }
        if (
          ((inputText || "").match(/[`\<\>\;\,\{\}\"*\+]/g) || []).length > 0
        ) {
          var lettercountfont = inputText.match(/[`\<\>\;\,\{\}\"*\+]/g).length;
          signWidth += stripfloat(lettercountfont * 1.762 * 0.68);
        }
        if (((inputText || "").match(/[$\=\[\]\^-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$\=\[\]\^-]/g).length;
          signWidth += stripfloat(lettercountfont * 1.762 * 0.96);
        }
        if (((inputText || "").match(/[£\/%#\(\)\?\\\~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[£\/%#\(\)\?\\\~]/g).length;
          signWidth += stripfloat(lettercountfont * 1.762 * 1.31);
        }
        if (((inputText || "").match(/[€_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€_]/g).length;
          signWidth += stripfloat(lettercountfont * 1.762 * 1.69);
        }
        if (((inputText || "").match(/[\@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\@]/g).length;
          signWidth += stripfloat(lettercountfont * 1.762 * 2.04);
        }
        if (((inputText || "").match(/[\&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\&]/g).length;
          signWidth += stripfloat(lettercountfont * 1.762 * 2.61);
        }

        return stripfloat(signWidth);
        break;

      case "RMPlaytime":
        if (((inputText || "").match(/[W]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/g).length;
          signWidth += stripfloat(lettercountfont * 4.65 * 1.935);
        }
        if (((inputText || "").match(/[AOQV]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AOQV]/g).length;
          signWidth += stripfloat(lettercountfont * 4.65 * 1.376);
        }
        if (((inputText || "").match(/[M]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[M]/g).length;
          signWidth += stripfloat(lettercountfont * 4.65 * 1.269);
        }
        if (((inputText || "").match(/[B-HJLNPR-UXYZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[B-HJLNPR-UXYZ]/g).length;
          signWidth += stripfloat(lettercountfont * 4.65 * 0.925);
        }
        if (((inputText || "").match(/[K]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[K]/g).length;
          signWidth += stripfloat(lettercountfont * 4.65 * 0.774);
        }
        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 4.65 * 0.344);
        }

        //small

        if (((inputText || "").match(/[mqw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[mqw]/g).length;
          signWidth += stripfloat(lettercountfont * 4.215 * 1.779);
        }
        if (((inputText || "").match(/[dhovy]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[dhovy]/g).length;
          signWidth += stripfloat(lettercountfont * 4.215 * 1.139);
        }
        if (((inputText || "").match(/[abejnpqsug]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abejnpqsug]/g).length;
          signWidth += stripfloat(lettercountfont * 4.215 * 1.02);
        }
        if (((inputText || "").match(/[kx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[kx]/g).length;
          signWidth += stripfloat(lettercountfont * 4.215 * 0.901);
        }
        if (((inputText || "").match(/[crtz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[crtz]/g).length;
          signWidth += stripfloat(lettercountfont * 4.215 * 0.782);
        }
        if (((inputText || "").match(/[f]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[f]/g).length;
          signWidth += stripfloat(lettercountfont * 4.215 * 0.688);
        }
        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 4.215 * 0.356);
        }

        //number

        if (((inputText || "").match(/[0]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0]/g).length;
          signWidth += stripfloat(lettercountfont * 3.83 * 1.436);
        }
        if (((inputText || "").match(/[46]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[46]/g).length;
          signWidth += stripfloat(lettercountfont * 3.83 * 1.07);
        }
        if (((inputText || "").match(/[235789]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[235789]/g).length;
          signWidth += stripfloat(lettercountfont * 3.83 * 0.992);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.83 * 0.601);
        }

        //punctuation

        if (((inputText || "").match(/[!`\;\:,\.\'|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[!`\;\:,\.\'|]/g).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 0.45);
        }
        if (
          ((inputText || "").match(/[$\*\=\+\"\?\{\}\[\]]/g) || []).length > 0
        ) {
          var lettercountfont = inputText.match(
            /[$\*\=\+\"\?\{\}\[\]]/g
          ).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 0.93);
        }
        if (((inputText || "").match(/[\(\)\^-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[-\(\)\^-]/g).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 1.07);
        }
        if (((inputText || "").match(/[€£¥\\\~\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[€£¥\\\~\/]/g).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 1.21);
        }
        if (((inputText || "").match(/[\_\<\>]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\_\<\>]/g).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 1.37);
        }
        if (((inputText || "").match(/[\&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\&]/g).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 1.54);
        }
        if (((inputText || "").match(/[\%\@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\%\@]/g).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 1.72);
        }

        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#]/g).length;
          signWidth += stripfloat(lettercountfont * 3.55 * 1.54);
        }

        return stripfloat(signWidth);
        break;

      case "RoselinaEllis":
        if (((inputText || "").match(/[W]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 1.737);
        }
        if (((inputText || "").match(/[X]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[X]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 1.57);
        }
        if (((inputText || "").match(/[MVY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MVY]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 1.418);
        }
        if (((inputText || "").match(/[NTU]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[NTU]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 1.32);
        }
        if (((inputText || "").match(/[K]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[K]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 1.181);
        }
        if (((inputText || "").match(/[Z]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[Z]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 1.097);
        }
        if (((inputText || "").match(/[H]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[H]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 1);
        }
        if (((inputText || "").match(/[DFLR]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[DFLR]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 0.861);
        }
        if (((inputText || "").match(/[GJPS]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[GJPS]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 0.792);
        }
        if (((inputText || "").match(/[B]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[B]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 0.737);
        }
        if (((inputText || "").match(/[ACEIOQ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ACEIOQ]/g).length;
          signWidth += stripfloat(lettercountfont * 7.195 * 0.667);
        }

        //small

        if (((inputText || "").match(/[t]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[t]/g).length;
          signWidth += stripfloat(lettercountfont * 2.469 * 1.863);
        }
        if (((inputText || "").match(/[fgjp]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[fgjp]/g).length;
          signWidth += stripfloat(lettercountfont * 2.469 * 1.215);
        }
        if (((inputText || "").match(/[hmqsxyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[hmqsxyz]/g).length;
          signWidth += stripfloat(lettercountfont * 2.469 * 1.053);
        }
        if (((inputText || "").match(/[abdknuw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abdknuw]/g).length;
          signWidth += stripfloat(lettercountfont * 2.469 * 0.931);
        }
        if (((inputText || "").match(/[ceilorv]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ceilorv]/g).length;
          signWidth += stripfloat(lettercountfont * 2.469 * 0.688);
        }

        //number

        if (((inputText || "").match(/[3]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[3]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 1.239);
        }
        if (((inputText || "").match(/[2589]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[2589]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 1.074);
        }
        if (((inputText || "").match(/[0467]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0467]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 0.95);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 2.42 * 0.702);
        }

        //punctuation

        if (((inputText || "").match(/[`^\*\,\.]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[`^\*\,\.]/g).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 0.41);
        }
        if (((inputText || "").match(/[\"\'\+\:\;\~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\"\'\+\:\;\~]/g).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 0.57);
        }
        if (((inputText || "").match(/[\÷\=$¢€-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\÷\=$¢€-]/g).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 0.83);
        }
        if (
          ((inputText || "").match(/[£¥#_\(\)\!\|\{\}\<\>\[\]]/g) || [])
            .length > 0
        ) {
          var lettercountfont = inputText.match(
            /[£¥#_\(\)\!\|\{\}\<\>\[\]]/g
          ).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 1.05);
        }
        if (((inputText || "").match(/[#]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#]/g).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 1.39);
        }
        if (((inputText || "").match(/[\/\%\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\/\%\\]/g).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 1.76);
        }
        if (((inputText || "").match(/[\?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\?]/g).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 1.86);
        }
        if (((inputText || "").match(/[\@\&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\@\&]/g).length;
          signWidth += stripfloat(lettercountfont * 1.935 * 2.18);
        }

        return stripfloat(signWidth);
        break;

      //Width
      case "Walkway":
        // uppercase
        if (((inputText || "").match(/[W]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 1.581);
        }

        if (((inputText || "").match(/[GMOQXY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[GMOQXY]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 1.177);
        }

        if (((inputText || "").match(/[AD]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AD]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 1.065);
        }

        if (((inputText || "").match(/[BCEHKNPSUVZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BCEHKNPSUVZ]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 1);
        }

        if (((inputText || "").match(/[RT]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[RT]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 0.952);
        }

        if (((inputText || "").match(/[FL]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[FL]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 0.855);
        }

        if (((inputText || "").match(/[J]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[J]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 0.677);
        }
        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 6.2 * 0.097);
        }

        // lowercase
        if (((inputText || "").match(/[mw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[mw]/g).length;
          signWidth += stripfloat(lettercountfont * 4.7269 * 1.587);
        }
        if (((inputText || "").match(/[a-egopquvxyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[a-egopquvxyz]/g).length;
          signWidth += stripfloat(lettercountfont * 4.7269 * 1.142);
        }
        if (((inputText || "").match(/[hkns]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[hkns]/g).length;
          signWidth += stripfloat(lettercountfont * 4.7269 * 1.015);
        }
        if (((inputText || "").match(/[f]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[f]/g).length;
          signWidth += stripfloat(lettercountfont * 4.7269 * 0.783);
        }
        if (((inputText || "").match(/[jr]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[jr]/g).length;
          signWidth += stripfloat(lettercountfont * 4.7269 * 0.677);
        }
        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 4.7269 * 0.148);
        }
        if (((inputText || "").match(/[t]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[t]/g).length;
          signWidth += stripfloat(lettercountfont * 4.7269 * 0.487);
        }

        //numbers
        if (((inputText || "").match(/[9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[9]/g).length;
          signWidth += stripfloat(lettercountfont * 5.3 * 1.396);
        }
        if (((inputText || "").match(/[02-8]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02-8]/g).length;
          signWidth += stripfloat(lettercountfont * 5.3 * 1.019);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 5.3 * 0.453);
        }

        //punctuations
        if (((inputText || "").match(/[$=€&÷_~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$=€&÷_~]/g).length;
          signWidth += stripfloat(lettercountfont * 3.453 * 1.68);
        }
        if (((inputText || "").match(/[¢+#?\\<>\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢+#?\\<>\/]/g).length;
          signWidth += stripfloat(lettercountfont * 3.453 * 1.3);
        }
        if (((inputText || "").match(/["*^()-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/["*^()-]/g).length;
          signWidth += stripfloat(lettercountfont * 3.453 * 0.67);
        }
        if (((inputText || "").match(/['|:!]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/['|:!]/g).length;
          signWidth += stripfloat(lettercountfont * 3.453 * 0.2);
        }
        if (((inputText || "").match(/[{},.;`[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[{},.;`[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 3.453 * 0.38);
        }
        if (((inputText || "").match(/[%@¥]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[%@¥]/g).length;
          signWidth += stripfloat(lettercountfont * 3.453 * 2.14);
        }

        return stripfloat(signWidth);
        break;

      case "Spaceship2100":
        if (((inputText || "").match(/[BCMQWY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BCMQWY]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 1.319);
        }
        if (((inputText || "").match(/[ADEGHOPSZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ADEGHOPSZ]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 1.182);
        }
        if (((inputText || "").match(/[NUV]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[NUV]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 1.072);
        }
        if (((inputText || "").match(/[RX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[RX]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 0.797);
        }
        if (((inputText || "").match(/[KT]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[KT]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 0.659);
        }
        if (((inputText || "").match(/[J]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[J]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 0.495);
        }
        if (((inputText || "").match(/[FI]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[FI]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 0.357);
        }
        if (((inputText || "").match(/[L]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[L]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6385 * 0.219);
        }
        //lowercase
        if (((inputText || "").match(/[bdeowy]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[bdeowy]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6038 * 1.034);
        }
        if (((inputText || "").match(/[acghmnpqsz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[acghmnpqsz]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6038 * 1.193);
        }
        if (((inputText || "").match(/[uv]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[uv]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6038 * 1.054);
        }
        if (((inputText || "").match(/[kr]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[kr]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6038 * 0.777);
        }
        if (((inputText || "").match(/[jx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[jx]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6038 * 0.638);
        }
        if (((inputText || "").match(/[ft]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ft]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6038 * 0.444);
        }
        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 3.6038 * 0.222);
        }
        //numbers
        if (((inputText || "").match(/[025789]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[025789]/g).length;
          signWidth += stripfloat(lettercountfont * 4.11 * 1.119);
        }
        if (((inputText || "").match(/[36]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[36]/g).length;
          signWidth += stripfloat(lettercountfont * 4.11 * 1.022);
        }
        if (((inputText || "").match(/[4]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[4]/g).length;
          signWidth += stripfloat(lettercountfont * 4.11 * 0.925);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 4.11 * 0.341);
        }
        //punctuations
        if (((inputText || "").match(/[$€@&_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$€@&_]/g).length;
          signWidth += stripfloat(lettercountfont * 2.315 * 1.94);
        }
        if (((inputText || "").match(/[!:;.,|']/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[!:;.,|']/g).length;
          signWidth += stripfloat(lettercountfont * 2.315 * 0.39);
        }
        if (((inputText || "").match(/[<>`^{}"#*]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[<>`^{}"#*]/g).length;
          signWidth += stripfloat(lettercountfont * 2.315 * 0.6);
        }
        if (((inputText || "").match(/[~()=%+\[\]-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[~()=%+\[\]-]/g).length;
          signWidth += stripfloat(lettercountfont * 2.315 * 1.08);
        }
        if (((inputText || "").match(/[\/#?\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\/#?\\]/g).length;
          signWidth += stripfloat(lettercountfont * 2.315 * 1.64);
        }

        return stripfloat(signWidth);
        break;

      case "Southland":
        if (((inputText || "").match(/[W]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/g).length;
          signWidth += stripfloat(lettercountfont * 2.4692 * 1.498);
        }
        if (((inputText || "").match(/[BFGIMTX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BFGIMTX]/g).length;
          signWidth += stripfloat(lettercountfont * 2.4692 * 1.134);
        }
        if (((inputText || "").match(/[ACDEHJKLNO-SUVYZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ACDEHJKLNO-SUVYZ]/g).length;
          signWidth += stripfloat(lettercountfont * 2.4692 * 0.931);
        }

        if (((inputText || "").match(/[z]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[z]/g).length;
          signWidth += stripfloat(lettercountfont * 1.4115 * 1.559);
        }
        if (((inputText || "").match(/[ghjptwfy]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ghjptwfy]/g).length;
          signWidth += stripfloat(lettercountfont * 1.4115 * 1.204);
        }
        if (((inputText || "").match(/[a-eik-oqrsuvx]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[a-eik-oqrsuvx]/g).length;
          signWidth += stripfloat(lettercountfont * 1.4115 * 0.921);
        }

        if (((inputText || "").match(/[02-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02-9]/g).length;
          signWidth += stripfloat(lettercountfont * 1.21 * 0.99);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 1.21 * 0.58);
        }

        if (
          ((inputText || "").match(/[`,.;:\[\]<>{}^|\\!'"%=÷\/+\*$-]/g) || [])
            .length > 0
        ) {
          var lettercountfont = inputText.match(
            /[`,.;:\[\]<>{}^|\\!'"%=÷\/+\*$-]/g
          ).length;
          signWidth += stripfloat(lettercountfont * 0.784 * 0.76);
        }
        if (((inputText || "").match(/[¢€£¥#@()?~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[¢€£¥#@()?~]/g).length;
          signWidth += stripfloat(lettercountfont * 0.784 * 1.53);
        }
        if (((inputText || "").match(/[&_]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[&_]/g).length;
          signWidth += stripfloat(lettercountfont * 0.784 * 2.23);
        }
        return stripfloat(signWidth);
        break;

      case "Samantha":
        if (((inputText || "").match(/[HWX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[HWX]/g).length;
          signWidth += stripfloat(lettercountfont * 4.8538 * 1.298);
        }
        if (((inputText || "").match(/[KMU]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[KMU]/g).length;
          signWidth += stripfloat(lettercountfont * 4.8538 * 1.174);
        }
        if (((inputText || "").match(/[ALORTZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ALORTZ]/g).length;
          signWidth += stripfloat(lettercountfont * 4.8538 * 1.092);
        }
        if (((inputText || "").match(/[BDFGNPQVY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BDFGNPQVY]/g).length;
          signWidth += stripfloat(lettercountfont * 4.8538 * 0.968);
        }
        if (((inputText || "").match(/[EJ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[EJ]/g).length;
          signWidth += stripfloat(lettercountfont * 4.8538 * 0.865);
        }
        if (((inputText || "").match(/[CS]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CS]/g).length;
          signWidth += stripfloat(lettercountfont * 4.8538 * 0.783);
        }
        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 4.8538 * 0.453);
        }

        if (((inputText || "").match(/[djt]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[djt]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7923 * 1.325);
        }
        if (((inputText || "").match(/[bgmwyz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[bgmwyz]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7923 * 1.146);
        }
        if (((inputText || "").match(/[achnoqrux]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[achnoqrux]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7923 * 0.967);
        }
        if (((inputText || "").match(/[efklpsv]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[efklpsv]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7923 * 0.824);
        }
        if (((inputText || "").match(/[i]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[i]/g).length;
          signWidth += stripfloat(lettercountfont * 2.7923 * 0.68);
        }

        if (((inputText || "").match(/[02-6]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02-6]/g).length;
          signWidth += stripfloat(lettercountfont * 2.45 * 1.102);
        }
        if (((inputText || "").match(/[789]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[789]/g).length;
          signWidth += stripfloat(lettercountfont * 2.45 * 1.02);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 2.45 * 0.367);
        }

        if (((inputText || "").match(/[!;:.,'"`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[!;:.,'"`]/g).length;
          signWidth += stripfloat(lettercountfont * 1.611 * 0.44);
        }
        if (
          ((inputText || "").match(/[\[\]{}<>()=+\/*~^-]/g) || []).length > 0
        ) {
          var lettercountfont = inputText.match(/[\[\]{}<>()=+\/*~^-]/g).length;
          signWidth += stripfloat(lettercountfont * 1.611 * 0.93);
        }
        if (((inputText || "").match(/[$%#_?\\]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$%#_?\\]/g).length;
          signWidth += stripfloat(lettercountfont * 1.611 * 1.36);
        }
        if (((inputText || "").match(/[@&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@&]/g).length;
          signWidth += stripfloat(lettercountfont * 1.611 * 2.2);
        }

        return stripfloat(signWidth);
        break;
      //Width
      case "JackArmstrong":
        if (((inputText || "").match(/[W]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 1.327);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[M]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[M]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 1.233);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[AG]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[AG]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 1.195);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[C]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[C]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 1.132);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[B]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[B]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 1.082);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[DY]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[DY]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 1.05);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[EP]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[EP]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 1.025);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[HR]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[HR]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 0.994);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[FKQTVZ]/gi) || []).length > 0) {
          console.log(
            tempHeight + "TempHeight" + "EarlierSign-Width:" + signWidth
          );
          var lettercountfont = inputText.match(/[FKQTVZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 0.962);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[S]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[S]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 0.937);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[JOU]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[JOU]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 0.899);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[X]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[X]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 0.862);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }
        if (((inputText || "").match(/[INL]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[INL]/gi).length;
          signWidth += stripfloat(lettercountfont * 15.9 * 0.834);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }

        //number

        if (((inputText || "").match(/[6]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[6]/g).length;
          signWidth += stripfloat(lettercountfont * 14.48 * 1.215);
        }
        if (((inputText || "").match(/[23]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[23]/g).length;
          signWidth += stripfloat(lettercountfont * 14.48 * 1.188);
        }
        if (((inputText || "").match(/[4]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[4]/g).length;
          signWidth += stripfloat(lettercountfont * 14.48 * 1.139);
        }
        if (((inputText || "").match(/[07]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[07]/g).length;
          signWidth += stripfloat(lettercountfont * 14.48 * 1.049);
        }
        if (((inputText || "").match(/[589]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[589]/g).length;
          signWidth += stripfloat(lettercountfont * 14.48 * 0.988);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          console.log(
            tempHeight + "TempHeight" + "EarlierSign-Width:" + signWidth
          );
          signWidth += stripfloat(lettercountfont * 14.48 * 0.242);
          console.log(tempHeight + "TempHeight" + "Sign-Width:" + signWidth);
        }

        //punctuations
        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.862);
        }
        if (((inputText || "").match(/[%]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[%]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.742);
        }
        if (((inputText || "").match(/[&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[&]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.413);
        }
        if (((inputText || "").match(/[?#]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[?#]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.381);
        }
        if (((inputText || "").match(/[\^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[^]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.325);
        }
        if (((inputText || "").match(/[~]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[~]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.26);
        }
        if (((inputText || "").match(/[\<\>\{\}]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\<\>\{\}]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.228);
        }
        if (((inputText || "").match(/[\=]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\=]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.052);
        }
        if (((inputText || "").match(/[%\-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[%\-]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 1.036);
        }
        if (((inputText || "").match(/[\[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 0.987);
        }
        if (((inputText || "").match(/[\(\)\+\"*]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\(\)\+\"*]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 0.939);
        }
        if (((inputText || "").match(/[\,\'\;]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\,\'\;]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 0.506);
        }
        if (((inputText || "").match(/[\.\:\|!]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\.\:\|!]/g).length;
          signWidth += stripfloat(lettercountfont * 12.457 * 0.353);
        }

        return stripfloat(signWidth);
        break;

      case "Breamcatcher":
        if (((inputText || "").match(/[W]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.715 * 2.025);
        }
        if (((inputText || "").match(/[R]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[R]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.715 * 1.326);
        }
        if (((inputText || "").match(/[AKMOQUVXY]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[AKMOQUVXY]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.715 * 1.215);
        }
        if (((inputText || "").match(/[N]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[N]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.715 * 0.994);
        }
        if (((inputText || "").match(/[B-HLPSTZ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[B-HLPSTZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.715 * 0.847);
        }
        if (((inputText || "").match(/[J]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[J]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.715 * 0.662);
        }
        if (((inputText || "").match(/[I]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/gi).length;
          signWidth += stripfloat(lettercountfont * 2.715 * 0.295);
        }

        //number

        if (((inputText || "").match(/[48]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[48]/g).length;
          signWidth += stripfloat(lettercountfont * 2.47 * 1.215);
        }
        if (((inputText || "").match(/[69]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[69]/g).length;
          signWidth += stripfloat(lettercountfont * 2.47 * 1.093);
        }
        if (((inputText || "").match(/[02357]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[02357]/g).length;
          signWidth += stripfloat(lettercountfont * 2.47 * 1.012);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 2.47 * 0.405);
        }

        //punctuations
        if (((inputText || "").match(/[\‰]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\‰]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 1.922);
        }
        if (((inputText || "").match(/[\¤\÷]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\¤\÷]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 1.657);
        }
        if (((inputText || "").match(/[-\©\®\+]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[-\©\®\+]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 1.558);
        }
        if (((inputText || "").match(/[\=\%\#\~\™\µ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\=\%\#\~\™\µ]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 1.425);
        }
        if (((inputText || "").match(/[\*\@\<\>\¶\^]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\*\@\<\>\¶\^]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 1.226);
        }
        if (
          ((inputText || "").match(/[\¥\£\/\&\_\\\{\}\§]/g) || []).length > 0
        ) {
          var lettercountfont = inputText.match(/[\¥\£\/\&\_\\\{\}\§]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 1.094);
        }
        if (((inputText || "").match(/[\¢\€\(\)]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\¢\€\(\)]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 0.895);
        }
        if (((inputText || "").match(/[\$\?\¿\[\]]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\$\?\¿\[\]]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 0.762);
        }
        if (((inputText || "").match(/[-\"\`]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[-\"\`]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 0.563);
        }
        if (((inputText || "").match(/[\.\,\;\:\!\¡\,]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\.\,\;\:\!\¡\,]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 0.431);
        }
        if (((inputText || "").match(/[\'\|]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\'\|]/g).length;
          signWidth += stripfloat(lettercountfont * 3.017 * 0.232);
        }

        return stripfloat(signWidth);
        break;
      case "FancyMatter":
        if (((inputText || "").match(/[EGSO]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[EGSO]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 0.64);
        }
        if (((inputText || "").match(/[CIJQ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CIJQ]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 0.73);
        }
        if (((inputText || "").match(/[AZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[AZ]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 1);
        }
        if (((inputText || "").match(/[BDFKPRVY]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[BDFKPRVY]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 1.1);
        }
        if (((inputText || "").match(/[HUT]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[HUT]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 1.19);
        }
        if (((inputText || "").match(/[MNX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MNX]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 1.29);
        }
        if (((inputText || "").match(/[W]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 1.41);
        }

        if (((inputText || "").match(/[L]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[L]/g).length;
          signWidth += stripfloat(lettercountfont * 6.823 * 0.86);
        }

        if (((inputText || "").match(/[il]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[il]/g).length;
          signWidth += stripfloat(lettercountfont * 3.631 * 0.5);
        }
        if (((inputText || "").match(/[cfstve]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[cfstve]/g).length;
          signWidth += stripfloat(lettercountfont * 3.631 * 0.72);
        }
        if (((inputText || "").match(/[abdjkopu]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[abdjkopu]/g).length;
          signWidth += stripfloat(lettercountfont * 3.631 * 1.02);
        }
        if (((inputText || "").match(/[ghnrxy]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ghnrxy]/g).length;
          signWidth += stripfloat(lettercountfont * 3.631 * 1.13);
        }
        if (((inputText || "").match(/[qz]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[qz]/g).length;
          signWidth += stripfloat(lettercountfont * 3.631 * 1.31);
        }

        if (((inputText || "").match(/[w]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[w]/g).length;
          signWidth += stripfloat(lettercountfont * 3.631 * 2.01);
        }

        if (((inputText || "").match(/[m]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[m]/g).length;
          signWidth += stripfloat(lettercountfont * 3.631 * 1.31);
        }

        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.67 * 0.68);
        }
        if (((inputText || "").match(/[6-9]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[6-9]/g).length;
          signWidth += stripfloat(lettercountfont * 3.67 * 0.95);
        }
        if (((inputText || "").match(/[0345]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0345]/g).length;
          signWidth += stripfloat(lettercountfont * 3.67 * 1.08);
        }
        if (((inputText || "").match(/[2]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[2]/g).length;
          signWidth += stripfloat(lettercountfont * 3.67 * 1.25);
        }

        //punctuation
        if (((inputText || "").match(/[@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[@]/g).length;
          signWidth += stripfloat(lettercountfont * 1.154 * 2.34);
        }
        if (((inputText || "").match(/[#\&]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#\&]/g).length;
          signWidth += stripfloat(lettercountfont * 1.154 * 1.994);
        }
        if (((inputText || "").match(/[$?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$?]/g).length;
          signWidth += stripfloat(lettercountfont * 1.154 * 1.474);
        }
        if (
          ((inputText || "").match(/[\%\(\)-\+\=\{\}\[\]\<\>]/g) || []).length >
          0
        ) {
          var lettercountfont = inputText.match(
            /[\%\(\)-\+\=\{\}\[\]\<\>]/g
          ).length;
          signWidth += stripfloat(lettercountfont * 1.154 * 1.127);
        }
        if (((inputText || "").match(/[\!\*\_\|\"]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\!\*\_\|\"]/g).length;
          signWidth += stripfloat(lettercountfont * 1.154 * 0.78);
        }
        if (((inputText || "").match(/[\^\\\;\'\:\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\^\\\;\'\:\/]/g).length;
          signWidth += stripfloat(lettercountfont * 1.154 * 0.26);
        }

        return stripfloat(signWidth);
        break;

      case "ChildHappy":
        if (((inputText || "").match(/[I]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/g).length;
          signWidth += stripfloat(lettercountfont * 4.332 * 0.28);
        }
        if (((inputText || "").match(/[FJKLPS]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[FJKLPS]/g).length;
          signWidth += stripfloat(lettercountfont * 4.332 * 0.88);
        }
        if (((inputText || "").match(/[ABDEGRTVYZ]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[ABDEGRTVYZ]/g).length;
          signWidth += stripfloat(lettercountfont * 4.332 * 1);
        }
        if (((inputText || "").match(/[CHNOQUX]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[CHNOQUX]/g).length;
          signWidth += stripfloat(lettercountfont * 4.332 * 1.11);
        }
        if (((inputText || "").match(/[MW]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[MW]/g).length;
          signWidth += stripfloat(lettercountfont * 4.332 * 1.36);
        }

        if (((inputText || "").match(/[i]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[i]/g).length;
          signWidth += stripfloat(lettercountfont * 3.688 * 0.27);
        }
        if (((inputText || "").match(/[cfstvzbpqlg]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[cfstvzbpqlg]/g).length;
          signWidth += stripfloat(lettercountfont * 3.688 * 0.95);
        }
        if (((inputText || "").match(/[acdehjkvyrxnu]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[acdehjkvyrxnu]/g).length;
          signWidth += stripfloat(lettercountfont * 3.688 * 1.02);
        }
        if (((inputText || "").match(/[o]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[o]/g).length;
          signWidth += stripfloat(lettercountfont * 3.688 * 1.2);
        }
        if (((inputText || "").match(/[mw]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[mw]/g).length;
          signWidth += stripfloat(lettercountfont * 3.688 * 1.53);
        }

        if (((inputText || "").match(/[0]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[0]/g).length;
          signWidth += stripfloat(lettercountfont * 3.43 * 1.34);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 3.43 * 0.44);
        }
        if (((inputText || "").match(/[2-578]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[2-578]/g).length;
          signWidth += stripfloat(lettercountfont * 3.43 * 1);
        }
        if (((inputText || "").match(/[69]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[69]/g).length;
          signWidth += stripfloat(lettercountfont * 3.43 * 1.17);
        }

        //punctuation
        if (((inputText || "").match(/[%@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[%@]/g).length;
          signWidth += stripfloat(lettercountfont * 1.386 * 2.237);
        }
        if (((inputText || "").match(/[#\&\_\<\>]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[#\&\_\<\>]/g).length;
          signWidth += stripfloat(lettercountfont * 1.386 * 1.588);
        }
        if (((inputText || "").match(/[$\+\=\?]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[$\+\=\?]/g).length;
          signWidth += stripfloat(lettercountfont * 1.386 * 1.227);
        }
        if (((inputText || "").match(/[\^\*-\{\}\\\/]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\^\*-\{\}\\\/]/g).length;
          signWidth += stripfloat(lettercountfont * 1.386 * 0.938);
        }
        if (((inputText || "").match(/[\(\)\[\]\"\:]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\(\)\[\]\"\:]/g).length;
          signWidth += stripfloat(lettercountfont * 1.386 * 0.505);
        }
        if (((inputText || "").match(/[\!\|\;\']/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[\!\|\;\']/g).length;
          signWidth += stripfloat(lettercountfont * 1.386 * 0.216);
        }
        return stripfloat(signWidth);
        break;

      case "Retrolight":
        if (((inputText || "").match(/[W]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[W]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 1.908);
        }
        if (((inputText || "").match(/[M]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[M]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 1.228);
        }
        if (((inputText || "").match(/[AOQ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[AOQ]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 1.161);
        }
        if (((inputText || "").match(/[CVY]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[CVY]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 1.121);
        }
        if (((inputText || "").match(/[DGX]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[DGX]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 1.028);
        }
        if (((inputText || "").match(/[BHKNRTUZ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[BHKNRTUZ]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 0.974);
        }
        if (((inputText || "").match(/[ELPS]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[ELPS]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 0.894);
        }
        if (((inputText || "").match(/[FJ]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[FJ]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 0.841);
        }
        if (((inputText || "").match(/[I]/gi) || []).length > 0) {
          var lettercountfont = inputText.match(/[I]/gi).length;
          signWidth += stripfloat(lettercountfont * 7.492 * 0.268);
        }

        //number

        if (((inputText || "").match(/[456890]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[456890]/g).length;
          signWidth += stripfloat(lettercountfont * 6.6 * 1.106);
        }
        if (((inputText || "").match(/[23]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[23]/g).length;
          signWidth += stripfloat(lettercountfont * 6.6 * 1.015);
        }
        if (((inputText || "").match(/[7]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[7]/g).length;
          signWidth += stripfloat(lettercountfont * 6.6 * 0.954);
        }
        if (((inputText || "").match(/[1]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[1]/g).length;
          signWidth += stripfloat(lettercountfont * 6.6 * 0.485);
        }

        if (((inputText || "").match(/[!|\[\]^();"':.`,]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[!|\[\]^();"':.,]/g).length;
          signWidth += stripfloat(lettercountfont * 1.34 * 0.56);
        }
        if (((inputText || "").match(/[*{}<>~-]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[*{}<>~-]/g).length;
          signWidth += stripfloat(lettercountfont * 1.34 * 1);
        }
        if (((inputText || "").match(/[?\/\\=_&#$]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[?\/\\=_&#$]/g).length;
          signWidth += stripfloat(lettercountfont * 1.34 * 1.31);
        }
        if (((inputText || "").match(/[%@]/g) || []).length > 0) {
          var lettercountfont = inputText.match(/[%@]/g).length;
          signWidth += stripfloat(lettercountfont * 1.34 * 1.94);
        }

        return stripfloat(signWidth);
        break;
    }
  });
  // console.log(maxWidth);
  var maxLength = Math.max.apply(this, maxWidth);
  console.log("Max-Width" + maxWidth);

  var maxHeightTotal = Math.max.apply(this, maxHeight);
  console.log(maxHeightTotal);
  // console.log(maxHeight);
  maxHeight = maxHeight.filter(Number);
  const sum = maxHeight.reduce((partialSum, a) => partialSum + a, 0);

  // $(".width_text").html(Math.round(maxLength) + "cm");
  $(".height_text").html(Math.round(sum) + "cm");

  var newwidth2 = stripfloat(maxLength / tempHeight);
  var newheight2 = stripfloat(sum * heightMulti);

  // console.log(newwidth2+"New WIdth without multi");

  var textlinelength = $("#input_text").val().split("\n");
  var temptextlinelength = textlinelength;
  var lineheight = 0;

  if (textlinelength.slice(-1) == "") {
    textlinelength.pop();
  }

  if (textlinelength.length == 0 || textlinelength.length == 1) {
    lineheight = 1;
  } else {
    inputText = $("#input_text").val();
    lineheight = 0;
    switch (selectedFont) {
      case "RMPlaytime":
        lineheight = 0;
        $(".text_show").css("line-height", "36%");
        $("#text").css("line-height", "36%");
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.37;
        if (
          (inputText || "").match(/[a-z]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "49%");
          $("#text").css("line-height", "49%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.15;
        }

        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "40%");
          $("#text").css("line-height", "40%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.24;
        }

        if (
          (inputText || "").match(/[A-Z]/gm) &&
          (inputText || "").match(/[a-z]/gm)
        ) {
          $(".text_show").css("line-height", "40%");
          $("#text").css("line-height", "40%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.24;
        }

        if (
          (inputText || "").match(/[A-Z]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.15;
        }

        break;
      case "JackArmstrong":
        lineheight = 0;

        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.1;
        break;
      case "AmsterdamGraffiti":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.05;
        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.08;
        }

        if ((inputText || "").match(/[qwy]/gi)) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.15;
        }

        break;
      case "Breamcatcher":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.06;
        if ((inputText || "").match(/[jq]/gi)) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.06;
        }
        break;
      case "Elegant":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.08;
        if ((inputText || "").match(/[aceimnosuvwxz]/gm)) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight = textlinelength.length + (textlinelength.length - 1) * 1;
        }

        if ((inputText || "").match(/[r]/gm)) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.9;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "75%");
          $("#text").css("line-height", "75%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.05;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "110%");
          $("#text").css("line-height", "110%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.01;
        }
        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.07;
        }
        if (
          (inputText || "").match(/[A-Z0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "110%");
          $("#text").css("line-height", "110%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        break;
      case "Samantha":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.1;
        if ((inputText || "").match(/[aceimnorsuvwx]/gm)) {
          $(".text_show").css("line-height", "70%");
          $("#text").css("line-height", "70%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "115%");
          $("#text").css("line-height", "115%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if ((inputText || "").match(/[bdhklt]/gm)) {
          $(".text_show").css("line-height", "130%");
          $("#text").css("line-height", "130%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if ((inputText || "").match(/[fgjpqyz]/gm)) {
          $(".text_show").css("line-height", "180%");
          $("#text").css("line-height", "180%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "180%");
          $("#text").css("line-height", "180%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "175%");
          $("#text").css("line-height", "175%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          ((inputText || "").match(/[A-Z]/gm) &&
            (inputText || "").match(/[fgjpqyz]/gm)) ||
          (inputText || "").match(/[GJQYZ]/gm)
        ) {
          $(".text_show").css("line-height", "200%");
          $("#text").css("line-height", "200%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.05;
        }

        break;

      case "AvalonChaligraphy":
        lineheight = 0;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight = textlinelength.length + (textlinelength.length - 1) * 1;
        }

        if ((inputText || "").match(/[bdhklt]/gm)) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "130%");
          $("#text").css("line-height", "130%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "130%");
          $("#text").css("line-height", "130%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "95%");
          $("#text").css("line-height", "95%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if (
          (inputText || "").match(/[A-Z0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "140%");
          $("#text").css("line-height", "140%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if (
          (inputText || "").match(/[A-Z0-9]/gm) &&
          (inputText || "").match(/[GJY]/gm)
        ) {
          $(".text_show").css("line-height", "165%");
          $("#text").css("line-height", "165%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        break;
      case "PaperFlowers":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.2;

        break;
      case "Retrolight":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.3;
        if ((inputText || "").match(/[qQ]/gm)) {
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.23;
        }
        break;
      case "Technology":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.45;
        break;
      case "BombFont":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.15;
        break;
      case "FancyMatter":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.2;
        if ((inputText || "").match(/[aceimnosuvwxz]/gm)) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.3;
        }

        if ((inputText || "").match(/[bdhklt]/gm)) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "130%");
          $("#text").css("line-height", "130%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "130%");
          $("#text").css("line-height", "130%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.2;
        }
        if (
          (inputText || "").match(/[A-Z0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "140%");
          $("#text").css("line-height", "140%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if (
          (inputText || "").match(/[a-zA-Z0-9]/gm) &&
          (inputText || "").match(/[GLY]/gm)
        ) {
          $(".text_show").css("line-height", "140%");
          $("#text").css("line-height", "140%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.06;
        }

        if (
          (inputText || "").match(/[a-z]/gm) &&
          (inputText || "").match(/[r]/gm)
        ) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        break;
      case "ChildHappy":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.1;
        if ((inputText || "").match(/[a-z]/gm)) {
          $(".text_show").css("line-height", "60%");
          $("#text").css("line-height", "60%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.2;
        }

        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.15;
        }

        if (
          (inputText || "").match(/[a-zA-Z0-9]/gm) &&
          (inputText || "").match(/[q]/gm)
        ) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.07;
        }
        break;
      case "Blinkest":
        lineheight = 0;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "30%");
          $("#text").css("line-height", "30%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.45;
        }

        if (
          (inputText || "").match(/[a-z]/gm) &&
          (inputText || "").match(/[w]/gm)
        ) {
          $(".text_show").css("line-height", "30%");
          $("#text").css("line-height", "30%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.25;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.01;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "80%");
          $("#text").css("line-height", "80%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "75%");
          $("#text").css("line-height", "75%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "95%");
          $("#text").css("line-height", "95%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        break;
      case "Walkway":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.05;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.2;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "75%");
          $("#text").css("line-height", "75%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.01;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "95%");
          $("#text").css("line-height", "95%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }
        break;
      case "DolceVita":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.35;
        break;
      case "Spaceship2100":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.24;
        if ((inputText || "").match(/[aceimnorsuvwxzz]/gi)) {
          $(".text_show").css("line-height", "55%");
          $("#text").css("line-height", "55%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.3;
        }

        if (
          (inputText || "").match(/[bdfhklt0-9]/gi) ||
          (inputText || "").match(/[gjpqy0-9]/gi)
        ) {
          $(".text_show").css("line-height", "75%");
          $("#text").css("line-height", "75%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.01;
        }
        if (
          (inputText || "").match(/[bdfhklt]/gi) &&
          (inputText || "").match(/[gjpqy]/gi)
        ) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        // if ((inputText || "").match(/[A-Z]/gm)) {
        //   $(".text_show").css("line-height", "90%");
        //   $("#text").css("line-height", "90%");
        //   lineheight = 0;
        //   lineheight =
        //     textlinelength.length + (textlinelength.length - 1) * 0.23;
        // }
        // if (
        //   (inputText || "").match(/[A-Z]/gm) &&
        //   (inputText || "").match(/[fgjpqyz]/gm)
        // ) {
        //   $(".text_show").css("line-height", "90%");
        //   $("#text").css("line-height", "90%");
        //   lineheight = 0;
        //   lineheight =
        //     textlinelength.length + (textlinelength.length - 1) * 0.1;
        // }
        break;
      case "LettersForLearners":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.13;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.23;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "60%");
          $("#text").css("line-height", "60%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.01;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "80%");
          $("#text").css("line-height", "80%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "85%");
          $("#text").css("line-height", "85%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.33;
        }
        break;
      case "Beautica":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.16;
        if ((inputText || "").match(/[aceimnosuvwxz]/gm)) {
          $(".text_show").css("line-height", "30%");
          $("#text").css("line-height", "30%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.25;
        }

        if ((inputText || "").match(/[r]/gm)) {
          $(".text_show").css("line-height", "35%");
          $("#text").css("line-height", "35%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.25;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "52%");
          $("#text").css("line-height", "52%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.01;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "78%");
          $("#text").css("line-height", "78%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.2;
        }

        if (
          (inputText || "").match(/[0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "70%");
          $("#text").css("line-height", "70%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.05;
        }

        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = textlinelength.length;
        }

        if (
          (inputText || "").match(/[A-Z]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = textlinelength.length;
        }
        break;
      case "ModernSansLight":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.5;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "72%");
          $("#text").css("line-height", "72%");
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.3;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.3;
        }

        if (
          (inputText || "").match(/[0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.33;
        }

        if (
          (inputText || "").match(/[0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.08;
        }

        break;
      case "GreatDay":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.16;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "45%");
          $("#text").css("line-height", "45%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "55%");
          $("#text").css("line-height", "55%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.2;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "65%");
          $("#text").css("line-height", "65%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if (
          (inputText || "").match(/[0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "80%");
          $("#text").css("line-height", "80%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "140%");
          $("#text").css("line-height", "140%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if (
          (inputText || "").match(/[A-Z]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "150%");
          $("#text").css("line-height", "150%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.25;
        }
        break;
      case "Southland":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.16;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "30%");
          $("#text").css("line-height", "30%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.45;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "60%");
          $("#text").css("line-height", "60%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }

        if ((inputText || "").match(/[r]/gm)) {
          $(".text_show").css("line-height", "47%");
          $("#text").css("line-height", "47%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "47%");
          $("#text").css("line-height", "47%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "80%");
          $("#text").css("line-height", "80%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.05;
        }

        if (
          (inputText || "").match(/[0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "75%");
          $("#text").css("line-height", "75%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }

        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.05;
        }
        break;
      case "PrettyGirlScript":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.8;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "60%");
          $("#text").css("line-height", "60%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.18;
        }
        if ((inputText || "").match(/[bdhklt]/gm)) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.3;
        }

        if ((inputText || "").match(/[fgjpqy]/gm)) {
          $(".text_show").css("line-height", "125%");
          $("#text").css("line-height", "125%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.2;
        }

        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          (inputText || "").match(/[A-Z0-9]/gm) &&
          (inputText || "").match(/[fgjpqy]/gi)
        ) {
          $(".text_show").css("line-height", "135%");
          $("#text").css("line-height", "135%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        break;
      case "Bearline":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.45;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.45;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.15;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "120%");
          $("#text").css("line-height", "120%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.02;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "85%");
          $("#text").css("line-height", "85%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }
        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "103%");
          $("#text").css("line-height", "103%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }
        if (
          ((inputText || "").match(/[A-Z0-9]/gm) &&
            (inputText || "").match(/[fgjpqyz]/gm)) ||
          (inputText || "").match(/[GQYZ]/gm)
        ) {
          $(".text_show").css("line-height", "122%");
          $("#text").css("line-height", "122%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.05;
        }

        break;
      case "Minimal":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.4;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.08;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqy]/gm)
        ) {
          $(".text_show").css("line-height", "70%");
          $("#text").css("line-height", "70%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.05;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqy]/gm)
        ) {
          $(".text_show").css("line-height", "94%");
          $("#text").css("line-height", "94%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.02;
        }
        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "110%");
          $("#text").css("line-height", "110%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.65;
        }
        if (
          (inputText || "").match(/[A-Z0-9]/gm) &&
          (inputText || "").match(/[fgjpqy]/gm)
        ) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.2;
        }
        break;
      case "AniTypewriter":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.35;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "70%");
          $("#text").css("line-height", "70%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.25;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "80%");
          $("#text").css("line-height", "80%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.02;
        }
        if ((inputText || "").match(/[A-Z0-9]/gm)) {
          $(".text_show").css("line-height", "85%");
          $("#text").css("line-height", "85%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          (inputText || "").match(/[A-Z0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.08;
        }
        break;
      case "Academy":
        lineheight = 0;
        lineheight = textlinelength.length + (textlinelength.length - 1) * 0.41;
        if ((inputText || "").match(/[qQ]/gm)) {
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.25;
        }
        break;

      case "AustinCapittal":
        lineheight = 0;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "50%");
          $("#text").css("line-height", "50%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.6;
        }

        if ((inputText || "").match(/[bdfht]/gm)) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.04;
        }

        if (
          (inputText || "").match(/[bdfht]/gm) &&
          (inputText || "").match(/[gjklpqy]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "100%");
          $("#text").css("line-height", "100%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.11;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "85%");
          $("#text").css("line-height", "85%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.18;
        }

        if (
          (inputText || "").match(/[0-9]/gm) &&
          (inputText || "").match(/[gjklpqy]/gm)
        ) {
          $(".text_show").css("line-height", "90%");
          $("#text").css("line-height", "90%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.11;
        }

        if (
          (inputText || "").match(/[A-Z]/gm) &&
          (inputText || "").match(/[bdfghjklpqty]/gi)
        ) {
          $(".text_show").css("line-height", "110%");
          $("#text").css("line-height", "110%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.13;
        }

        break;
      case "JulyIt":
        lineheight = 0;
        if ((inputText || "").match(/[aceiosuwx]/gm)) {
          $(".text_show").css("line-height", "40%");
          $("#text").css("line-height", "40%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.4;
        }

        if ((inputText || "").match(/[rnmv]/gm)) {
          $(".text_show").css("line-height", "45%");
          $("#text").css("line-height", "45%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.18;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "110%");
          $("#text").css("line-height", "110%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "110%");
          $("#text").css("line-height", "110%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }
        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "140%");
          $("#text").css("line-height", "140%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.02;
        }
        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "165%");
          $("#text").css("line-height", "165%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }

        if (
          (inputText || "").match(/[A-Z]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "175%");
          $("#text").css("line-height", "175%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        break;
      case "RoselinaEllis":
        lineheight = 0;
        if ((inputText || "").match(/[aceimnorsuvwxz]/gm)) {
          $(".text_show").css("line-height", "33%");
          $("#text").css("line-height", "33%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.3;
        }

        if ((inputText || "").match(/[0-9]/gm)) {
          $(".text_show").css("line-height", "55%");
          $("#text").css("line-height", "55%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.1;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) ||
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "55%");
          $("#text").css("line-height", "55%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.08;
        }

        if (
          (inputText || "").match(/[0-9]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "70%");
          $("#text").css("line-height", "70%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.02;
        }

        if (
          (inputText || "").match(/[bdhklt]/gm) &&
          (inputText || "").match(/[fgjpqyz]/gm)
        ) {
          $(".text_show").css("line-height", "75%");
          $("#text").css("line-height", "75%");
          lineheight = 0;
          lineheight =
            textlinelength.length + (textlinelength.length - 1) * 0.02;
        }
        if ((inputText || "").match(/[A-Z]/gm)) {
          $(".text_show").css("line-height", "120%");
          $("#text").css("line-height", "120%");
          lineheight = 0;
          lineheight = textlinelength.length;
        }
        break;
      default:
        lineheight = 0;
        lineheight = textlinelength.length;
        break;
    }
  }

  $(".size-box").each(function () {
    switch (selectedFontFamily) {
      case "simple":
        for (size in fontwidthnew["simple"]) {
          var heightMultiMulti = fontwidthnew["simple"][size];
          var newwidth = stripfloat(heightMultiMulti * newwidth2);
          var newheight = stripfloat(heightMultiMulti * lineheight);
          // $(".size-box[data-size='" + size + "']")
          //   .find(".s_size_w")
          //   .html("Width: " + Math.round(newwidth) + "cm");
          $(".size-box[data-size='" + size + "']")
            .find(".s_size_h")
            .html("Height: " + cmToInchesRounded(Math.round(newheight)) + (isUSMarket() ? "IN" : "cm"));
          if (diffper) {
            newheight = Math.round(
              Number(newheight) + (Number(newheight) * diffper) / 100
            );
            $(".size-box[data-size='" + size + "']")
              .find(".s_size_h")
              .html("Height: " + cmToInchesRounded(Math.round(newheight)) + (isUSMarket() ? "IN" : "cm"));
            console.log("Set Diff Height");
          }
        }
        break;
      case "fancy":
        for (size in fontwidthnew["fancy"]) {
          var heightMultiMulti = fontwidthnew["fancy"][size];
          var newwidth = stripfloat(heightMultiMulti * newwidth2);
          var newheight = stripfloat(heightMultiMulti * lineheight);
          // $(".size-box[data-size='" + size + "']")
          //   .find(".s_size_w")
          //   .html("Width: " + Math.round(newwidth) + "cm");
          $(".size-box[data-size='" + size + "']")
            .find(".s_size_h")
            .html("Height: " + cmToInchesRounded(Math.round(newheight)) + (isUSMarket() ? "IN" : "cm"));
          if (diffper) {
            newheight = Math.round(
              Number(newheight) + (Number(newheight) * diffper) / 100
            );
            $(".size-box[data-size='" + size + "']")
              .find(".s_size_h")
              .html("Height: " + cmToInchesRounded(Math.round(newheight)) + (isUSMarket() ? "IN" : "cm"));
            console.log("Set Diff Height");
          }
        }
        break;
      case "doubleline":
        for (size in fontwidthnew["doubleline"]) {
          var heightMultiMulti = fontwidthnew["doubleline"][size];
          var newwidth = stripfloat(heightMultiMulti * newwidth2);
          var newheight = stripfloat(heightMultiMulti * lineheight);
          // $(".size-box[data-size='" + size + "']")
          //   .find(".s_size_w")
          //   .html("Width: " + Math.round(newwidth) + "cm");
          $(".size-box[data-size='" + size + "']")
            .find(".s_size_h")
            .html("Height: " + cmToInchesRounded(Math.round(newheight)) + (isUSMarket() ? "IN" : "cm"));
          if (diffper) {
            newheight = Math.round(
              Number(newheight) + (Number(newheight) * diffper) / 100
            );
            $(".size-box[data-size='" + size + "']")
              .find(".s_size_h")
              .html("Height: " + cmToInchesRounded(Math.round(newheight)) + (isUSMarket() ? "IN" : "cm"));
            console.log("Set Diff Height");
          }
        }
        break;
    }
  });

  var heightMultinew = fontwidthnew[selectedFontFamily][selectedSize];
  var newwidthnew = stripfloat(heightMultinew * newwidth2);
  var newheightnew = stripfloat(heightMultinew * lineheight);
  // $(".width_text").html(Math.round(newwidthnew) + "cm");
  // $(".height_text").html(Math.round(newheightnew) + "cm");
  updateline();
}

function closeMessage2() {
  $(".loading-char").hide();
}

$(".bord_img img").click(function (e) {
  $(".bord_txt span.sign_note").text($(this).attr("name"));
  $(".bord_img img").removeClass("active");
  $(this).addClass("active");
  // console.log(".bord_img div span." + $(this).attr("data-name"));
  $(".bord_img div span.board-name").css("display", "none");
  $(".bord_img div span." + $(this).attr("data-name")).css("display", "block");
  var imgname = $(this).attr("data-name");
  var imgpath = $(this).data("img");
  $(".bord_txt .cmore").find("a").attr("href", imgpath);
  $(".bord_txt .cmore").find("a").attr("data-lightbox", imgname);
  setNewPrice();
  var inwidth = $(".size-box.active").find(".s_size_w").html();
  var inheight = $(".size-box.active").find(".s_size_h").html();
  inwidth = inwidth.replace("Width: ", "");
  inwidth = inwidth.replace("cm", "");
  inwidth = inwidth.replace("IN", "");
  inheight = inheight.replace("Height: ", "");
  inheight = inheight.replace("cm", "");
  inheight = inheight.replace("IN", "");

  if (inwidth != 0 && inheight != 0) {
    $(".main_width").show();
    $(".main_height").show();
    $(".main_width .width_text").text(inwidth + (isUSMarket() ? "IN" : "cm"));
    $(".height_text").text(inheight + (isUSMarket() ? "IN" : "cm"));
  } else {
    $(".main_width").hide();
    $(".main_height").hide();
  }
});
function readURL(event) {
  var getImagePath = URL.createObjectURL(event.target.files[0]);
  $(".demo_text").css("background-image", "url(" + getImagePath + ")");
}

$("#upload-background").on("click", function (e) {
  e.preventDefault();
  $("#bg-file").trigger("click");
});

$("#upload-background-mob").on("click", function (e) {
  e.preventDefault();
  $("#bg-file-mob").trigger("click");
});

function sizelimit() {
  var fonttype = $(".font_style")
    .find("ul")
    .find("li.active")
    .attr("data-fonttype")
    .toLowerCase();

  switch (fonttype) {


    case "fancy":
      $("#size_table .size-box[data-size='xs']").addClass("disabled");
      $("#size_table .size-box[data-size='s']").addClass("disabled");
      $("#size_table .size-box[data-size='s']").addClass("test");
      $("#size_table .size-box[data-size='xs']").off("click");
      $("#size_table .size-box[data-size='s']").off("click");

      if (
        $("#size_table .size-box[data-size='s']").hasClass("active") ||
        $("#size_table .size-box[data-size='xs']").hasClass("active")
      ) {
        $("#size_table .size-box").removeClass("active");
        $("#size_table .size-box[data-size='m']").addClass("active");
      }
     
      setClickEvents();
      break;  
    case "doubleline":
      $("#size_table .size-box[data-size='xs']").addClass("disabled");
      $("#size_table .size-box[data-size='s']").addClass("disabled");
      
      $("#size_table .size-box[data-size='xs']").off("click");
      $("#size_table .size-box[data-size='s']").off("click");

      if (
        $("#size_table .size-box[data-size='s']").hasClass("active") ||
        $("#size_table .size-box[data-size='xs']").hasClass("active")
      ) {
        $("#size_table .size-box").removeClass("active");
        $("#size_table .size-box[data-size='m']").addClass("active");
      }
      setClickEvents();
      break;


    default:
      $("#size_table .size-box").removeClass("disabled");
      setClickEvents();
      break;
  }
}

function saveValueImg() {
  // var canvas = document.querySelector("#img-canvas");
  // addContentToCanvas();
  var fontEmbedCss2 =
    '<style>@font-face { font-family: "AustinCapittal";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Austin_Capittal.woff2?v=18185634114219175299") format("woff2"); } @font-face { font-family: "JackArmstrong";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/JackArmstrong.woff2?v=2576563125808041030") format("woff2"); } @font-face { font-family: "AmsterdamGraffiti";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/AmsterdamGraffiti.woff2?v=16279379981659937049") format("woff2"); } @font-face { font-family: "Breamcatcher";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Breamcatcher-Regular.woff2?v=2941331553239173200") format("woff2"); } @font-face { font-family: "Elegant";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/ElegantDEMO.woff2?v=11656112446863033352") format("woff2"); } @font-face { font-family: "Samantha";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/samantha.woff2?v=2159698739127892017") format("woff2"); } @font-face { font-family: "AvalonChaligraphy";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/AvalonChaligraphy.woff2?v=15992971333618947812") format("woff2"); } @font-face { font-family: "PaperFlowers";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Paper_Flowers_1.woff2?v=8533548857346667497") format("woff2"); } @font-face { font-family: "Retrolight";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Retrolight_1.woff2?v=14399106001303716544") format("woff2"); } @font-face { font-family: "Technology";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Technology-Regular.woff2?v=7112124536972140816") format("woff2"); } @font-face { font-family: "BombFont";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Bomb_Font1.woff2?v=4081530101380789326") format("woff2"); } @font-face { font-family: "FancyMatter";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Fancy_Matter_1.woff2?v=2973192915714394353") format("woff2"); } @font-face { font-family: "ChildHappy";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/ChildHappy.woff2?v=12327271972422558590") format("woff2"); } @font-face { font-family: "Blinkest";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Blinkest.woff2?v=4326514917777394581") format("woff2"); } @font-face { font-family: "Walkway";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/WalkwaySemiBold.woff2?v=3707742914144486028") format("woff2"); } @font-face { font-family: "DolceVita";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/DolceVita.woff2?v=5421272802829725142") format("woff2"); } @font-face { font-family: "LettersForLearners";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/LettersforLearners.woff2?v=10415040247371965719") format("woff2"); } @font-face { font-family: "Beautica";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Beautica.woff2?v=13716742545442525508") format("woff2"); } @font-face { font-family: "RoselinaEllis";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Roselina_Ellis.woff2?v=5966410187543708545") format("woff2"); } @font-face { font-family: "ModernSansLight";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/ModernSansLight.woff2?v=12248377219332319233") format("woff2"); } @font-face { font-family: "GreatDay";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Great_Day2021.woff2?v=1915681956636756588") format("woff2"); } @font-face { font-family: "Southland";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Southland.woff2?v=11653177111012775358") format("woff2"); } @font-face { font-family: "PrettyGirlScript";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/PrettyGirlsScriptDemo.woff2?v=17423060541029772815") format("woff2"); } @font-face { font-family: "Spaceship2100";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Spaceship2100.woff2?v=11544229036258332673") format("woff2"); } @font-face { font-family: "JulyIt";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Julyit.woff2?v=10213126908244662414") format("woff2"); } @font-face { font-family: "RMPlaytime";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/RM-Playtime.woff2?v=5052400439366510956") format("woff2"); } @font-face { font-family: "Bearline";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Bearline.woff2?v=2534110479223502085") format("woff2"); } @font-face { font-family: "Minimal";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Minimal.woff2?v=5813875141588338083") format("woff2"); } @font-face { font-family: "Academy";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/Academy-Regular.woff2?v=10612480675331917583") format("woff2"); } @font-face { font-family: "AniTypewriter";  src: url("//cdn.shopify.com/s/files/1/0682/4987/8820/files/AniTypewriter.woff2?v=16169870840647081349") format("woff2"); }</style>';

  htmlToImage
    .toCanvas(document.querySelector("#text"), {
      // fontEmbedCSS: fontEmbedCss2,
      // html2canvas(document.querySelector("#text"), {
      //   // canvas: canvas,
      //   logging: false,
      //   useCORS: true,
    })
    .then(function (canvas) {
      //getHeightWidth();
      getcrop(canvas);
      // console.log("Drew on the existing canvas");
      canvas.toDataURL();
    }, false);
  // htmlToImage.toCanvas(document.getElementById('text'),{cacheBust: true, style:document.querySelector("#text").style,
  //   includeQueryParams: true,
  //   quality: 0.01, })
  // .then(function (canvas) {
  //   getcrop(canvas);
  // });

  // var html = document.querySelector("#text").outerHTML;
  //   html = fontEmbedCss2 + html;
  // rasterizeHTML.drawHTML(html,
  //                        canvas).then(function (renderResult) {
  //     console.log(renderResult);
  //   getcrop(renderResult.image);
  // }), function error(e) {
  //         console.log(e);
  //     };
}

function getSignWidth() {
  var fontwidth = {
    simple: {
      xs: 8,
      s: 9,
      m: 12,
      l: 15,
      xl: 20,
      xxl: 24,
      super: 27,
      xxxl:27,
      newsuper:33,
      megasuper:40,
    },
    fancy: {
      xs: 10,
      s: 12,
      m: 16,
      l: 20,
      xl: 27,
      xxl: 30,
      super: 36,
      xxxl:36,
      newsuper: 40,
      megasuper: 45,
    },
    doubleline: {
      m: 20,
      l: 26,
      xl: 34,
      xxl: 40,
      super: 46,
      xxxl:46,
      newsuper: 50,
      megasuper: 55,
    },
  };

  var textlength = $("#input_text").val().split("\n");
  var lengths = $.map(textlength, function (i) {
    return i.length;
  });
  var maxLength = Math.max.apply(this, lengths);
  var fontsize = $(".size-box").attr("data-size");
  var fonttype = $(".font_style")
    .find("ul")
    .find("li.active")
    .attr("data-fonttype")
    .toLowerCase();
  // $(".s_size .s_size_w").html("Width: " + fontwidth[fonttype][fontsize]);

  $(".size-box").each(function () {
    // var lengthval = $(this).find(".s_size div:eq(0)").html();
    // lengthval = lengthval.replace("Width: ", "");
    // lengthval = lengthval.replace("cm", "");
    // var signheightCM = Math.round(cropHeight / (cropWidth / lengthval));
    // if (isNaN(signheightCM)) {
    //   signheightCM = 0;
    // }
    // $(this)
    //   .find(".s_size .s_size_h")
    //   .html("Height: " + fontwidth[fonttype][fontsize] + "cm");
    // console.log("added height");
  });
}

function updateline() {
  var length = $(".size-box.active .s_size .s_size_w").html();
  length = length.replace("Width: ", "");
  length = length.replace("cm", "");
  length = length.replace("IN", "");
  console.log(length + "Lewngththueh");
  if (length > 110) {
    $(".size-notice").show();
  } else {
    $(".size-notice").hide();
  }

  var letterCount2 = $("#input_text").val().replace(/\s/g, "").length;

  if (letterCount2 != 0 && letterCount2 < 50) {
    $("#add_to_card").removeClass("disable-cart");
    $("#add_to_card").prop("disabled", false);
    $(".s_size").show();
  } else {
    $("#add_to_card").addClass("disable-cart");
    $("#add_to_card").prop("disabled", true);
    console.log("Shouldnt be running");
    console.log(letterCount2);
  }

  if (letterCount2 == 0) {
    $(".text_show").html("Neon");
    $(".s_size").hide();
    $("#add_to_card").addClass("disable-cart");
    $("#add_to_card").prop("disabled", true);
  }
}

function getcrop(canvas) {
  var currheight = $(".size-box.active .s_size .s_size_h").html();
  currheight = currheight.replace("Height: ", "");
  currheight = currheight.replace("cm", "");
  currheight = currheight.replace("IN", "");

  var LENGTHIN = currheight;

  // if ($('#input_text')) {

  // }
  var myImage = new Image();
  myImage.crossOrigin = "Anonymous";
  myImage.onload = function () {
    var imageData = removeImageBlanks(myImage); //Will return cropped image data
  };
  myImage.src = canvas.toDataURL();

  //-----------------------------------------//
  function removeImageBlanks(imageObject) {
    imgWidth = imageObject.width;
    imgHeight = imageObject.height;
    var canvas = document.createElement("canvas");
    canvas.setAttribute("width", imgWidth);
    canvas.setAttribute("height", imgHeight);
    var context = canvas.getContext("2d");
    context.drawImage(imageObject, 0, 0);

    var imageData = context.getImageData(0, 0, imgWidth, imgHeight),
      data = imageData.data,
      getRBG = function (x, y) {
        var offset = imgWidth * y + x;
        return {
          red: data[offset * 4],
          green: data[offset * 4 + 1],
          blue: data[offset * 4 + 2],
          opacity: data[offset * 4 + 3],
        };
      },
      isWhite = function (rgb) {
        // many images contain noise, as the white is not a pure #fff white
        return rgb.red > 200 && rgb.green > 200 && rgb.blue > 200;
      },
      scanY = function (fromTop) {
        var offset = fromTop ? 1 : -1;

        // loop through each row
        for (
          var y = fromTop ? 0 : imgHeight - 1;
          fromTop ? y < imgHeight : y > -1;
          y += offset
        ) {
          // loop through each column
          for (var x = 0; x < imgWidth; x++) {
            var rgb = getRBG(x, y);
            if (!isWhite(rgb)) {
              if (fromTop) {
                return y;
              } else {
                return Math.min(y + 1, imgHeight);
              }
            }
          }
        }
        return null; // all image is white
      },
      scanX = function (fromLeft) {
        var offset = fromLeft ? 1 : -1;

        // loop through each column
        for (
          var x = fromLeft ? 0 : imgWidth - 1;
          fromLeft ? x < imgWidth : x > -1;
          x += offset
        ) {
          // loop through each row
          for (var y = 0; y < imgHeight; y++) {
            var rgb = getRBG(x, y);
            if (!isWhite(rgb)) {
              if (fromLeft) {
                return x;
              } else {
                return Math.min(x + 1, imgWidth);
              }
            }
          }
        }
        return null; // all image is white
      };

    var cropTop = scanY(true),
      cropBottom = scanY(false),
      cropLeft = scanX(true),
      cropRight = scanX(false),
      cropWidth = cropRight - cropLeft,
      cropHeight = cropBottom - cropTop;

    canvas.setAttribute("width", cropWidth);
    canvas.setAttribute("height", cropHeight);
    console.log(cropWidth);
    console.log(cropHeight);
    // finally crop the guy
    canvas
      .getContext("2d")
      .drawImage(
        imageObject,
        cropLeft,
        cropTop,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight
      );
    console.log("CH" + canvas.height);
    console.log("CW" + canvas.width);

    var textlengthtemp = $("#input_text").val().split("\n");
    // cropWidth = newCanvasW;
    // if (oldCanvasH && textlengthtemp.length > 1 && textlengthtemp.length < 5) {
    //   var linediff = canvas.height - oldCanvasH * textlengthtemp.length;
    //   diffper = Math.round((linediff / canvas.height) * 100);
    //   LENGTHIN = Math.round(
    //     Number(LENGTHIN) + (Number(LENGTHIN) * diffper) / 100
    //   );
    //   var signHeightCM = Math.round((cropWidth / cropHeight) * LENGTHIN);
    //   console.log(linediff + ": Line Diff" + diffper + ": DiffPer" + LENGTHIN);

    //   $(".height_text").html(LENGTHIN + "cm");
    //   $(".width_text").html(signHeightCM + "cm");
    //   var length = [];
    //   $(".size-box").each(function () {
    //     var lengthval = $(this).find(".s_size div:eq(1)").html();
    //     lengthval = lengthval.replace("Height: ", "");
    //     lengthval = lengthval.replace("cm", "");
    //     lengthval = Math.round(
    //       Number(lengthval) + (Number(lengthval) * diffper) / 100
    //     );
    //     var signheightCM = Math.round((cropWidth / cropHeight) * lengthval);
    //     if (isNaN(signheightCM)) {
    //       signheightCM = 0;
    //     }
    //     $(this)
    //       .find(".s_size .s_size_w")
    //       .html("Width: " + signheightCM + "cm");
    //     $(this)
    //       .find(".s_size .s_size_h")
    //       .html("Height: " + lengthval + "cm");
    //   });
    // } else {
    var signHeightCM = Math.round((cropWidth / cropHeight) * LENGTHIN);
    oldCanvasH = 0;
    diffper = 0;
    $(".height_text").html(LENGTHIN + (isUSMarket() ? "IN" : "cm"));
    $(".width_text").html(signHeightCM + (isUSMarket() ? "IN" : "cm"));
    var length = [];
    $(".size-box").each(function () {
      var lengthval = $(this).find(".s_size div:eq(1)").html();
      lengthval = lengthval.replace("Height: ", "");
      lengthval = lengthval.replace("cm", "");
      lengthval = lengthval.replace("IN", "");
      var signheightCM = Math.round((cropWidth / cropHeight) * lengthval);
      if (isNaN(signheightCM)) {
        signheightCM = 0;
      }
      $(this)
        .find(".s_size .s_size_w")
        .html("Width: " + signheightCM + (isUSMarket() ? "IN" : "cm"));
    });
    // }

    if (textlengthtemp.length == 1) {
      oldCanvasH = canvas.height;
    }

    if (signHeightCM && LENGTHIN) {
      $(".main_width").show();
      $(".main_height").show();
    } else {
      $(".main_width").hide();
      $(".main_height").hide();
    }
    updateline();
  }
  // console.log(canvas.toDataURL());
  updateline();
}

function setNewPrice() {
  var simpleprice = {
    xs: {
      1: "180",
      2: "180",
      3: "243.7864078",
      4: "295.3398058",
      5: "341.6504854",
      6: "388.8349515",
      7: "433.3980583",
      8: "476.2135922",
      9: "518.1553398",
      10: "562.7184466",
      11: "600.2912621",
      12: "639.6116505",
      13: "677.184466",
      14: "714.7572816",
      15: "749.7087379",
      16: "784.6601942",
      17: "819.6116505",
      18: "853.6893204",
      19: "886.8932039",
      20: "919.223301",
      21: "950.6796117",
      22: "983.0097087",
      23: "1013.592233",
      24: "1045.92233",
      25: "1074.757282",
    },
    s: {
      1: "205",
      2: "205",
      3: "283.982684",
      4: "345.2164502",
      5: "402.9004329",
      6: "457.9220779",
      7: "513.8311688",
      8: "567.0779221",
      9: "617.6623377",
      10: "670.021645",
      11: "717.0562771",
      12: "764.978355",
      13: "812.012987",
      14: "855.4978355",
      15: "898.0952381",
      16: "943.3549784",
      17: "985.0649351",
      18: "1026.774892",
      19: "1066.709957",
      20: "1106.645022",
      21: "1145.692641",
      22: "1185.627706",
      23: "1222.900433",
      24: "1259.285714",
      25: "1294.78355",
    },

    m: {
      1: "250",
      2: "250",
      3: "337.585034",
      4: "407.3129252",
      5: "473.6394558",
      6: "537.414966",
      7: "599.4897959",
      8: "661.5646259",
      9: "720.2380952",
      10: "778.0612245",
      11: "833.3333333",
      12: "887.755102",
      13: "940.4761905",
      14: "991.4965986",
      15: "1041.666667",
      16: "1090.136054",
      17: "1138.605442",
      18: "1184.52381",
      19: "1232.142857",
      20: "1278.911565",
      21: "1322.278912",
      22: "1368.197279",
      23: "1409.863946",
      24: "1453.231293",
      25: "1494.897959",
    },
    l: {
      1: "280",
      2: "280",
      3: "390.0319489",
      4: "476.8051118",
      5: "558.2108626",
      6: "634.2492013",
      7: "713.8658147",
      8: "788.115016",
      9: "859.6805112",
      10: "930.3514377",
      11: "999.2332268",
      12: "1065.43131",
      13: "1131.629393",
      14: "1194.249201",
      15: "1253.290735",
      16: "1313.226837",
      17: "1373.162939",
      18: "1431.309904",
      19: "1486.773163",
      20: "1544.025559",
      21: "1599.488818",
      22: "1653.162939",
      23: "1705.942492",
      24: "1758.722045",
      25: "1807.028754",
    },

    xl: {
      1: "320",
      2: "320",
      3: "447.1232877",
      4: "547.0684932",
      5: "640",
      6: "728.5479452",
      7: "818.8493151",
      8: "903.0136986",
      9: "986.3013699",
      10: "1066.958904",
      11: "1145.863014",
      12: "1221.260274",
      13: "1298.410959",
      14: "1368.547945",
      15: "1437.808219",
      16: "1507.068493",
      17: "1575.452055",
      18: "1641.205479",
      19: "1705.205479",
      20: "1770.958904",
      21: "1834.082192",
      22: "1895.452055",
      23: "1955.068493",
      24: "2017.315068",
      25: "2072.547945",
    },

    super: {
      1: "360",
      2: "360",
      3: "501.3084112",
      4: "614.0186916",
      5: "717.4766355",
      6: "816.728972",
      7: "918.5046729",
      8: "1014.392523",
      9: "1106.915888",
      10: "1198.598131",
      11: "1287.757009",
      12: "1371.028037",
      13: "1456.82243",
      14: "1536.728972",
      15: "1612.429907",
      16: "1691.495327",
      17: "1768.037383",
      18: "1842.056075",
      19: "1913.551402",
      20: "1987.570093",
      21: "2059.065421",
      22: "2128.037383",
      23: "2196.168224",
      24: "2262.616822",
      25: "2326.542056",
    },

    xxxl:{
      1: "400",
2: "400",
3: "558.904109589041",
4: "683.835616438356",
5: "800",
6: "910.68493150685",
7: "1023.56164383562",
8: "1128.76712328767",
9: "1232.87671232877",
10: "1333.69863013699",
11: "1432.32876712329",
12: "1526.57534246575",
13: "1623.01369863014",
14: "1710.68493150685",
15: "1797.2602739726",
16: "1883.83561643836",
17: "1969.31506849315",
18: "2051.50684931507",
19: "2131.50684931507",
20: "2213.69863013699",
21: "2292.60273972603",
22: "2369.31506849315",
23: "2443.83561643836",
24: "2521.64383561644",
25: "2590.68493150685",
    },

    newsuper:{
      1: "450",
2: "450",
3: "626.635514018692",
4: "767.523364485982",
5: "896.845794392524",
6: "1020.91121495327",
7: "1148.1308411215",
8: "1267.99065420561",
9: "1383.64485981308",
10: "1498.2476635514",
11: "1609.69626168224",
12: "1713.78504672897",
13: "1821.02803738318",
14: "1920.91121495327",
15: "2015.53738317757",
16: "2114.36915887851",
17: "2210.04672897196",
18: "2302.57009345795",
19: "2391.93925233645",
20: "2484.46261682243",
21: "2573.83177570094",
22: "2660.04672897196",
23: "2745.21028037383",
24: "2828.27102803738",
25: "2908.17757009346",
    },

    megasuper:{
      1: "720",
2: "720",
3: "1002.61682242991",
4: "1228.03738317757",
5: "1434.95327102804",
6: "1633.45794392523",
7: "1837.00934579439",
8: "2028.78504672897",
9: "2213.83177570094",
10: "2397.19626168224",
11: "2575.51401869159",
12: "2742.05607476636",
13: "2913.64485981309",
14: "3073.45794392523",
15: "3224.85981308411",
16: "3382.99065420561",
17: "3536.07476635514",
18: "3684.11214953271",
19: "3827.10280373832",
20: "3975.14018691589",
21: "4118.1308411215",
22: "4256.07476635514",
23: "4392.33644859813",
24: "4525.23364485982",
25: "4653.08411214954",
    }
    
  };

  var fancyprice = {
    xs: {
      1: "190",
      2: "190",
      3: "257.4766355",
      4: "312.5233645",
      5: "361.3551402",
      6: "411.0747664",
      7: "458.1308411",
      8: "503.411215",
      9: "547.8037383",
      10: "594.8598131",
      11: "633.9252336",
      12: "675.6542056",
      13: "715.6074766",
      14: "754.6728972",
      15: "792.8504673",
      16: "829.2523364",
      17: "865.6542056",
      18: "902.0560748",
      19: "937.5700935",
      20: "971.3084112",
      21: "1004.158879",
      22: "1038.785047",
      23: "1071.635514",
      24: "1105.373832",
      25: "1135.560748",
    },
    s: {
      1: "215",
      2: "215",
      3: "298.3125",
      4: "362.8125",
      5: "423.7291667",
      6: "480.1666667",
      7: "539.2916667",
      8: "595.7291667",
      9: "648.5833333",
      10: "704.125",
      11: "753.3958333",
      12: "803.5625",
      13: "852.8333333",
      14: "898.5208333",
      15: "943.3125",
      16: "990.7916667",
      17: "1034.6875",
      18: "1078.583333",
      19: "1119.791667",
      20: "1161.895833",
      21: "1202.208333",
      22: "1244.3125",
      23: "1283.729167",
      24: "1322.25",
      25: "1359.875",
    },
    m: {
      1: "275",
      2: "275",
      3: "371.1601307",
      4: "447.5490196",
      5: "521.2418301",
      6: "590.4411765",
      7: "659.6405229",
      8: "727.0424837",
      9: "791.748366",
      10: "855.5555556",
      11: "915.7679739",
      12: "975.9803922",
      13: "1033.496732",
      14: "1090.114379",
      15: "1144.934641",
      16: "1197.957516",
      17: "1250.980392",
      18: "1302.205882",
      19: "1354.330065",
      20: "1405.555556",
      21: "1453.186275",
      22: "1503.513072",
      23: "1549.346405",
      24: "1596.977124",
      25: "1642.810458",
    },

    l: {
      1: "300",
      2: "300",
      3: "419.0769231",
      4: "511.3846154",
      5: "599.0769231",
      6: "681.2307692",
      7: "766.1538462",
      8: "845.5384615",
      9: "923.0769231",
      10: "998.7692308",
      11: "1072.615385",
      12: "1143.692308",
      13: "1214.769231",
      14: "1281.230769",
      15: "1344.923077",
      16: "1409.538462",
      17: "1473.230769",
      18: "1536",
      19: "1596",
      20: "1656.923077",
      21: "1716",
      22: "1774.153846",
      23: "1830.461538",
      24: "1887.692308",
      25: "1939.384615",
    },

    xl: {
      1: "350",
      2: "350",
      3: "489.4459103",
      4: "599.3403694",
      5: "700.9234828",
      6: "797.8891821",
      7: "896.701847",
      8: "989.0501319",
      9: "1080.474934",
      10: "1169.129288",
      11: "1255.013193",
      12: "1338.126649",
      13: "1422.163588",
      14: "1499.736148",
      15: "1574.538259",
      16: "1651.187335",
      17: "1725.989446",
      18: "1798.021108",
      19: "1867.282322",
      20: "1940.237467",
      21: "2008.575198",
      22: "2075.989446",
      23: "2141.556728",
      24: "2209.894459",
      25: "2269.920844",
    },

    super: {
      1: "400",
      2: "400",
      3: "519.3548387",
      4: "635.6793744",
      5: "750.3453269",
      6: "861.8931952",
      7: "968.112427",
      8: "1070.018998",
      9: "1167.719783",
      10: "1266.211668",
      11: "1361.654758",
      12: "1449.969631",
      13: "1535.261962",
      14: "1614.449158",
      15: "1690.556591",
      16: "1768.980306",
      17: "1845.857309",
      18: "1920.404663",
      19: "1991.83138",
      20: "2065.602912",
      21: "2137.02651",
      22: "2206.879904",
      23: "2275.159061",
      24: "2342.649484",
      25: "2406.184484",
    },

    xxxl:{
      1: "437.5",
2: "437.5",
3: "611.807387862797",
4: "749.175461741425",
5: "876.154353562005",
6: "997.361477572559",
7: "1120.87730870712",
8: "1236.31266490765",
9: "1350.59366754617",
10: "1461.41160949868",
11: "1568.76649076517",
12: "1672.65831134565",
13: "1777.70448548813",
14: "1874.67018469657",
15: "1968.172823219",
16: "2063.98416886543",
17: "2157.48680738786",
18: "2247.52638522427",
19: "2334.10290237467",
20: "2425.29683377309",
21: "2510.71899736148",
22: "2594.98680738786",
23: "2676.94591029024",
24: "2762.36807387863",
25: "2837.40105540897",
    },

    newsuper:{
      1: "500",
2: "500",
3: "649.193548387097",
4: "794.599217986315",
5: "937.931658660284",
6: "1077.36649394179",
7: "1210.14053368814",
8: "1337.52374776058",
9: "1459.64972911198",
10: "1582.76458480631",
11: "1702.06844798267",
12: "1812.4620383589",
13: "1919.07745238001",
14: "2018.06144729224",
15: "2113.19573818767",
16: "2211.225382666",
17: "2307.32163671599",
18: "2400.50582924359",
19: "2489.7892244141",
20: "2582.00364013314",
21: "2671.28313731653",
22: "2758.59987992741",
23: "2843.9488264887",
24: "2928.31185457968",
25: "3007.73060446049",
    },

    megasuper:{
      1: "800",
2: "800",
3: "1038.70967741935",
4: "1271.3587487781",
5: "1500.69065385645",
6: "1723.78639030687",
7: "1936.22485390102",
8: "2140.03799641692",
9: "2335.43956657917",
10: "2532.4233356901",
11: "2723.30951677227",
12: "2899.93926137424",
13: "3070.52392380802",
14: "3228.89831566759",
15: "3381.11318110027",
16: "3537.96061226561",
17: "3691.71461874558",
18: "3840.80932678974",
19: "3983.66275906256",
20: "4131.20582421303",
21: "4274.05301970645",
22: "4413.75980788385",
23: "4550.31812238192",
24: "4685.29896732748",
25: "4812.36896713678",
    },
  };

  var doubleprice = {
    m: {
      1: "350",
      2: "350",
      3: "472.0101781",
      4: "569.0839695",
      5: "662.5954198",
      6: "750.7633588",
      7: "838.0407125",
      8: "924.4274809",
      9: "1006.361323",
      10: "1087.40458",
      11: "1165.776081",
      12: "1242.483612",
      13: "1316.515299",
      14: "1387.871142",
      15: "1457.443089",
      16: "1525.231139",
      17: "1593.01919",
      18: "1657.239449",
      19: "1724.135551",
      20: "1790.139706",
      21: "1850.792172",
      22: "1915.012431",
      23: "1972.989053",
      24: "2033.641519",
      25: "2092.51009",
    },
    l: {
      1: "400",
      2: "400",
      3: "558.2733813",
      4: "682.0143885",
      5: "798.0815348",
      6: "908.3932854",
      7: "1021.582734",
      8: "1127.098321",
      9: "1230.695444",
      10: "1331.414868",
      11: "1430.215827",
      12: "1524.220624",
      13: "1619.184652",
      14: "1708.393285",
      15: "1792.805755",
      16: "1879.136691",
      17: "1964.508393",
      18: "2047.961631",
      19: "2127.577938",
      20: "2209.11271",
      21: "2287.769784",
      22: "2364.508393",
      23: "2440.28777",
      24: "2516.067146",
      25: "2585.131894",
    },
    xl: {
      1: "450",
      2: "450",
      3: "628.3367556",
      4: "768.788501",
      5: "900",
      6: "1024.743326",
      7: "1151.334702",
      8: "1269.609856",
      9: "1386.036961",
      10: "1500.616016",
      11: "1611.498973",
      12: "1716.837782",
      13: "1824.948665",
      14: "1924.743326",
      15: "2021.765914",
      16: "2119.712526",
      17: "2214.887064",
      18: "2308.213552",
      19: "2397.843943",
      20: "2490.246407",
      21: "2578.952772",
      22: "2664.887064",
      23: "2749.897331",
      24: "2835.831622",
      25: "2914.373717",
    },

    super: {
      1: "540",
      2: "540",
      3: "709.5979899",
      4: "873.5194969",
      5: "1027.037862",
      6: "1165.826762",
      7: "1301.85322",
      8: "1431.310346",
      9: "1557.650382",
      10: "1677.217657",
      11: "1792.208093",
      12: "1901.800588",
      13: "2013.719619",
      14: "2118.618057",
      15: "2218.005925",
      16: "2321.342019",
      17: "2421.514054",
      18: "2519.30278",
      19: "2613.102192",
      20: "2710.098688",
      21: "2803.893834",
      22: "2896.083471",
      23: "2985.053018",
      24: "3073.215631",
      25: "3157.333458",
    },

    xxxl:{
      1: "562.5",
2: "562.5",
3: "785.420944558522",
4: "960.985626283368",
5: "1125",
6: "1280.92915811088",
7: "1439.16837782341",
8: "1587.01232032854",
9: "1732.54620123203",
10: "1875.77002053388",
11: "2014.37371663244",
12: "2146.04722792608",
13: "2281.18583162218",
14: "2405.92915811088",
15: "2527.20739219712",
16: "2649.64065708419",
17: "2768.60882956879",
18: "2885.26694045174",
19: "2997.30492813142",
20: "3112.80800821355",
21: "3223.6909650924",
22: "3331.10882956879",
23: "3437.37166324435",
24: "3544.78952772074",
25: "3642.96714579055",
    },

    newsuper:{
      1: "675",
2: "675",
3: "886.997487437186",
4: "1091.89937108541",
5: "1283.79732733943",
6: "1457.28345265557",
7: "1627.31652537448",
8: "1789.13793249686",
9: "1947.06297779129",
10: "2096.52207072374",
11: "2240.26011670872",
12: "2377.25073533965",
13: "2517.14952374561",
14: "2648.27257112695",
15: "2772.50740636355",
16: "2901.67752406592",
17: "3026.89256700885",
18: "3149.1284749168",
19: "3266.37773938652",
20: "3387.62335978888",
21: "3504.86729230224",
22: "3620.10433893896",
23: "3731.31627240622",
24: "3841.51953929813",
25: "3946.66682208109",
    },

    megasuper:{
      1: "1080",
2: "1080",
3: "1419.1959798995",
4: "1747.03899373665",
5: "2054.07572374309",
6: "2331.65352424891",
7: "2603.70644059917",
8: "2862.62069199498",
9: "3115.30076446606",
10: "3354.43531315799",
11: "3584.41618673396",
12: "3803.60117654343",
13: "4027.43923799298",
14: "4237.23611380312",
15: "4436.01185018169",
16: "4642.68403850547",
17: "4843.02810721416",
18: "5038.60555986688",
19: "5226.20438301844",
20: "5420.1973756622",
21: "5607.78766768359",
22: "5792.16694230234",
23: "5970.10603584995",
24: "6146.43126287701",
25: "6314.66691532974",
    },
  };

  var retrolightprice = {
    m: {
      1: "437.5",
      2: "437.5",
      3: "590.01272264631",
      4: "711.354961832061",
      5: "828.24427480916",
      6: "938.454198473282",
      7: "1047.55089058524",
      8: "1155.53435114504",
      9: "1257.95165394402",
      10: "1359.25572519084",
      11: "1457.22010178117",
      12: "1553.10451551734",
      13: "1645.64412412319",
      14: "1734.8389275987",
      15: "1821.80386098732",
      16: "1906.53892428906",
      17: "1991.2739875908",
      18: "2071.54931071876",
      19: "2155.16943897705",
      20: "2237.6746321919",
      21: "2313.49021514608",
      22: "2393.76553827404",
      23: "2466.23631609789",
      24: "2542.05189905208",
      25: "2615.63761191938",
    },
    l: {
      1: "500",
      2: "500",
      3: "697.8417266",
      4: "852.5179856",
      5: "997.6019185",
      6: "1135.491607",
      7: "1276.978417",
      8: "1408.872902",
      9: "1538.369305",
      10: "1664.268585",
      11: "1787.769784",
      12: "1905.275779",
      13: "2023.980815",
      14: "2135.491607",
      15: "2241.007194",
      16: "2348.920863",
      17: "2455.635492",
      18: "2559.952038",
      19: "2659.472422",
      20: "2761.390887",
      21: "2859.71223",
      22: "2955.635492",
      23: "3050.359712",
      24: "3145.083933",
      25: "3231.414868",
    },
    xl: {
      1: "562.5",
      2: "562.5",
      3: "785.4209446",
      4: "960.9856263",
      5: "1125",
      6: "1280.929158",
      7: "1439.168378",
      8: "1587.01232",
      9: "1732.546201",
      10: "1875.770021",
      11: "2014.373717",
      12: "2146.047228",
      13: "2281.185832",
      14: "2405.929158",
      15: "2527.207392",
      16: "2649.640657",
      17: "2768.60883",
      18: "2885.26694",
      19: "2997.304928",
      20: "3112.808008",
      21: "3223.690965",
      22: "3331.10883",
      23: "3437.371663",
      24: "3544.789528",
      25: "3642.967146",
    },

    super: {
      1: "675",
      2: "675",
      3: "886.9974874",
      4: "1091.899371",
      5: "1283.797327",
      6: "1457.283453",
      7: "1627.316525",
      8: "1789.137932",
      9: "1947.062978",
      10: "2096.522071",
      11: "2240.260117",
      12: "2377.250735",
      13: "2517.149524",
      14: "2648.272571",
      15: "2772.507406",
      16: "2901.677524",
      17: "3026.892567",
      18: "3149.128475",
      19: "3266.377739",
      20: "3387.62336",
      21: "3504.867292",
      22: "3620.104339",
      23: "3731.316272",
      24: "3841.519539",
      25: "3946.666822",
    },
  };

  var fancypriceperline = {
    xs: {
      3: "95",
      4: "188",
      5: "279",
      6: "368",
      7: "455",
      8: "540",
      9: "623",
      10: "704",
    },
    s: {
      3: "110",
      4: "218",
      5: "324",
      6: "428",
      7: "530",
      8: "630",
      9: "728",
      10: "824",
    },
    m: {
      3: "140",
      4: "278",
      5: "414",
      6: "548",
      7: "680",
      8: "810",
      9: "938",
      10: "1064",
    },
    l: {
      3: "160",
      4: "318",
      5: "474",
      6: "628",
      7: "780",
      8: "930",
      9: "1078",
      10: "1224",
    },
    xl: {
      3: "190",
      4: "372",
      5: "546",
      6: "713",
      7: "873",
      8: "1023",
      9: "1165",
      10: "1298",
    },
    super: {
      3: "235",
      4: "464",
      5: "672",
      6: "867",
      7: "1049",
      8: "1224",
      9: "1389",
      10: "1549",
    },
    xxxl:{
      3: "281",
4: "555",
5: "804",
6: "1038",
7: "1256",
8: "1466",
9: "1664",
10: "1856",
    },

    newsuper:{
      3: "336",
4: "664",
5: "962",
6: "1242",
7: "1503",
8: "1755",
9: "1992",
10: "2222",
    },

    megasuper:{
      3: "402",
4: "795",
5: "1152",
6: "1487",
7: "1800",
8: "2102",
9: "2386",
10: "2662",
    }
  };

  var simplepriceperline = {
    xs: {
      3: "65",
      4: "113",
      5: "159",
      6: "203",
      7: "246",
      8: "288",
      9: "330",
      10: "372",
    },

    s: {
      3: "115",
      4: "220",
      5: "325",
      6: "423",
      7: "518",
      8: "610",
      9: "697",
      10: "779",
    },
    m: {
      3: "140",
      4: "270",
      5: "395",
      6: "515",
      7: "630",
      8: "740",
      9: "845",
      10: "940",
    },
    l: {
      3: "165",
      4: "320",
      5: "467",
      6: "603",
      7: "731",
      8: "849",
      9: "965",
      10: "1080",
    },
    xl: {
      3: "195",
      4: "385",
      5: "565",
      6: "735",
      7: "895",
      8: "1045",
      9: "1185",
      10: "1315",
    },
    super: {
      3: "235",
      4: "460",
      5: "670",
      6: "865",
      7: "1055",
      8: "1225",
      9: "1395",
      10: "1555",
    },
    xxxl:{
      3: "281",
4: "551",
5: "803",
6: "1037",
7: "1265",
8: "1469",
9: "1673",
10: "1865",
    },

    newsuper:{
      3: "336",
4: "659",
5: "961",
6: "1241",
7: "1514",
8: "1758",
9: "2002",
10: "2232",
    },
    megasuper:{
      3: "402",
4: "789",
5: "1151",
6: "1486",
7: "1813",
8: "2105",
9: "2397",
10: "2673",
    }
  };

  var doublepriceperline = {
    m: {
      3: "190",
      4: "370",
      5: "540",
      6: "700",
      7: "850",
      8: "1000",
      9: "1145",
      10: "1280",
    },
    l: {
      3: "230",
      4: "440",
      5: "640",
      6: "830",
      7: "1015",
      8: "1190",
      9: "1360",
      10: "1520",
    },
    xl: {
      3: "270",
      4: "520",
      5: "755",
      6: "975",
      7: "1185",
      8: "1380",
      9: "1560",
      10: "1730",
    },
    super: {
      3: "315",
      4: "615",
      5: "890",
      6: "1160",
      7: "1410",
      8: "1640",
      9: "1850",
      10: "2050",
    },

    xxxl:{
      3: "373",
4: "729",
5: "1055",
6: "1375",
7: "1671",
8: "1944",
9: "2193",
10: "2430",
    },

    newsuper:{
      3: "442",
4: "864",
5: "1250",
6: "1629",
7: "1980",
8: "2304",
9: "2599",
10: "2880",
    },

    megasuper:{
      3: "524",
4: "1024",
5: "1481",
6: "1930",
7: "2346",
8: "2730",
9: "3080",
10: "3413",
    },
  };

  var fonttype = $(".font_style")
    .find("ul")
    .find("li.active")
    .attr("data-fonttype")
    .toLowerCase();

  var letterCount = $("#input_text").val().replace(/\s/g, "").length;

  if (letterCount == 0) {
    $("#add_to_card").addClass("disable-cart");
    $("#add_to_card").prop("disabled", true);
    // console.log("Letter Count 0");
  } else {
    $("#add_to_card").removeClass("disable-cart");
    $("#add_to_card").prop("disabled", false);
  }

  if (letterCount > 50 && letterCount != 0) {
    $(".loading-char").css("display", "flex");
    $("#add_to_card").addClass("disable-cart");
    $("#add_to_card").prop("disabled", true);
  } else {
    $(".loading-char").hide();
    $("#add_to_card").removeClass("disable-cart");
    $("#add_to_card").prop("disabled", false);
  }

  if (letterCount == 0) {
    letterCount = 1;
  }

  var fontsize = $(".size-box.active").attr("data-size");
  $(".text_show").html(
    escapeHtml($("#input_text").val()) +
      "<div class='main_width' style='display:none;'><div class='inner' id='mainwidth' ><span class='width_text'></span><span class='left_'></span><span class='right_'></span></div></div><div class='main_height' style='display:none;'><div class='inner' id='mainheight'><span class='height_text'>18cm</span><span class='top_'></span><span class='bottom_'></span></div></div>"
  );

  $(".text_show").html(
    $(".text_show")
      .html()
      .replace(/\r\n|\r|\n/g, "<br>")
  );

  $("#text").html(escapeHtml($("#input_text").val()));
  $("#text").html(
    $("#text")
      .html()
      .replace(/\r\n|\r|\n/g, "<br>")
  );

  if (!$(".text_show").text()) {
    $(".text_show").text("Neon");
  }

var fontwidth = {
    simple: {
      xs: 8,
      s: 9,
      m: 12,
      l: 15,
      xl: 20,
      xxl: 24,
      super: 27,
      xxxl:27,
      newsuper:33,
      megasuper:40,
    },
    fancy: {
      xs: 10,
      s: 12,
      m: 16,
      l: 20,
      xl: 27,
      xxl: 30,
      super: 36,
      xxxl:36,
      newsuper: 40,
      megasuper: 45,
    },
    doubleline: {
      m: 20,
      l: 26,
      xl: 34,
      xxl: 40,
      super: 46,
      xxxl:46,
      newsuper: 50,
      megasuper: 55,
    },
  };

  var textlength = $("#input_text").val().split("\n");
  var lengths = $.map(textlength, function (i) {
    return i.length;
  });
  var maxLength = Math.max.apply(this, lengths);

  var modulo4 = 0;

  if (maxLength >= 3) {
    modulo4 = 1;
  }

  for (let index = 0; index <= maxLength; index++) {
    if (index % 4 == 3 && index >= 4) {
      modulo4++;
      // console.log('Inside Modulo is: '+modulo4);
    }
  }

  // console.log('Outside Modulo is: '+modulo4);

  if (textlength != 0) {
    // $(".main_height").show();
    // $(".main_width").show();
  }

  var heightmultiplier = 1;

  var regex = /([bfdhklt])/;
  var regex2 = /([gjpqy])/;
  var regex3 = /([A-Z0-9])/;

  var textwithoutspace = $("#input_text").val().replace(/\s/g, "");
  if (regex.test(textwithoutspace) && regex2.test(textwithoutspace)) {
    heightmultiplier = 1.4;
  } else if (regex.test(textwithoutspace) && !regex2.test(textwithoutspace)) {
    heightmultiplier = 1;
  } else if (regex3.test(textwithoutspace)) {
    heightmultiplier = 1;
  } else if (!regex.test(textwithoutspace) && !regex2.test(textwithoutspace)) {
    heightmultiplier = 0.6;
  }

  const upperfont = [
    "amnesia",
    "banksy",
    "broadway",
    "daffodil",
    "disco",
    "futurama",
    "graffiti",
    "milan",
    "varsity",
  ];

  if (
    upperfont.includes(
      $(".font_style").find("ul").find("li.active p").text().toLowerCase()
    )
  ) {
    heightmultiplier = 1;
  }

  var fontsize2 = $(".size-box.active").attr("data-size");

  // $(".width_text").html(fontwidth[fonttype][fontsize2] * maxLength + "cm");
  var trimtext = "";

  if ($("#input_text").val().match(/\n/g) != null) {
    let inputtext = $("#input_text").val();
    let wsRegex = /^\s+|\s+$/g;
    trimtext = inputtext.replaceAll(wsRegex, "");
  }

  if (trimtext.match(/\n/g)) {
    var newlinenumber = trimtext.match(/\n/g).length + 1;
  } else {
    var newlinenumber = 1;
  }

  if (newlinenumber >= 2) {
    $(".height_text").html(
      parseInt(
        fontwidth[fonttype][fontsize2] * newlinenumber * 1.25 * heightmultiplier
      ) + (isUSMarket() ? "IN" : "cm")
    );

    console.log(
      "Set Height : " +
        parseInt(
          fontwidth[fonttype][fontsize2] *
            newlinenumber *
            1.25 *
            heightmultiplier
        ) +
        (isUSMarket() ? "IN" : "cm")
    );
  } else {
    $(".height_text").html(
      parseInt(
        fontwidth[fonttype][fontsize2] * newlinenumber * heightmultiplier
      ) + (isUSMarket() ? "IN" : "cm")
    );

    console.log(
      "Set Height : " +
        parseInt(
          fontwidth[fonttype][fontsize2] * newlinenumber * heightmultiplier
        ) +
        (isUSMarket() ? "IN" : "cm")
    );
  }

  // if ($('#input_text').val().endsWith('\n') || $('#input_text').val().startsWith('\n')) {
  //   $("#mainheight").hide();
  //   $('.main_height').hide();
  //   $('.s_size_h').hide();
  // } else{
  //   $("#mainheight").show();
  //   $('.main_height').show();
  //   $('.s_size_h').show();
  // }

  var newwidth = $("#text").width();
  var newheight = $("#text").height();

  var heightcm = Math.floor((newheight * 2.54) / 24);

  $("#input_text").val();

  var total_width = 0;

  var tempprice = 0;

  switch (fonttype) {
    case "simple":
      var i = 0;
      var newlineprice = 0;
      $("#size_table .size-box").removeClass("disabled");
      for (fontsizekey in simpleprice) {
        $("#size_table .size-box").each(function () {
          if ($(this).attr("data-size") == fontsizekey) {
            if (newlinenumber >= 3 && newlinenumber < 10) {
              newlineprice = simplepriceperline[fontsizekey][newlinenumber];
            } else if (newlinenumber >= 10) {
              newlineprice =
                parseInt(simplepriceperline[fontsizekey][10]) +
                parseInt(simplepriceperline[fontsizekey][10]) *
                  (newlinenumber - 10);
            }
            if (letterCount <= 25) {
              tempprice =
                parseInt(Math.ceil(simpleprice[fontsizekey][letterCount])) +
                parseInt(newlineprice);
            } else if (letterCount > 25) {
              tempprice =
                parseInt(Math.ceil(simpleprice[fontsizekey][25])) +
                (parseInt(Math.ceil(simpleprice[fontsizekey][25])) -
                  parseInt(Math.ceil(simpleprice[fontsizekey][24]))) *
                  (parseInt(letterCount) - 25);
              parseInt(newlineprice);
            }
            if (letterCount > 10) { tempprice =parseInt(Math.ceil( tempprice + tempprice*0.15)); }
            //tempprice =parseInt(Math.ceil( tempprice - tempprice*0.4));
            $(this)
              .find("div:eq(2)")
              .html("$" + convertPrice(tempprice));
            // switch (fontsizekey) {
            //   case "xs":
            //     total_width =
            //       fontwidth[fonttype][fontsizekey] * (maxLength - modulo4) +
            //       (fontwidth[fonttype][fontsizekey] - 1) * modulo4;
            //     break;
            //   case "s":
            //     total_width =
            //       ((fontwidth[fonttype][fontsizekey] +
            //         fontwidth[fonttype][fontsizekey] +
            //         1) *
            //         maxLength) /
            //       2;
            //     break;
            //   case "m":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            //   case "l":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            //   case "xl":
            //     total_width =
            //       ((fontwidth[fonttype][fontsizekey] +
            //         fontwidth[fonttype][fontsizekey] +
            //         1) *
            //         maxLength) /
            //       2;
            //     break;
            //   case "super":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            // }
            // console.log("Total Width: " + total_width + "cm");
            // $(this)
            //   .find(".s_size .s_size_w")
            //   .html("Width: " + parseInt(total_width) + "cm");
            // $(this)
            //   .find(".s_size .s_size_h")
            //   .html(
            //     "Height: " +
            //       parseInt(
            //         fontwidth[fonttype][fontsizekey] * heightmultiplier
            //       ) +
            //       "cm"
            //   );
            // if (newlinenumber >= 2) {
            //   $(this)
            //     .find(".s_size .s_size_h")
            //     .html(
            //       "Height: " +
            //         parseInt(
            //           fontwidth[fonttype][fontsizekey] *
            //             newlinenumber *
            //             1.25 *
            //             heightmultiplier
            //         ) +
            //         "cm"
            //     );
            // }
          }
        });
      }
      break;
    case "fancy":
      var i = 0;
      var newlineprice = 0;
      //$("#size_table .size-box").removeClass("disabled");
      for (fontsizekey in fancyprice) {
        $("#size_table .size-box").each(function () {
          if ($(this).attr("data-size") == fontsizekey) {
            if (newlinenumber >= 3 && newlinenumber < 10) {
              newlineprice = fancypriceperline[fontsizekey][newlinenumber];
            } else if (newlinenumber >= 10) {
              newlineprice =
                parseInt(fancypriceperline[fontsizekey][10]) +
                parseInt(fancypriceperline[fontsizekey][10]) *
                  (newlinenumber - 10);
            }
            if (letterCount <= 25) {
              tempprice =
                parseInt(Math.ceil(fancyprice[fontsizekey][letterCount])) +
                parseInt(newlineprice);
            } else if (letterCount > 25) {
              tempprice =
                parseInt(Math.ceil(fancyprice[fontsizekey][25])) +
                (parseInt(Math.ceil(fancyprice[fontsizekey][25])) -
                  parseInt(Math.ceil(fancyprice[fontsizekey][24]))) *
                  (parseInt(letterCount) - 25);
              parseInt(newlineprice);
            }
            if (letterCount > 10) { tempprice =parseInt(Math.ceil( tempprice + tempprice*0.15)); }
            //tempprice =parseInt(Math.ceil( tempprice - tempprice*0.4));
            $(this)
              .find("div:eq(2)")
              .html("$" + convertPrice(tempprice));
            // switch ($(this).attr("data-size")) {
            //   case "xs":
            //     total_width =
            //       fontwidth[fonttype][fontsizekey] * (maxLength - modulo4) +
            //       (fontwidth[fonttype][fontsizekey] - 1) * modulo4;
            //     break;
            //   case "s":
            //     total_width =
            //       ((fontwidth[fonttype][fontsizekey] +
            //         fontwidth[fonttype][fontsizekey] +
            //         1) *
            //         maxLength) /
            //       2;
            //     break;
            //   case "m":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            //   case "l":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            //   case "xl":
            //     total_width =
            //       ((fontwidth[fonttype][fontsizekey] +
            //         fontwidth[fonttype][fontsizekey] +
            //         1) *
            //         maxLength) /
            //       2;
            //     break;
            //   case "super":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            // }

            // $(this)
            //   .find(".s_size .s_size_w")
            //   .html("Width: " + parseInt(total_width) + "cm");
            // $(this)
            //   .find(".s_size .s_size_h")
            //   .html(
            //     "Height: " +
            //       parseInt(
            //         fontwidth[fonttype][fontsizekey] * heightmultiplier
            //       ) +
            //       "cm"
            //   );
            // if (newlinenumber >= 2) {
            //   $(this)
            //     .find(".s_size .s_size_h")
            //     .html(
            //       "Height: " +
            //         parseInt(
            //           fontwidth[fonttype][fontsizekey] *
            //             newlinenumber *
            //             1.25 *
            //             heightmultiplier
            //         ) +
            //         "cm"
            //     );
            // }
          }
        });
      }
      break;
    case "doubleline":
      var i = 0;
      var newlineprice = 0;
      for (fontsizekey in doubleprice) {
        $("#size_table .size-box").each(function () {
          if ($(this).attr("data-size") == fontsizekey) {
            if (newlinenumber >= 3 && newlinenumber < 10) {
              newlineprice = doublepriceperline[fontsizekey][newlinenumber];
            } else if (newlinenumber >= 10) {
              newlineprice =
                parseInt(doublepriceperline[fontsizekey][10]) +
                parseInt(doublepriceperline[fontsizekey][10]) *
                  (newlinenumber - 10);
            }
            if (letterCount <= 25) {
              tempprice =
                parseInt(Math.ceil(doubleprice[fontsizekey][letterCount])) +
                parseInt(newlineprice);
            } else if (letterCount > 25) {
              tempprice =
                parseInt(Math.ceil(doubleprice[fontsizekey][25])) +
                (parseInt(Math.ceil(doubleprice[fontsizekey][25])) -
                  parseInt(Math.ceil(doubleprice[fontsizekey][24]))) *
                  (parseInt(letterCount) - 25);
              parseInt(newlineprice);
            }
            if (letterCount > 10) { tempprice =parseInt(Math.ceil( tempprice + tempprice*0.15)); }
            //tempprice =parseInt(Math.ceil( tempprice - tempprice*0.3));
            $(this)
              .find("div:eq(2)")
              .html("$" + convertPrice(tempprice));
            // switch (fontsizekey) {
            //   case "xs":
            //     total_width =
            //       fontwidth[fonttype][fontsizekey] * (maxLength - modulo4) +
            //       (fontwidth[fonttype][fontsizekey] - 1) * modulo4;

            //     break;
            //   case "s":
            //     total_width =
            //       ((fontwidth[fonttype][fontsizekey] +
            //         fontwidth[fonttype][fontsizekey] +
            //         1) *
            //         maxLength) /
            //       2;
            //     break;
            //   case "m":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            //   case "l":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            //   case "xl":
            //     total_width =
            //       ((fontwidth[fonttype][fontsizekey] +
            //         fontwidth[fonttype][fontsizekey] +
            //         1) *
            //         maxLength) /
            //       2;
            //     break;
            //   case "super":
            //     total_width = fontwidth[fonttype][fontsizekey] * maxLength;
            //     break;
            // }

            // $(this)
            //   .find(".s_size .s_size_w")
            //   .html("Width: " + parseInt(total_width) + "cm");
            // $(this)
            //   .find(".s_size .s_size_h")
            //   .html(
            //     "Height: " +
            //       parseInt(
            //         fontwidth[fonttype][fontsizekey] * heightmultiplier
            //       ) +
            //       "cm"
            //   );
            // if (newlinenumber >= 2) {
            //   $(this)
            //     .find(".s_size .s_size_h")
            //     .html(
            //       "Height: " +
            //         parseInt(
            //           fontwidth[fonttype][fontsizekey] *
            //             newlinenumber *
            //             1.25 *
            //             heightmultiplier
            //         ) +
            //         "cm"
            //     );
            // }
          }
        });
      }
      break;
  }

  
  //getWidthHeight();

  var fonttypename = $(".font_style")
    .find("ul")
    .find("li.active")
    .attr("data-font")
    .toLowerCase();

  if (fonttypename == "retrolight") {
    var i = 0;
    var newlineprice = 0;
    console.log('TESTING');
    for (fontsizekey in doubleprice) {
      $("#size_table .size-box").each(function () {
        if ($(this).attr("data-size") == fontsizekey) {
          if (newlinenumber >= 3 && newlinenumber < 10) {
            newlineprice = doublepriceperline[fontsizekey][newlinenumber];
          } else if (newlinenumber >= 10) {
            newlineprice =
              parseInt(doublepriceperline[fontsizekey][10]) +
              parseInt(doublepriceperline[fontsizekey][10]) *
                (newlinenumber - 10);
          }
          if (letterCount <= 25) {
            tempprice =
              parseInt(Math.ceil(doubleprice[fontsizekey][letterCount])) +
              parseInt(newlineprice);
          } else if (letterCount > 25) {
            tempprice =
              parseInt(Math.ceil(doubleprice[fontsizekey][25])) +
              (parseInt(Math.ceil(doubleprice[fontsizekey][25])) -
                parseInt(Math.ceil(doubleprice[fontsizekey][24]))) *
                (parseInt(letterCount) - 25);
            parseInt(newlineprice);
          }
          tempprice =parseInt(Math.ceil( tempprice + tempprice*0.25));
          //tempprice =parseInt(Math.ceil( tempprice - tempprice*0.3));
          $(this)
            .find("div:eq(2)")
            .html("$" + convertPrice(tempprice));
          
        }
      });
    }
  }

  // console.log("Updated width");

  var current_width = $(".size-box.active .s_size_w").text();
  current_width = current_width.replace("Width: ", "");
  // $(".width_text").html(current_width);

  setwaterprice();
  // getNewPrice();
  fontAdjustcall();
  getFontSize();
  updateline();
  // setTimeout(saveValueImg, 4000);
  var letterCount2 = $("#input_text").val().replace(/\s/g, "").length;

  if (letterCount2 == 0 || letterCount2 > 50) {
    $("#add_to_card").addClass("disable-cart");
    $("#add_to_card").prop("disabled", true);
  } else {
    $("#add_to_card").removeClass("disable-cart");
    $("#add_to_card").prop("disabled", false);
    $(".s_size").show();
  }

  if (letterCount2 == 0) {
    $(".text_show").html("Neon");
    $(".s_size").hide();
    $("#add_to_card").addClass("disable-cart");
    $("#add_to_card").prop("disabled", true);
  }
}

var inputElement = document.getElementById("input_text");

var timer;

if (inputElement) {
  inputElement.oninput = function () {
    setNewPrice();
    var letterCount2 = $("#input_text").val().replace(/\s/g, "").length;

    if (letterCount2 == 0 || letterCount2 > 50) {
      $("#add_to_card").addClass("disable-cart");
      $("#add_to_card").prop("disabled", true);
    } else {
      $("#add_to_card").removeClass("disable-cart");
      $("#add_to_card").prop("disabled", false);
      $(".s_size").show();
    }

    if (letterCount2 == 0) {
      $(".text_show").html("Neon");
      $(".s_size").hide();
      $("#add_to_card").addClass("disable-cart");
      $("#add_to_card").prop("disabled", true);
    }

    // clearTimeout(timer);
    // timer = setTimeout(saveValueImg, 1500);
  };
}

function roundToTwo(num) {
  return +(Math.round(num + "e+2") + "e-2");
}

function getNewPrice() {
  // console.log("running");
  var textprice = parseInt(
    $(".size-box.active .withprice div:eq(1)").html().replace("$", "")
  );

  var boardcolprice = parseInt($(".bord_img .active").attr("data-price"));

  var backboardprice = parseInt($(".backing-box input:checked").val());

  var mount_kit = 0;

  if($('.custom-select-mount select').length == 1){
    mount_kit = parseInt($('.custom-select-mount select').val());
  }
  



  var sign_hanging_kit = 0;
  if ($("#check-3").prop("checked") == true) {
    sign_hanging_kit = parseInt(convertPrice("25"));
  }

  var sided_tape = 0;
  if ($("#3m-tape").prop("checked") == true) {
    sided_tape = parseInt(convertPrice("20"));
  }

  var options = parseInt($("input.optionalpricing").attr("data-price"));
  // setwaterprice();
  var totalprice =
    textprice + options + boardcolprice + sign_hanging_kit + sided_tape + backboardprice + mount_kit;
  $(".total_sel_price").html("$" + totalprice);
  //$(".total_sel_price").css("text-decoration", "line-through");
  //Discount
  //$(".price-item--sale").html("$" + roundToTwo(totalprice - totalprice * 0.2));
}

function addcartp() {
  var imageblob;
  var start = Date.now();
  var stop;
  $(".charlimitmessage").show();
  htmlToImage.toPng(document.getElementById("text")).then(function (dataUrl) {
    // console.log("Coverting Canvas");
    const imageurl = dataUrl;
    // console.log("Coverted Canvas");
    // console.log(imageurl);
    var price = $(".total_sel_price").text();
    price = parseInt(price.replace(/[^0-9.]/g, ""));
    if (isUSMarket()){  
      price = (price / audToUsdRate);
      console.log(price+'Test');
    }

    price = price.toString()
    //var price = $(".price-item--sale").text();

    let final_text = escapeHtml($("#input_text").val());
    let final_font = $(".font_style li.active p").text();
    let final_color = $("#color_table p.active+p.color_name").text();
    let final_rgb;

    if ($(".rgb-option input:checked").length > 0) {
      final_rgb = "RGB Sign: Yes";
    } else if($(".rgbw-option input:checked").length > 0) {
      final_rgb = "RGBW Sign: Yes";
    } else {
      final_rgb = "RGB Not Selected";
    }

    let final_size = $(".size-box.active .withprice>div>strong").text();
    let final_size_w = $(".size-box.active .s_size_w").text();
    let final_size_h = $(".size-box.active .s_size_h").text();
    let final_in_out = $(".indoor-outdoor-section label.active").attr(
      "data-option-value"
    );
    let final_backboard = $(".backing-box input[type='radio']:checked")
      .parent()
      .find(".backing-titile")
      .text();
    let final_bbcol = $(".board50 .active").attr("data-label");
    let final_power = $(".chosen-single span").text();

    var final_mount = $(".tot_price_sec input[type='checkbox']:checked")
      .map(function () {
        return $(this).attr("data-title");
      })
      .get();

    if (final_text == "") {
      final_text = "No Text Entered";
    }

    if (final_font == "") {
      final_font = "No Font Selected";
    }

    if (final_color == "") {
      final_color = "No Color Selected";
    }

    if (final_size == "") {
      final_size = "No Size Selected";
    }

    if (final_in_out == "") {
      final_in_out = "No Indoor or Outdoor Usage Selected";
    }

    if (final_backboard == "") {
      final_backboard = "No Backing Selected";
    }

    if (final_bbcol == "") {
      final_bbcol = "No Backing Color Selected";
    }

    if (final_power == "Select Power Adapter:") {
      final_power = "No Adapter Selected";
    }

    let desc =
      "Text = " +
      final_text +
      "<br>Font = " +
      final_font +
      "<br>Colour = " +
      final_color +
      "<br>Sign Size = " +
      final_size +
      "<br>" +
      final_size_w +
      "<br>" +
      final_size_h +
      "<br>Sign Indoor or Outdoor = " +
      final_in_out +
      "<br>Backboard Cut = " +
      final_backboard +
      "<br>Backboard Colour = " +
      final_bbcol +
      "<br>Power Adapter = " +
      final_power +
      "<br>"+
      final_rgb +
      "<br Mounting Options = >" +
      final_mount.toString();

    let props = 
  "&properties[Final%20Color]=" + encodeURIComponent(final_color) +
  "&properties[Sign%20Size]=" + encodeURIComponent(final_size_w + "x" + final_size_h) +
  "&properties[Indoor%20or%20Outdoor]=" + encodeURIComponent(final_in_out) +
  "&properties[Sign%20Shape]=" + encodeURIComponent(final_backboard) +
  "&properties[Backboard%20Colour]=" + encodeURIComponent(final_bbcol) +
  "&properties[Power%20Adapter]=" + encodeURIComponent(final_power) +
  "&properties[RGB%20Option]=" + encodeURIComponent(final_rgb) +
  "&properties[Mounting%20Options]=" + encodeURIComponent(final_mount.toString());


    
    var formdata = {
      price: price,
      description: desc,
      image: imageurl,
    };
    stop = Date.now();
    var timeout = (stop - start) / 1000;
    // console.log(timeout);
    // Send AJAX request to PHP script
    $.ajax({
      url: "https://api.theneonfactory.com.au/php/addvar.php",
      type: "POST",
      data: formdata,
      start_time: new Date().getTime(),
      success: function (data) {
        $(".charlimitmessage").hide();
        // console.log(
        //   "This request took " +
        //     (new Date().getTime() - this.start_time) +
        //     " ms"
        // );
        // console.log(data);
        window.location.href = getCartDomain() + '/cart/add?id=' + data + '&quantity=1' + props;
      },
      error: function (xhr, status, error) {
        console.log(error);
      },
    });
  });
}

var currencySmbl = "$";

$(document).ready(function () {
  $("#add_to_card").addClass("disable-cart");
  $("#add_to_card").prop("disabled", true);
  $('[data-fancybox="images"]').fancybox({});
  setClickEvents();
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
  // $( ".draggable" ).draggable();
  // fontEmbedCss = htmlToImage.getFontEmbedCSS(document.getElementById("text"));
  // console.log(fontEmbedCss);
});

function setSize(slide) {
  var size = $(slide).val() / 20 + "rem";
  $(".text_show").css("font-size", size);
  $(".text_show, #text").css("line-height", size);
}

function setFont(font, type, font_li) {
  oldCanvasH = 0;
  $(".text_show").css("font-family", font);

  if ($(font_li).attr("data-desk") != "" || $(font_li).attr("data-mob") != "") {
    $(".demo_box_side .text_show").css(
      "font-size",
      $(font_li).attr("data-desk") + "px"
    );
    $(".demo_box_full .text_show").css(
      "font-size",
      $(font_li).attr("data-mob") + "px"
    );
    console.log("Font size set");
  } else {
    $(".demo_box_side .text_show").css("font-size", "100px");
    $(".demo_box_full .text_show").css("font-size", "70px");
  }

  if ($(font_li).attr("data-lineh") != "") {
    $(".text_show").css("line-height", $(font_li).attr("data-lineh"));
    $("#text").css("line-height", $(font_li).attr("data-lineh"));
    $("#text").attr("data-lineh", $(font_li).attr("data-lineh"));
    // console.log("Changed Line Height");
  } else {
    $(".text_show").css("line-height", "100%");
    $("#text").css("line-height", "100%");
    $("#text").attr("data-lineh", "100%");
  }

  $("#text").css("font-family", font);
  $(".font_style li").removeClass("active");
  $(font_li).addClass("active");

  group = type;
  sizelimit();
  setNewPrice();
  setTimeout(saveValueImg, 3000);
}

function setwaterprice() {
  var waterproofpricing = {
    simple: {
      xs: 100,
      s: 100,
      m: 100,
      l: 120,
      xl: 120,
      super: 150,
      xxxl:150,
      newsuper:170,
      megasuper:200,
    },
    fancy: {
      xs: 100,
      s: 100,
      m: 100,
      l: 120,
      xl: 120,
      super: 150,
      xxxl:150,
      newsuper:170,
      megasuper:200,
    },
    doubleline: {
      xs: 130,
      s: 130,
      m: 170,
      l: 250,
      xl: 250,
      super: 300,
      xxxl:350,
      newsuper:400,
      megasuper:450,
    },
  };

  var rgbprice = {
    simple: {
      xs: 100,
      s: 100,
      m: 100,
      l: 120,
      xl: 120,
            super: 150,
      xxxl:150,
      newsuper:170,
      megasuper:200,
    },
    fancy: {
      xs: 100,
      s: 100,
      m: 100,
      l: 120,
      xl: 120,
           super: 150,
      xxxl:150,
      newsuper:170,
      megasuper:200,
    },
    doubleline: {
      xs: 130,
      s: 130,
      m: 170,
      l: 250,
      xl: 250,
         super: 300,
      xxxl:350,
      newsuper:400,
      megasuper:450,
    },
  };

  var rgbandwater = {
    simple: {
      xs: 160,
      s: 160,
      m: 160,
      l: 192,
      xl: 192,
       super: 220,
      xxxl:240,
      newsuper:272,
      megasuper:320,
    },
    fancy: {
      xs: 160,
      s: 160,
      m: 160,
      l: 192,
      xl: 192,
      super: 220,
      xxxl:240,
      newsuper:272,
      megasuper:320,
    },
    doubleline: {
      xs: 208,
      s: 208,
      m: 272,
      l: 400,
      xl: 400,
         super: 500,
      xxxl:570,
      newsuper:640,
      megasuper:800,
    },
  };

  var waterproofpricing10 = {
    simple: {
      xs: 120,
      s: 120,
      m: 120,
      l: 170,
      xl: 170,
      super: 200,
      xxxl:200,
      newsuper:250,
      megasuper:250,
    },
    fancy: {
      xs: 120,
      s: 120,
      m: 120,
      l: 170,
      xl: 170,
      super: 200,
      xxxl:200,
      newsuper:250,
      megasuper:250,
    },
    doubleline: {
      xs: 220,
      s: 220,
      m: 250,
      l: 300,
      xl: 300,
            super: 350,
      xxxl:425,
      newsuper:600,
      megasuper:750,
    },
  };

  var rgbprice10 = {
    simple: {
      xs: 120,
      s: 120,
      m: 120,
      l: 170,
      xl: 170,
            super: 200,
      xxxl:200,
      newsuper:250,
      megasuper:250,
    },
    fancy: {
      xs: 120,
      s: 120,
      m: 120,
      l: 170,
      xl: 170,
            super: 200,
      xxxl:200,
      newsuper:250,
      megasuper:250,
    },
    doubleline: {
      xs: 220,
      s: 220,
      m: 250,
      l: 300,
      xl: 300,
           super: 350,
      xxxl:425,
      newsuper:600,
      megasuper:750,
    },
  };

  var rgbandwater10 = {
    simple: {
      xs: 192,
      s: 192,
      m: 192,
      l: 272,
      xl: 272,
      super: 400,
    },
    fancy: {
      xs: 192,
      s: 192,
      m: 192,
      l: 272,
      xl: 272,
      super: 400,
    },
    doubleline: {
      xs: 352,
      s: 352,
      m: 400,
      l: 480,
      xl: 480,
        super: 700,
      xxxl:800,
      newsuper:960,
      megasuper:1200,
    },
  };

  if ($("#input_text").val().length >= 10) {
    waterproofpricing = waterproofpricing10;
    rgbandwater = rgbandwater10;
    rgbprice = rgbprice10;
  }

 

  var waterprice =
    waterproofpricing[
      $(".font_style li.active").attr("data-fonttype").toLowerCase()
    ][$(".size-box.active").attr("data-size")];
  $("#outdooruse1").attr("data-price", convertPrice(waterprice));
  $("#waterProofPrice").html(convertPrice(waterprice));
  $("#outdooruse").val(convertPrice(waterprice));

  if (
    $("#outdooruse1.active").length > 0 &&
    $(".rgb-option input:checked").length > 0
  ) {
    $(".color-extension .rgb-image").show();
    $("#optional_option1 .label-wrap").addClass("active");
    $("#color_table p.active").removeClass("active");
    $("#color_table p").css("text-shadow", "unset");
    $(".new-neon-rightpart .color_style #color_table li.col-xs-2").css(
      "pointer-events",
      "none"
    );

    // intervalSetID = setInterval(cycleColors, 1000);

    var optionsprice =
      rgbandwater[
        $(".font_style li.active").attr("data-fonttype").toLowerCase()
      ][$(".size-box.active").attr("data-size")];
    $("input.optionalpricing").attr("data-price", optionsprice);
    // console.log("Added RGB and Water Pricing");
  } else if ($("#outdooruse1.active").length > 0) {
    $(".color-extension .rgb-image").hide();
    $("#optional_option1 .label-wrap").removeClass("active");
    $(".new-neon-rightpart .color_style #color_table li.col-xs-2").css(
      "pointer-events",
      "all"
    );
    // clearInterval(intervalSetID);
    var waterprice =
      waterproofpricing[
        $(".font_style li.active").attr("data-fonttype").toLowerCase()
      ][$(".size-box.active").attr("data-size")];
    $("#outdooruse1").attr("data-price", convertPrice(waterprice));
    $("#waterProofPrice").html(convertPrice(waterprice));
    $("#outdooruse").val(convertPrice(waterprice));
    $("input.optionalpricing").attr("data-price", convertPrice(waterprice));
    // console.log("Added Water Pricing");
  } else if ($(".rgb-option input:checked").length > 0) {
    $(".color-extension .rgb-image").show();
    $("#optional_option1 .label-wrap").addClass("active");
    $("#color_table p.active").removeClass("active");
    $("#color_table p").css("text-shadow", "unset");
    $(".new-neon-rightpart .color_style #color_table li.col-xs-2").css(
      "pointer-events",
      "none"
    );
    // intervalSetID = setInterval(cycleColors, 1000);
    var waterprice =
      rgbprice[$(".font_style li.active").attr("data-fonttype").toLowerCase()][
        $(".size-box.active").attr("data-size")
      ];
    $("input.optionalpricing").attr("data-price", convertPrice(waterprice));
    $("#waterProofPrice").html(convertPrice(waterprice));
    $("#outdooruse").val(convertPrice(waterprice));
    $("input.optionalpricing").attr("data-price", convertPrice(waterprice));
    // console.log("Added RGB Pricing");
  } else {
    $(".color-extension .rgb-image").hide();
    $("#optional_option1 .label-wrap").removeClass("active");
    $(".new-neon-rightpart .color_style #color_table li.col-xs-2").css(
      "pointer-events",
      "all"
    );
    // clearInterval(intervalSetID);
    $("input.optionalpricing").attr("data-price", "0");
    // console.log("No Option Selected");
  }

   if($(".rgbw-option input:checked").length > 0){
     if ($("input.optionalpricing").attr("data-price") == 0) {
       var waterprice =
      rgbprice[$(".font_style li.active").attr("data-fonttype").toLowerCase()][
        $(".size-box.active").attr("data-size")
      ];
       $("input.optionalpricing").attr("data-price", convertPrice(waterprice)*1.5);
     } else {
       let cstprc = $("input.optionalpricing").attr("data-price");
     cstprc = cstprc*1.5;
     $("input.optionalpricing").attr("data-price", cstprc);
     }
    
  }
  
  getNewPrice();
  setcycle();
  updateline();
}

function changeAppearance(wrap) {
  var $selected_color = $("#color_table li p.active");
  var color = $selected_color.attr("data-color");
  var color_name = $selected_color.attr("data-color-title");
  var color_off = $selected_color.attr("data-color-off");

  if (color_name == "Cotton Candy") {
    color_name = ConttonCandy_color_name;
  }

  if ($("." + wrap + " .demo_on_off").hasClass("onswitch")) {
    $(".demo_on_off").removeClass("onswitch");
    $(".demo_on_off").addClass("offswitch");
    $(".text_show").css("color", "#fff");
    setColor(color, $selected_color.closest("li"), "switch");
  } else if ($("." + wrap + " .demo_on_off").hasClass("offswitch")) {
    // FIRST ON/OFF COLOR SETTINGS  (The second is below)
    $(".demo_on_off").removeClass("offswitch");
    $(".demo_on_off").addClass("onswitch");
    var color_string =
      "0 1px 0 " +
      color +
      ", 0 2px 0 " +
      color +
      ", 0 3px 0 " +
      color +
      ", 0 4px 0 " +
      color +
      ", 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
    switch (color_name) {
      case "Lemon Yellow":
        color_string =
          "0 1px 0 #e9e36a, 0 2px 0 #dad450, 0 3px 0 #c7c144, 0 4px 0 #aaa535, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Light Green":
        color_string =
          "0 1px 0 #43efcc, 0 2px 0 #39d8b8, 0 3px 0 #28bb9d, 0 4px 0 #1da085, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Golden Yellow":
        color_string =
          "0 1px 0 #dfb91f, 0 2px 0 #cda916, 0 3px 0 #ba9912, 0 4px 0 #a48401, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Orange":
        color_string =
          "0 1px 0 #d97b00, 0 2px 0 #e77f00, 0 3px 0 #bf6c01, 0 4px 0 #a85f00, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Red":
        color_string =
          "0 1px 0 #db1438, 0 2px 0 #bc0828, 0 3px 0 #a0001d, 0 4px 0 #790016, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.33), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Dark Blue":
        color_string =
          "0 1px 0 #005fd0, 0 2px 0 #0062d6, 0 3px 0 #00489e, 0 4px 0 #003d85, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Deep Green":
        color_string =
          "0 1px 0 #00b837, 0 2px 0 #009b2f, 0 3px 0 #008628, 0 4px 0 #007222, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Light Blue":
        color_string =
          "0 1px 0 #2dbfde, 0 2px 0 #2aaac6, 0 3px 0 #2391a8, 0 4px 0 #1d7d91, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      case "Hot Pink":
        color_string =
          "0 1px 0 #e73dcd, 0 2px 0 #d22fba, 0 3px 0 #c42aad, 0 4px 0 #b5219f, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
      default:
        color_string =
          "0 1px 0 #b5b5b5, 0 2px 0 #a9a9a9, 0 3px 0 #949494, 0 4px 0 #7d7d7d, 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
        break;
    }
    $(".text_show").css("text-shadow", color_string);
    $(".text_show").css("color", color_off);
  }
}

function showmaxcount() {
  var message = new Array({
    type: "p",
    class: "",
    html:
      " please contact us for a quote.<br>(Prices start from just " +
      currencySmbl +
      "792)",
  });
  showMessage(message);
}

function showreqfields() {
  $(".message_wrapper.s_wrapper").addClass("show");
  $(".message_wrapper.s_wrapper.show").css("visibility", "visible");
  var message = new Array({
    type: "p",
    class: "",
    html: "Please fill all required fields.",
  });
  showMessage(message);
}

function setBG(bg) {
  $(".demo_text").css("background-image", "url(" + bg + ")");
  CanvasUtils.changeColor();
}

function setColor(color, lo, from) {
  if (typeof from == "undefined") from = "";
  var color_string =
    "0 0 5px #fff, 0 0 10px #fff, 0 0 20px " +
    color +
    ", 0 0 30px " +
    color +
    ", 0 0 40px " +
    color +
    ", 0 0 55px " +
    color +
    ", 0 0 75px " +
    color;
  var color_string_s =
    "0 0 2px #fff, 0 0 4px #fff, 0 0 8px " +
    color +
    ", 0 0 12px " +
    color +
    ", 0 0 16px " +
    color +
    ", 0 0 22px " +
    color +
    ", 0 0 30px " +
    color;
  $(".text_show").css("text-shadow", color_string);
  $("#text").css("color", color);
  //      $(".font_style li").css("text-shadow", color_string_s);
  //      $(".font_style li").css("color", color);
  $("#color_table p").css("text-shadow", "none");
  $("#color_table p").removeClass("white");
  $("#color_table p").removeClass("active");
  $(lo).children("p").css("text-shadow", color_string_s);
  $(lo).children("p.color_name").css("text-shadow", "none");
  $(lo).children("p").addClass("active");
  $(lo).children("p.color_name").removeClass("active");
  $(".color_desc .cdesc").html($(lo).children("p").attr("title"));
  var imgname = $.trim($(lo).children("p.color_name").text())
    .replace(/ /g, "")
    .toLowerCase();
  var datanow = Date.now();
  //       color_imgs

  //       var color = $('.color_desc .cimg img').append('https://cdn.shopify.com/s/files/1/0267/5638/2908/files/'+imgname+'.jpg?' + datanow + ');

  //  console.log("color" + color)

  // $('.color_desc .cimg').css('background-image','url(https://cdn.shopify.com/s/files/1/0267/5638/2908/files/'+imgname+'.jpg?' + datanow + ')');
  $(".color_desc .cimg img").attr(
    "src",
    "https://cdn.shopify.com/s/files/1/0267/5638/2908/files/" +
      imgname +
      ".jpg?" +
      datanow +
      ""
  );
  $(".color_desc .cmore")
    .find("a")
    .attr(
      "href",
      "https://cdn.shopify.com/s/files/1/0267/5638/2908/files/" +
        imgname +
        ".png?" +
        datanow +
        ")"
    );
  $(".color_desc .cmore").find("a").attr("data-lightbox", imgname);
  $(".color_desc .cmore")
    .find("a")
    .html("Photos of " + $(lo).children("p.color_name").text());
  var wrap =
    $(".demo_box_side").css("display") != "none"
      ? "demo_box_side"
      : "demo_box_full";
  if (from == "") {
  }

  // Matt SECOND ON/OFF COLOR SETTINGS

  if ($("." + wrap + " .demo_on_off").hasClass("onswitch")) {
    var color_off = $(lo).find("p.active").attr("data-color-off");
    var color_name = $(lo).find("p.active").attr("data-color-title");
    if (color_name == "Cotton Candy") {
      color_name = ConttonCandy_color_name;
    }
    var color_string =
      "0 1px 0 " +
      color +
      ", 0 2px 0 " +
      color +
      ", 0 3px 0 " +
      color +
      ", 0 4px 0 " +
      color +
      ", 0 0 5px rgba(0,0,0,.23), 0 1px 3px rgba(0,0,0,.43), 1px 4px 6px rgba(0,0,0,.4), 0 5px 10px rgba(0,0,0,.38), 3px 7px 12px rgba(0,0,0,.25)";
    $(".text_show").css("text-shadow", color_string);
    $(".text_show").css("color", color_off);
  }
}
/* Align text */
function aligntext(align, curr) {
  $(".align_icon").removeClass("active");
  $(curr).addClass("active");
  $(".text_show, #text").css("text-align", align);
}

function updateText() {
  letters_line_wise = [];
  var arrayOfLines = $("#input_text")
    .val()
    .match(/[^\r\n]+/g);
  var $content;
  var char;
  var $result;
  /* Fix error in console*/
  if (arrayOfLines !== null) {
    for (var i = 0; i < arrayOfLines.length; i++) {
      $content = arrayOfLines[i];
      $result = $content.replace(/\s/g, "").length;
      letters_line_wise.push($result);
    }
  }

  /*--  Fix NAN error in the height --*/
  if (arrayOfLines == null) {
    $result = Default_text.replace(/\s/g, "").length;
    letters_line_wise.push($result);
  }
  /*--  Fix NAN error in the height --*/

  if (arrayOfLines.length > 1) {
    $(".align_wrap").show();
    $(".align_wrap").removeClass("disabled");
  } else {
    $(".align_wrap").hide();
    $(".align_wrap").addClass("disabled");
  }
  /* End fix error in console*/

  letters = $("#input_text")
    .val()
    .replace(/\r\n|\r|\n/g, "").length;
  var str = $("#input_text")
    .val()
    .replace(/\r\n|\r|\n/g, "&#13;&#10;");
  enters = $("#input_text").val().length - letters;
  spaces =
    $("#input_text").val().length -
    $("#input_text").val().replace(/\s/g, "").length;
  $(".text_show").html(
    escapeHtml($("#input_text").val()) +
      "<div class='main_width' style='display:none'><div class='inner' id='mainwidth'><span class='width_text'>25CM</span><span class='left_'></span><span class='right_'></span></div></div><div class='main_height' style='display:none;'><div class='inner' id='mainheight'><span class='height_text'>20CM</span><span class='top_'></span><span class='bottom_'></span></div></div>"
  );
  $("#text").html(escapeHtml($("#input_text").val()));
  letters = $.trim(
    $("#input_text")
      .val()
      .replace(/\r\n|\r|\n/g, "")
      .replace(/\s+/g, "")
  ).length;
  if (letters < 2) {
    letters = 2;
  }
}

$(window).on("resize", function () {
  if (winwidth != $(window).width()) {
    winwidth = $(window).width();
    fontAdjustcall(true);

    MagicScroll.refresh();
  }
});
function fontAdjustcall(resize) {
  //           on text chnage find width height
  var findwidth = $(".text_show").width();
  var findheight = $(".text_show").height();
  var letters = $("#input_text")
    .val()
    .replace(/\r\n|\r|\n/g, "").length;
  $(".hight-text").css("width", findwidth);
  $(".hight-text").css("height", findheight);

  var currfont = $(".font_style li.active");

  if (typeof resize == "undefined") resize = false;

  //update text for making font in one line

  var fs = 0;
  var reset_fs = 0;
  var fl = 0;
  var ff = $(".text_show").css("font-family");
  $(".text_show").css("white-space", "nowrap");
  var reset_fl = currfont.attr("data-lineh");

  var reset_fl = 1;

  fl = reset_fl;

  var $text_show = $(".text_show");
  if ($(window).width() > 991) {
    $text_show = $(".demo_box_side .text_show");

    if (currfont.attr("data-desk") == "") {
      reset_fs = 100;
    } else {
      reset_fs = currfont.attr("data-desk");
    }
  } else {
    $text_show = $(".demo_box_full .text_show");

    if (currfont.attr("data-mob") == "") {
      reset_fs = 80;
    } else {
      reset_fs = currfont.attr("data-mob");
    }
  }

  fs = parseInt($text_show.css("font-size"));

  if (letters < 8) {
    $text_show.css("font-size", reset_fs + "px");

    // $("#text").css("font-size", currfont.attr("data-desk") + "px");

    $("#text").attr("data-lineh", reset_fl);
    fs = reset_fs;
    fl = reset_fl;
  }

  var reducesize;
  if ($(window).width() > 991) {
    reducesize = 100;
  } else {
    reducesize = 50;
  }

  for (var i = fs; i >= 9; i--) {
    var tparent = $text_show.parent();
    var containerMetrics = tparent[0].getBoundingClientRect();
    var containerMetricsRight = Math.floor(containerMetrics.right) - reducesize;
    var contentMetrics = $text_show[0].getBoundingClientRect();
    var contentMetricsRight = Math.floor(contentMetrics.right);

    var containerMetricsBottom =
      Math.floor(containerMetrics.bottom) - reducesize;
    var contentMetricsBottom = Math.floor(contentMetrics.bottom);

    // console.log(containerMetrics);
    // console.log("Metrics");
    // console.log(containerMetricsRight);

    if (
      contentMetricsRight + 20 > containerMetricsRight ||
      contentMetricsBottom + 120 > containerMetricsBottom
    ) {
      fs--;
      fl = (fs * reset_fl) / reset_fs;
      /* if(fs < 20){fs = 90;}*/
      if (fl < 1) {
        fl = 1;
      }
      $(".text_show").css("font-size", fs + "px");

      $("#text").attr("data-lineh", fl);
    } else {
      break;
    }
  }

  if (resize) {
    for (var i = fs; i <= reset_fs; i++) {
      var tparent = $text_show.parent();
      var containerMetrics = tparent[0].getBoundingClientRect();
      var containerMetricsRight = Math.floor(containerMetrics.right);
      var contentMetrics = $text_show[0].getBoundingClientRect();
      var contentMetricsRight = Math.floor(contentMetrics.right);

      var containerMetricsBottom =
        Math.floor(containerMetrics.bottom) - reducesize;
      var contentMetricsBottom = Math.floor(contentMetrics.bottom);

      if (
        contentMetricsRight < containerMetricsRight ||
        contentMetricsBottom + 120 > containerMetricsBottom
      ) {
        fs++;
        fl = (fs * reset_fl) / reset_fs;
        /*if(fs < 20){fs = 90;}
                            if(fl < 1){fl = 1.5;} */
        $(".text_show").css("font-size", fs + "px");
        // $(".text_show, #text").css("line-height", fl);
        $("#text").attr("data-lineh", fl);
      } else {
        break;
      }
    }
  }
}

$(document).ready(function () {
  winwidth = $(window).width();
  if (document.location.pathname == "/pages/custom-neon-signs") {
    // $(".font_style li")[0].click();
    $(".font_style li:eq(0)").addClass("active");
    $("#color_table li:eq(0) p").addClass("active");
    $(".custom-select-power select").chosen({
      disable_search: true,
    });
$(".custom-select-mount select").chosen({
      disable_search: true,
    });
    
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
});
// $(window).on("resize", function () {
//   if (winwidth != $(window).width()) {
//     fontAdjustcall(true);
//     winwidth = $(window).width();
//     initDraggable(winwidth);
//     CanvasUtils.calculateDimensions(true, 500);
//   }
// });

function swithchtap(box, tab) {
  $(".option_group_custom .form-group.active").removeClass("active");
  $(".option_group_custom ." + box).addClass("active");
  $(".custom_tab li.active").removeClass("active");
  $(tab).closest("li").addClass("active");
}

function setClickEvents() {
  $(".size-box")
    .not(".disabled")
    .on("click", function () {
      const sizeboxdata = $(this).attr("data-size");
      switch (sizeboxdata) {
        case "xs":
          $(".text_show").css("transform", "scale(1)");
          break;
        case "s":
          $(".text_show").css("transform", "scale(1.03)");
          break;
        case "m":
          $(".text_show").css("transform", "scale(1.06)");
          break;
        case "l":
          $(".text_show").css("transform", "scale(1.09)");
          break;
        case "xl":
          $(".text_show").css("transform", "scale(1.2)");
          break;
        case "super":
          $(".text_show").css("transform", "scale(1.25)");
          break;
        case "xxxl":
          $(".text_show").css("transform", "scale(1.3)");
          break;
        case "newsuper":
          $(".text_show").css("transform", "scale(1.35)");
          break;
          case "megasuper":
          $(".text_show").css("transform", "scale(1.4)");
          break;
      }
      $(".size-box.active").removeClass("active");
      $(this).addClass("active");
      var size_active = $(".size-box.active").attr("data-size");
      $(".backing-box").each(function () {
        var board_price_tmp = $(this).attr("data-" + size_active) / 100;
        if (board_price_tmp > 0) {
          $(this)
            .find(".col-xs-4")
            .text("+" + board_price_tmp);
        } else {
          $(this).find(".col-xs-4").text("FREE");
        }
        if (
          $("#board_img").attr("data-board-type") == $(this).attr("data-type")
        ) {
          if (board_price_tmp > 0) {
            $("#board_price").text("+" + board_price_tmp);
          } else {
            $("#board_price").text("FREE");
          }
        }
      });
      if (!$(this).hasClass("disabled")) {
        $("#add_to_card").removeClass("disable-cart");
        $("#add_to_card").prop("disabled", false);
      } else {
        $("#add_to_card").addClass("disable-cart");
        $("#add_to_card").prop("disabled", true);
      }
      // up_total_price();

      setNewPrice();
      var inwidth = $(".size-box.active").find(".s_size_w").html();
      var inheight = $(".size-box.active").find(".s_size_h").html();
      inwidth = inwidth.replace("Width: ", "");
      inwidth = inwidth.replace("cm", "");
      inwidth = inwidth.replace("IN", "");
      inheight = inheight.replace("Height: ", "");
      inheight = inheight.replace("cm", "");
      inheight = inheight.replace("IN", "");

      if (inwidth != 0 && inheight != 0) {
        $(".main_width").show();
        $(".main_height").show();
        $(".main_width .width_text").text(inwidth + (isUSMarket() ? "IN" : "cm"));
        $(".height_text").text(inheight + (isUSMarket() ? "IN" : "cm"));
      } else {
        $(".main_width").hide();
        $(".main_height").hide();
      }
      // saveValueImg();
    });
  $(".backing-box").on("click", function () {
    $("#board_img").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0267/5638/2908/files/neon" +
        $(this).attr("data-type") +
        ".jpg"
    );
    $("#board_img").attr("data-board-type", $(this).attr("data-type"));
    $("#board_img").attr("data-des", $(this).find(".col-xs-8").text());
    if ($(this).attr("data-type") == "5") {
      $("#board_5").css("display", "inline");
    } else {
      $("#board_5").css("display", "none");
    }
    var size_active = $(".size-box.active").attr("data-size");
    var board_price_tmp = $(this).attr("data-" + size_active) / 100;
    if (board_price_tmp > 0) {
      $("#board_price").text("+" + board_price_tmp);
    } else {
      $("#board_price").text("FREE");
    }
    // up_total_price();

    setNewPrice();
    var inwidth = $(".size-box.active").find(".s_size_w").html();
    var inheight = $(".size-box.active").find(".s_size_h").html();
    inwidth = inwidth.replace("Width: ", "");
    inwidth = inwidth.replace("cm", "");
    inwidth = inwidth.replace("IN", "");
    inheight = inheight.replace("Height: ", "");
    inheight = inheight.replace("cm", "");
    inheight = inheight.replace("IN", "");

    if (inwidth != 0 && inheight != 0) {
      $(".main_width").show();
      $(".main_height").show();
      $(".main_width .width_text").text(inwidth + (isUSMarket() ? "IN" : "cm"));
      $(".height_text").text(inheight + (isUSMarket() ? "IN" : "cm"));
    } else {
      $(".main_width").hide();
      $(".main_height").hide();
    }
  });
  $(".plug-box").on("click", function () {
    $("#ele_plug").text($(this).text());
    var inwidth = $(".size-box.active").find(".s_size_w").html();
    var inheight = $(".size-box.active").find(".s_size_h").html();
    inwidth = inwidth.replace("Width: ", "");
    inwidth = inwidth.replace("cm", "");
    inwidth = inwidth.replace("IN", "");
    inheight = inheight.replace("Height: ", "");
    inheight = inheight.replace("cm", "");
    inheight = inheight.replace("IN", "");

    if (inwidth != 0 && inheight != 0) {
      $(".main_width").show();
      $(".main_height").show();
      $(".main_width .width_text").text(inwidth + (isUSMarket() ? "IN" : "cm"));
      $(".height_text").text(inheight + (isUSMarket() ? "IN" : "cm"));
    } else {
      $(".main_width").hide();
      $(".main_height").hide();
    }
  });
}

$(document).ready(function () {
  $(".charlimitmessage").hide();
});

function closeMessage() {
  $(".message_wrapper").removeClass("show");
  $("#message-back").removeClass("loading");
  $(".charlimitmessage").hide();
}

function showLoading() {
  $("#progress").removeClass("active");
  $(".process_wrapper").addClass("show");
}

function closeLoading() {
  $(".process_wrapper").removeClass("show");
}

$(".custom-radio  .custom-control-label").on("click", function () {
  $(".custom-radio  .custom-control-label").removeClass("active");
  $(this).addClass("active");
  setNewPrice();
  var inwidth = $(".size-box.active").find(".s_size_w").html();
  var inheight = $(".size-box.active").find(".s_size_h").html();
  inwidth = inwidth.replace("Width: ", "");
  inwidth = inwidth.replace("cm", "");
  inwidth = inwidth.replace("IN", "");
  inheight = inheight.replace("Height: ", "");
  inheight = inheight.replace("cm", "");
  inheight = inheight.replace("IN", "");

  if (inwidth != 0 && inheight != 0) {
    $(".main_width").show();
    $(".main_height").show();
    $(".main_width .width_text").text(inwidth + (isUSMarket() ? "IN" : "cm"));
    $(".height_text").text(inheight + (isUSMarket() ? "IN" : "cm"));
  } else {
    $(".main_width").hide();
    $(".main_height").hide();
  }
});

$(".otheroptions  .custom-control-label input").on("click", function () {
  if ($(this).attr("checked") == "checked") {
    $(this).attr("checked", false);
    // console.log("Ran");
  } else {
    $(this).attr("checked", true);
    // console.log("Again?");
  }
  // console.log("added class");
});

$(".backing-box").on("click", function () {
  $(".backing-box input").attr("checked", false);
  $(this).find("input").attr("checked", true);
  setNewPrice();
  var inwidth = $(".size-box.active").find(".s_size_w").html();
  var inheight = $(".size-box.active").find(".s_size_h").html();
  inwidth = inwidth.replace("Width: ", "");
  inwidth = inwidth.replace("cm", "");
  inwidth = inwidth.replace("IN", "");
  inheight = inheight.replace("Height: ", "");
  inheight = inheight.replace("cm", "");
  inheight = inheight.replace("IN", "");

  if (inwidth != 0 && inheight != 0) {
    $(".main_width").show();
    $(".main_height").show();
    $(".main_width .width_text").text(inwidth + (isUSMarket() ? "IN" : "cm"));
    $(".height_text").text(inheight + (isUSMarket() ? "IN" : "cm"));
  } else {
    $(".main_width").hide();
    $(".main_height").hide();
  }
});


$('.custom-select-mount select').on('change', function() {
  getNewPrice();
});

$(".custom-select-dropdown .select-text").click(function () {
  $(".custom-select-dropdown").toggleClass("open");
  setNewPrice();
});
$(".custom-select-dropdown .dropdown-list li").click(function () {
  $(".custom-select-dropdown").removeClass("open");
  setNewPrice();
});
$(document).on("click", function (e) {
  if ($(e.target).is(".custom-select-dropdown .select-text") === false) {
    $(".custom-select-dropdown").removeClass("open");
  }
});
$(".openboardcolor").click(function () {
  $(".sidenav.boardcolor").addClass("active");
});
$(".openbackboardsidebar").click(function () {
  $(".sidenav.boardsidebar").addClass("active");
});
$(".openboardmount").click(function () {
  $(".sidenav.boardmount").addClass("active");
});

$(".opendimmer").click(function () {
  $(".sidenav.freedimmer").addClass("active");
});

$(".sidenav-close").click(function () {
  $(".sidenav").removeClass("active");
});
$(".charlimit-close").click(function () {
  $(".charlimitmessage").hide();
});
$(".backing_finish .tabs .tab-link").click(function () {
  var t = $(this).attr("data-tab");
  $(".backing_finish .tabs .tab-link").removeClass("current");
  $(".backing_finish .tab-content-around .tab-content").removeClass("current");
  $(this).addClass("current");
  $(".backing_finish #" + t).addClass("current");
});

$(".backing_cut .tabs .tab-link").click(function () {
  var t = $(this).attr("data-tab");
  $(".backing_cut .tabs .tab-link").removeClass("current");
  $(".backing_cut .tab-content-around .tab-content").removeClass("current");
  $(this).addClass("current");
  $(".backing_cut #" + t).addClass("current");
});

$(".backing_mount .tabs .tab-link").click(function () {
  var t = $(this).attr("data-tab");
  $(".backing_mount .tabs .tab-link").removeClass("current");
  $(".backing_mount .tab-content-around .tab-content").removeClass("current");
  $(this).addClass("current");
  $(".backing_mount #" + t).addClass("current");
});

$.fn.spectrum = function (arrayOfColors) {
  return this.each(function () {
    var self = $(this);
    (function spectrum() {
      var hue = arrayOfColors.shift();
      arrayOfColors.push(hue);
      self.animate({ color: hue }, 500, spectrum);
    })();
  });
};

function randomHues(n) {
  var res = [];
  for (var i = 0; i < n; i++)
    res.push(
      "rgb(" +
        Math.floor(Math.random() * 256) +
        "," +
        Math.floor(Math.random() * 256) +
        "," +
        Math.floor(Math.random() * 256) +
        ")"
    );
  return res;
}
var hues = randomHues(100);
var intervalSetID;
$(function () {
  $(".rgb-option .fal").spectrum(hues);
});

var colors = randomHues(100);
var currentIndex = 0;

function cycleColors() {
  $(".text_show").css(
    "text-shadow",
    colors[currentIndex] +
      " 0px 0px 5px, " +
      colors[currentIndex] +
      " 0px 0px 10px, " +
      colors[currentIndex] +
      " 0px 0px 20px, " +
      colors[currentIndex] +
      " 0px 0px 30px, " +
      colors[currentIndex] +
      " 0px 0px 40px, " +
      colors[currentIndex] +
      " 0px 0px 55px, " +
      colors[currentIndex] +
      " 0px 0px 75px"
  );
  currentIndex++;
  if (currentIndex >= colors.length) {
    currentIndex = 0;
  }
}

function setcycle() {
  if (intervalSetID) {
    clearInterval(intervalSetID);
    intervalSetID = "";
  } else if ($(".rgb-option .label-wrap.active").length > 0) {
    intervalSetID = setInterval(cycleColors, 1000);
  }
}
